export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A blob of JSON. */
  JSON: any;
  /** A string containing HTML. (Deprecated: use an HTMLAST field, or normalize the API instead.) */
  DeprecatedHTML: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  UTCDateTime: any;
  /** An object containing an abstract syntax tree representing arbitrary HTML. */
  HTMLAST: any;
  ServiceOrderByField: any;
  ServiceOrderDirectionField: any;
};

export type Query = {
  __typename?: 'Query';
  /**
   * This empty query can be ignored. It's only used to make sure we never have a non-empty Query type.
   * This way, all structures can use the "extend Query" syntax.
   */
  _?: Maybe<Scalars['String']>;
  /** Returns a list of the AB tests currently used on Zapier.com */
  abTests: Array<AbTest>;
  account: Account;
  accounts: Array<Account>;
  activities: Activities;
  /** @deprecated Use Query.appBySlug instead. */
  app?: Maybe<App>;
  appByCurrentImplementationId?: Maybe<AppV2>;
  appBySlug?: Maybe<AppV2>;
  appCategories: AppCategoryConnection;
  appCategory: AppV2Category;
  appImplementationById?: Maybe<AppImplementation>;
  appImplementationMetaById: AppImplementationMeta;
  appImplementationMetasByIds: Array<AppImplementationMeta>;
  appImplementationsByIds: Array<AppImplementation>;
  /** Gets an application by its slug. */
  applicationBySlug?: Maybe<Application>;
  /**
   * This method is deprecated. Please use the appBySlug.media field instead.
   * @deprecated Use appBySlug.media instead
   */
  appMedia: Array<Maybe<AppMedia>>;
  /**
   * This method is deprecated. Please use the appBySlug.pricingPlans field instead.
   * @deprecated Use appBySlug.pricingPlans instead.
   */
  appPricingPlans: Array<AppPricingPlan>;
  /**
   * Returns App Recommendations given a role id. At the moment, this is used to give users a preview of apps
   * during onboarding.
   */
  appRecommendationsByRole: Array<AppRecommendation>;
  /** @deprecated The App type is deprecated. Use an AppV2 query instead. */
  apps?: Maybe<Array<Maybe<App>>>;
  appsByCurrentImplementationId: Array<AppV2>;
  appsBySlug: Array<AppV2>;
  /** Return an authentication by id */
  authentication?: Maybe<AuthenticationV2>;
  /** @deprecated Use Query.authenticationsV2 instead. */
  authentications?: Maybe<Array<Maybe<Authentication>>>;
  /** Returns a list of authentications filtered by their ids */
  authenticationsById: AuthenticationV2Connection;
  /** Returns a list of all authentications that are available for the current user, either through ownership or sharing via team accounts. */
  authenticationsV2: AuthenticationV2Connection;
  /** Creates a bandit recommendation for current user for a given experiment. */
  banditRecommendation: BanditRecommendation;
  /** Gets all bandit recommendations generated for current user. */
  banditRecommendations: Array<BanditRecommendation>;
  /** @deprecated Use blogPostsV2 instead. */
  blogPosts?: Maybe<Array<Maybe<BlogPost>>>;
  /**
   * Returns blog posts ordered by published date. This will deprecate the blogPosts graphene endpoint eventually.
   *
   * categorySlug can also be negative, ex. "-app-tutorial" will give us everything that is NOT an app tutorial.
   */
  blogPostsV2: BlogPostConnection;
  /** Returns a single blog post. */
  blogPostV2: BlogPostV2;
  /** Returns the list of currencies we support on Zapier.com. */
  currencies: Array<Currency>;
  currentUser?: Maybe<User>;
  /** Returns the currently logged in user, or `null` if unauthenticated. */
  currentUserV2?: Maybe<UserV2>;
  /**
   * Returns a status code of the specified code. The specified code must
   * exist in the DRF status code list: https://www.django-rest-framework.org/api-guide/status-codes/
   */
  debugResponse: DebugResponse;
  domainMembers?: Maybe<DomainMembers>;
  domains: Array<Domain>;
  /**
   * Wraps the 'popular-zaps' endpoint to recommend Zap Templates based on apps
   * a user selects.
   */
  exploreZapTemplates?: Maybe<Array<ZapTemplateV2>>;
  /** Finds which accountId a folder belongs to (if user has access) */
  folderDiscovery: FolderDiscovery;
  /**
   * Returns forever session data for a logged in or logged out user. Forever
   * session data persists even after the user's session has expired.
   */
  foreverSession?: Maybe<ForeverSession>;
  /**
   * Retrieves the user's geolocation + currency based on that location.
   * Note: a countryCode can be provided that will take precedence over looking up the countryCode from headers.
   */
  geolocatedCurrency: GeolocatedCurrency;
  getAppsByCategory: AppsConnection;
  getAppsByNameContains: AppsConnection;
  getAppStats: Array<AppStats>;
  getDistinctAppsWithAuths: AppsConnection;
  /** Get all expert relationships for a given users's client_account_id */
  getExpertRelationships: Array<ExpertRelationship>;
  getPrivateAppsByNameContains: AppsConnection;
  /** Returns an enabled shared zap for a given shared zap ID. */
  getSharedZap: SharedZap;
  /** Returns a shared zap from a given zap - if the user has permission to see that zap. */
  getSharedZapByNodeId: SharedZap;
  /** Look up a consistent key. */
  hasConsistentKey: Scalars['Boolean'];
  /** Returns all (generic) content for an app. */
  helpDocs_getAppContent: HelpDocs_GenericsConnection;
  /** Returns the troubleshooting (currently actually generics) that match the provided arguments, with the best match sorted first */
  helpDocs_getBestTroubleshooting: Array<HelpDocs_Generic>;
  /**
   * Returns the tutorial that is the best match for the provided arguments.
   * @deprecated Use helpDocs_getBestTutorials instead
   */
  helpDocs_getBestTutorial?: Maybe<HelpDocs_Tutorial>;
  /** Returns the tutorials that match the provided arguments, with the best match sorted first */
  helpDocs_getBestTutorials: Array<HelpDocs_Tutorial>;
  /** Returns a tree of categories, starting with a list of root categories. */
  helpDocs_getCategoriesTree: Array<HelpDocs_Category>;
  /** Returns a category by numeric ID or slug */
  helpDocs_getCategory?: Maybe<HelpDocs_Category>;
  /** Returns all content under a (sub)category, with optional types filter. */
  helpDocs_getCategoryContent: Array<HelpDocs_ContentLink>;
  /** Returns (any type of) content by slug. */
  helpDocs_getContent?: Maybe<HelpDocs_Content>;
  /** Returns all faq content, with optional category filter. */
  helpDocs_getFaqs: HelpDocs_FaqsConnection;
  identityProvider: IdentityProvider;
  identityProviders: Array<IdentityProvider>;
  /** A single review for an integration. Filters by ID of the integration. */
  integrationReview?: Maybe<IntegrationReview>;
  /** A single review feedback item. */
  integrationReviewFeedbackItem?: Maybe<IntegrationReviewFeedbackItem>;
  /** Fetches all feedback snippets. */
  integrationReviewFeedbackSnippets: Array<
    Maybe<IntegrationReviewFeedbackSnippet>
  >;
  /** Fetches all reviews from bouncer. */
  integrationReviews: Array<Maybe<IntegrationReview>>;
  /** Get user by ID. */
  internal_getUser?: Maybe<Internal_User>;
  /** Get all users, optionally filter by email which may or may not include aliases. */
  internal_getUsers: Internal_UsersConnection;
  invitation: Invitation;
  invitationByCode: Invitation;
  invitations: Array<Invitation>;
  /** @deprecated Use isAuthenticatedV2 instead. */
  isAuthenticated?: Maybe<Scalars['Boolean']>;
  /** Returns `true` if the user is logged in to Zapier, `false` if not. */
  isAuthenticatedV2: Scalars['Boolean'];
  /** @deprecated Use PlatformIntegration.issue instead */
  issue?: Maybe<AppIssue>;
  /** @deprecated Use PlatformIntegration.issues instead */
  issues?: Maybe<Array<AppIssue>>;
  /** True if the Test Case Simulator is enabled on this environment. */
  isTestCaseSimulatorEnabled: Scalars['Boolean'];
  joinableAccounts: Array<JoinableAccount>;
  /** Returns the list pre-defined logo options */
  logoOptions: Array<Scalars['String']>;
  /**
   * Get a list of members on an account of an (optional) given status
   * @deprecated use account.members instead
   */
  members: Array<Member>;
  metaServiceUpdates?: Maybe<Array<Maybe<MetaServiceUpdate>>>;
  /**
   * Get the plan that is one plan higher than the account's current plan.
   * For example, given the plans Starter 750 and Starter 1500, if the account
   * is currently on the Starter 750 plan, this query would return the Starter
   * 1500 plan.
   * @deprecated use nextPlanV2 instead
   */
  nextPlan?: Maybe<Plan>;
  /**
   * Get the next plan up from the account's current plan based on plan type and Task usage.
   * For example, if the account has used 800 Tasks, this query would return the Starter
   * 1500 plan.
   */
  nextPlanV2?: Maybe<PlanV2>;
  /**
   * This represents the list of applications that a user has granted access to
   * their personal Zapier account, as well as the scopes of access granted.
   */
  oauths: Array<OAuth>;
  onboarding?: Maybe<Onboarding>;
  /** @deprecated Use Query.pairDetailsV2 instead. */
  pairDetails?: Maybe<PairDescription>;
  pairDetailsV2?: Maybe<PairDescriptionV2>;
  /** A single partner's integration. */
  partner?: Maybe<Partner>;
  /**
   * Partner's profile.
   * Will get info about its memberships and roles
   */
  partnerProfile: PartnerProfile;
  partnerStatus?: Maybe<PartnerStatus>;
  /** Returns a list of persisted modals for this user. */
  persistedModals: Array<PersistedModal>;
  /** Get the specific plan from the user's current plan group by plan name and interval. */
  planById?: Maybe<PlanV2>;
  /** Get the specific plan from the user's current plan group by plan name and interval. */
  planByName?: Maybe<PlanV2>;
  platformDeployKeys: Array<Maybe<PlatformDeployKey>>;
  platformIntegration?: Maybe<PlatformIntegration>;
  platformIntegrationDetails?: Maybe<PlatformIntegrationDetails>;
  platformIntegrations: Array<Maybe<PlatformIntegration>>;
  /** Returns a paginated list of Policies (scoped to the current User, if auth'd) */
  policies: Policies;
  /** Return a the last published policy by slug. */
  policy: Policy;
  /**
   * Get plans for the account in a format to display on pricing page v3 (plans with task variants).
   * If no accountId is specified, returns the plans for the default plan group.
   *
   * Note that variant and identity are no longer used, and will be removed.
   */
  pricingPageV3Plans: Array<PlanTaskGrouping>;
  /**
   * Get promotional plans that the currently authenticated user is eligible for. For example, if the user
   * has an offer (accepted or not) in Campaign A, and Campaign A's promotional plan group field is set to
   * Plan Group A, and Plan Group A contains Plan A and Plan B, this function would return [ PlanA, PlanB ]
   * for this user.
   */
  promoPlans: Array<PlanV2>;
  provision?: Maybe<Provision>;
  /** Returns only public press articles ordered by the order field */
  publicPressArticles: Array<PressArticle>;
  /** Returns a random user testimonial. Only featured testimonials will be returned. */
  randomUserTestimonial: UserTestimonial;
  /** Random zap template */
  randomZapTemplateSuggestions: Array<SuggestedZapTemplate>;
  /** @deprecated Use AppV2.reviewPage instead. */
  reviewPage?: Maybe<ReviewPage>;
  /** Find a RecommendationProfileRole by id. */
  roleById?: Maybe<RecommendationProfileRole>;
  /** Find a RecommendationProfileRole by its slug. */
  roleBySlug?: Maybe<RecommendationProfileRole>;
  /**
   * Returns the list of existing RecommendationProfileRoles.
   * @deprecated Use rolesV2 instead.
   */
  roles: Array<RecommendationProfileRole>;
  /** Returns the list of existing from the Roles V4 endpoint. */
  rolesV2: RolesConnection;
  /** Search for members on an account for a given search term */
  searchMembers?: Maybe<TeamMembers>;
  /** Search for Members / Teams on an account for a given search term */
  searchShare: Array<ShareResult>;
  /** Returns SEOData for a given path, if it exists. */
  seoData?: Maybe<SeoData>;
  /** @deprecated The concept of a Service will be removed from the GraphQL schema soon. You should rely on queries that return an App or AppImplementation type instead, depending on your use-case. See this Quip doc for more information: https://zapier.quip.com/3fUhAOmL2Sy5/New-AppImplementationIntegration-Schema-Scenarios. */
  service?: Maybe<Service>;
  /** Look up a single service by slug. */
  serviceBySlug?: Maybe<ServiceOne>;
  /** @deprecated The concept of a Service will be removed from the GraphQL schema soon. You should rely on queries that return App or AppImplementation types instead, depending on your use-case. See this Quip doc for more information: https://zapier.quip.com/3fUhAOmL2Sy5/New-AppImplementationIntegration-Schema-Scenarios. */
  services?: Maybe<Array<Maybe<Service>>>;
  /** Look up services by name. */
  servicesByNameContains?: Maybe<ServicesByNameContainsOutput>;
  /** Returns session data for a logged in or logged out user. */
  session: Session;
  /** Returns a list of Subscriptions */
  subscriptions: Array<Subscription>;
  suggestedUseCases: SuggestedUseCaseConnection;
  suggestedZapTemplates: SuggestedZapTemplateConnection;
  /**
   * If task was held due to an app this will return that App that is
   * causing it to be held
   */
  taskHeldApp?: Maybe<AppV2>;
  /** A list of timezones for a user to configure as their preference */
  timezones: Array<Timezone>;
  twoFactorAuth: TwoFactorAuth;
  twoFactorAuths: Array<TwoFactorAuth>;
  /** Returns a single Use Case for the given slug */
  useCaseBySlug?: Maybe<UseCase>;
  /** Returns a paginated list of Use Cases */
  useCases: UseCases;
  /** Check the status of user data deletion */
  userDataDeleteStatus: UserJobStatus;
  /** Check the status of user data export */
  userDataExportStatus: UserJobStatus;
  /** Returns service IDs for apps that were selected during the onboarding process. */
  userFollowedApps: Array<FollowedApp>;
  /** Returns a list of UserSkillLevel actions available for the current user. */
  userSkillLevelActions: Array<UserSkillLevelAction>;
  /** @deprecated The Testimonial type is deprecated. Use a query that returns an UserTestimonial type instead, like Query.randomUserTestimonial. */
  userTestimonials?: Maybe<Array<Maybe<Testimonial>>>;
  zap?: Maybe<Zap>;
  zapRunStatus: ZapRunStatus;
  zaps?: Maybe<Array<Maybe<Zap>>>;
  zapsByAuthIds: Array<ZapV2>;
  /** Returns a list of zaps that will be paused if the account changes to the given plan ID */
  zapsToBePaused: Array<ZapV2>;
  zapsV2: Array<ZapV2>;
  zapsV3?: Maybe<Zaps>;
  /** @deprecated Use Query.zapTemplateById instead. */
  zapTemplate?: Maybe<ZapTemplate>;
  zapTemplateById?: Maybe<ZapTemplateV2>;
  /** @deprecated Use Query.zapTemplatesConnectionV2 instead. */
  zapTemplates?: Maybe<Array<Maybe<ZapTemplate>>>;
  /** @deprecated Use Query.zapTemplatesConnectionV2 instead. */
  zapTemplatesConnection?: Maybe<ZapTemplatePaginatedList>;
  /**
   * Returns a (cursor-based) paginated list of published Zap Templates.
   * Only returns published ZTs by default. See the 'shouldIncludeUnpublished' parameter if you want unpublished ZTs too.
   */
  zapTemplatesConnectionV2: ZapTemplatesConnectionV2;
  zapV2?: Maybe<ZapV2>;
};

export type QueryAccountArgs = {
  id: Scalars['Int'];
};

export type QueryActivitiesArgs = {
  accountId: Scalars['ID'];
  action?: InputMaybe<Array<Scalars['String']>>;
  date?: InputMaybe<DateRangeType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['ID']>;
  zapId?: InputMaybe<Scalars['ID']>;
};

export type QueryAppArgs = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type QueryAppByCurrentImplementationIdArgs = {
  id: Scalars['ID'];
};

export type QueryAppBySlugArgs = {
  slug: Scalars['String'];
};

export type QueryAppCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<AppCategoryRole>;
};

export type QueryAppCategoryArgs = {
  slug: Scalars['String'];
};

export type QueryAppImplementationByIdArgs = {
  id: Scalars['ID'];
};

export type QueryAppImplementationMetaByIdArgs = {
  id: Scalars['ID'];
};

export type QueryAppImplementationMetasByIdsArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryAppImplementationsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryApplicationBySlugArgs = {
  slug: Scalars['String'];
};

export type QueryAppMediaArgs = {
  appSlug: Scalars['String'];
};

export type QueryAppPricingPlansArgs = {
  appSlug: Scalars['String'];
};

export type QueryAppRecommendationsByRoleArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: Scalars['Int'];
  roleId: Scalars['ID'];
  titleContains?: InputMaybe<Scalars['String']>;
};

export type QueryAppsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isSelected?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  nameContains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryAppsByCurrentImplementationIdArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryAppsBySlugArgs = {
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryAuthenticationArgs = {
  id: Scalars['ID'];
};

export type QueryAuthenticationsArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  selectedApis?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryAuthenticationsByIdArgs = {
  ids: Array<Scalars['ID']>;
};

export type QueryAuthenticationsV2Args = {
  accountId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  myAuths?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  selectedApi?: InputMaybe<Scalars['String']>;
  serviceSlug?: InputMaybe<Scalars['String']>;
};

export type QueryBanditRecommendationArgs = {
  count?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  options: Array<InputMaybe<Scalars['String']>>;
};

export type QueryBlogPostsArgs = {
  categorySlug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  serviceSlug?: InputMaybe<Scalars['String']>;
};

export type QueryBlogPostsV2Args = {
  blogSlug?: InputMaybe<Scalars['String']>;
  categorySlug?: InputMaybe<Scalars['String']>;
  categorySlugs?: InputMaybe<Array<Scalars['String']>>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  serviceSlug?: InputMaybe<Scalars['String']>;
};

export type QueryBlogPostV2Args = {
  slug: Scalars['String'];
};

export type QueryDebugResponseArgs = {
  code: Scalars['Int'];
  method?: InputMaybe<HttpMethod>;
};

export type QueryDomainMembersArgs = {
  accountId: Scalars['Int'];
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isCompanyMember?: InputMaybe<Scalars['Boolean']>;
  isEmailConfirmed?: InputMaybe<Scalars['Boolean']>;
  isMfaEnabled?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryDomainsArgs = {
  accountId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
};

export type QueryExploreZapTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  serviceIds?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryFolderDiscoveryArgs = {
  folderId: Scalars['ID'];
};

export type QueryGeolocatedCurrencyArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
};

export type QueryGetAppsByCategoryArgs = {
  categorySlug: Scalars['String'];
  excludeUpcoming?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AppSortOrder>;
};

export type QueryGetAppsByNameContainsArgs = {
  excludeUpcoming?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  nameContains: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AppSortOrder>;
};

export type QueryGetAppStatsArgs = {
  accountId: Scalars['ID'];
  selectedApis: Array<Scalars['String']>;
};

export type QueryGetDistinctAppsWithAuthsArgs = {
  accountId: Scalars['ID'];
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  isShared?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  owner?: InputMaybe<Scalars['ID']>;
  selectedApis?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type QueryGetExpertRelationshipsArgs = {
  id: Scalars['ID'];
};

export type QueryGetPrivateAppsByNameContainsArgs = {
  accountId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nameContains: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  selectedApis?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetSharedZapArgs = {
  sharedZapId?: InputMaybe<Scalars['ID']>;
};

export type QueryGetSharedZapByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

export type QueryHasConsistentKeyArgs = {
  key: Scalars['String'];
};

export type QueryHelpDocs_GetAppContentArgs = {
  app?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryHelpDocs_GetBestTroubleshootingArgs = {
  actionType?: InputMaybe<HelpDocs_ActionType>;
  app?: InputMaybe<Scalars['String']>;
  appAction?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  relatedCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryHelpDocs_GetBestTutorialArgs = {
  actionType?: InputMaybe<HelpDocs_ActionType>;
  app?: InputMaybe<Scalars['String']>;
  appAction?: InputMaybe<Scalars['String']>;
};

export type QueryHelpDocs_GetBestTutorialsArgs = {
  actionType?: InputMaybe<HelpDocs_ActionType>;
  app?: InputMaybe<Scalars['String']>;
  appAction?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type QueryHelpDocs_GetCategoryArgs = {
  id: Scalars['ID'];
};

export type QueryHelpDocs_GetCategoryContentArgs = {
  id: Scalars['ID'];
  types?: InputMaybe<Array<HelpDocs_ContentType>>;
};

export type QueryHelpDocs_GetContentArgs = {
  namespace?: InputMaybe<HelpDocs_Namespace>;
  slug: Scalars['String'];
};

export type QueryHelpDocs_GetFaqsArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  home?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryIdentityProviderArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type QueryIdentityProvidersArgs = {
  accountId: Scalars['Int'];
};

export type QueryIntegrationReviewArgs = {
  id?: InputMaybe<Scalars['ID']>;
  integrationId?: InputMaybe<Scalars['ID']>;
};

export type QueryIntegrationReviewFeedbackItemArgs = {
  id: Scalars['ID'];
};

export type QueryIntegrationReviewFeedbackSnippetsArgs = {
  type?: InputMaybe<IntegrationReviewFeedbackItemType>;
};

export type QueryIntegrationReviewsArgs = {
  status?: InputMaybe<IntegrationReviewStatus>;
};

export type QueryInternal_GetUserArgs = {
  id: Scalars['ID'];
};

export type QueryInternal_GetUsersArgs = {
  email?: InputMaybe<Scalars['String']>;
  include_aliases?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryInvitationArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type QueryInvitationByCodeArgs = {
  code: Scalars['String'];
};

export type QueryInvitationsArgs = {
  accountId: Scalars['Int'];
};

export type QueryIssueArgs = {
  appId: Scalars['ID'];
  issueId: Scalars['Int'];
};

export type QueryIssuesArgs = {
  appId: Scalars['ID'];
};

export type QueryMembersArgs = {
  accountId: Scalars['Int'];
  status?: InputMaybe<MemberStatus>;
};

export type QueryMetaServiceUpdatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  serviceSlug: Scalars['String'];
};

export type QueryNextPlanArgs = {
  accountId: Scalars['Int'];
  currentPlanId: Scalars['Int'];
};

export type QueryNextPlanV2Args = {
  accountId: Scalars['Int'];
  interval?: InputMaybe<BillingInterval>;
  type?: InputMaybe<Scalars['String']>;
};

export type QueryPairDetailsArgs = {
  primaryServiceSlug: Scalars['String'];
  secondaryServiceSlug: Scalars['String'];
};

export type QueryPairDetailsV2Args = {
  primaryServiceSlug: Scalars['String'];
  secondaryServiceSlug: Scalars['String'];
};

export type QueryPartnerArgs = {
  serviceId: Scalars['Int'];
};

export type QueryPartnerProfileArgs = {
  secret?: InputMaybe<Scalars['String']>;
};

export type QueryPartnerStatusArgs = {
  serviceId: Scalars['Int'];
};

export type QueryPlanByIdArgs = {
  accountId: Scalars['ID'];
  planId: Scalars['ID'];
};

export type QueryPlanByNameArgs = {
  accountId: Scalars['ID'];
  interval: BillingInterval;
  name: Scalars['String'];
};

export type QueryPlatformDeployKeysArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
};

export type QueryPlatformIntegrationArgs = {
  id: Scalars['ID'];
};

export type QueryPlatformIntegrationDetailsArgs = {
  id: Scalars['ID'];
};

export type QueryPlatformIntegrationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type QueryPoliciesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
};

export type QueryPolicyArgs = {
  slug: Scalars['String'];
};

export type QueryPricingPageV3PlansArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  identity?: InputMaybe<Scalars['ID']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type QueryProvisionArgs = {
  accountId: Scalars['Int'];
};

export type QueryPublicPressArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type QueryRandomZapTemplateSuggestionsArgs = {
  appCanonicalIds?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type QueryReviewPageArgs = {
  serviceSlug?: InputMaybe<Scalars['String']>;
};

export type QueryRoleByIdArgs = {
  id: Scalars['ID'];
};

export type QueryRoleBySlugArgs = {
  slug: Scalars['String'];
};

export type QueryRolesV2Args = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QuerySearchMembersArgs = {
  accountId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type QuerySearchShareArgs = {
  accountId: Scalars['Int'];
  excludeTeams?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type QuerySeoDataArgs = {
  path: Scalars['String'];
};

export type QueryServiceArgs = {
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type QueryServiceBySlugArgs = {
  slug: Scalars['String'];
};

export type QueryServicesArgs = {
  categorySlug?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isPremium?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  nameContains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['ServiceOrderByField']>;
  orderDirection?: InputMaybe<Scalars['ServiceOrderDirectionField']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryServicesByNameContainsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
};

export type QuerySuggestedUseCasesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type QuerySuggestedZapTemplatesArgs = {
  appCanonicalIds?: InputMaybe<Array<Scalars['String']>>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  personalizeBy: SuggestionPersonalization;
  priorityAppCanonicalIds?: InputMaybe<Array<Scalars['String']>>;
  roleCanonicalId?: InputMaybe<Scalars['String']>;
};

export type QueryTaskHeldAppArgs = {
  id: Scalars['ID'];
};

export type QueryTwoFactorAuthArgs = {
  code: Scalars['String'];
  id: Scalars['ID'];
};

export type QueryUseCaseBySlugArgs = {
  slug: Scalars['String'];
};

export type QueryUseCasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['ID']>;
};

export type QueryUserDataDeleteStatusArgs = {
  id: Scalars['ID'];
};

export type QueryUserDataExportStatusArgs = {
  id: Scalars['ID'];
};

export type QueryUserTestimonialsArgs = {
  featured?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  random?: InputMaybe<Scalars['Boolean']>;
};

export type QueryZapArgs = {
  id?: InputMaybe<Scalars['Int']>;
};

export type QueryZapRunStatusArgs = {
  id: Scalars['ID'];
};

export type QueryZapsArgs = {
  account_id?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<Array<KindType>>;
  myZaps?: InputMaybe<Scalars['Boolean']>;
};

export type QueryZapsByAuthIdsArgs = {
  account_id?: InputMaybe<Scalars['Int']>;
  authIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  selectedApi?: InputMaybe<Scalars['String']>;
  serviceSlug?: InputMaybe<Scalars['String']>;
};

export type QueryZapsToBePausedArgs = {
  accountId: Scalars['ID'];
  planId: Scalars['ID'];
};

export type QueryZapsV2Args = {
  account_id?: InputMaybe<Scalars['Int']>;
  action?: InputMaybe<Scalars['String']>;
  authId?: InputMaybe<Scalars['ID']>;
  folderId?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Array<KindType>>;
  limit?: InputMaybe<Scalars['Int']>;
  myZaps?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ZapOrderByInput>;
  search?: InputMaybe<Scalars['String']>;
  selectedApi?: InputMaybe<Scalars['String']>;
  serviceSlug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type QueryZapsV3Args = {
  accountId?: InputMaybe<Scalars['Int']>;
  activityEnd?: InputMaybe<Scalars['String']>;
  activityStart?: InputMaybe<Scalars['String']>;
  authIds?: InputMaybe<Array<Scalars['ID']>>;
  folderIds?: InputMaybe<Array<Scalars['ID']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  kind?: InputMaybe<Array<KindType>>;
  limit?: InputMaybe<Scalars['Int']>;
  myZaps?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ZapOrderByInput>;
  search?: InputMaybe<Scalars['String']>;
  selectedApis?: InputMaybe<Array<Scalars['String']>>;
  serviceSlugs?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type QueryZapTemplateArgs = {
  id: Scalars['String'];
};

export type QueryZapTemplateByIdArgs = {
  id: Scalars['ID'];
};

export type QueryZapTemplatesArgs = {
  addedById?: InputMaybe<Scalars['String']>;
  headAction?: InputMaybe<Scalars['String']>;
  headServiceSelectedApi?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeCommunity?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  mustContainAllServices?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  serviceSlug?: InputMaybe<Scalars['String']>;
  serviceSlugOrSelectedApi?: InputMaybe<Scalars['String']>;
  serviceSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceSlugsOrSelectedApis?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  tailAction?: InputMaybe<Scalars['String']>;
  tailServiceSelectedApi?: InputMaybe<Scalars['String']>;
};

export type QueryZapTemplatesConnectionArgs = {
  addedById?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mustContainAllServices?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  serviceSlug?: InputMaybe<Scalars['String']>;
  serviceSlugOrSelectedApi?: InputMaybe<Scalars['String']>;
  serviceSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceSlugsOrSelectedApis?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
};

export type QueryZapTemplatesConnectionV2Args = {
  addedByProfileId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  minServiceCount?: InputMaybe<Scalars['Int']>;
  mustContainAllServices?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<ZapTemplatesOrderByOptions>;
  prodIds?: InputMaybe<Array<Scalars['Int']>>;
  rankingStrategy?: InputMaybe<Scalars['String']>;
  serviceKeys?: InputMaybe<Array<Scalars['String']>>;
  serviceSlugs?: InputMaybe<Array<Scalars['String']>>;
  shouldExcludeUnranked?: InputMaybe<Scalars['Boolean']>;
  shouldIncludeUnpublished?: InputMaybe<Scalars['Boolean']>;
  shouldPersonalizeResults?: InputMaybe<Scalars['Boolean']>;
};

export type QueryZapV2Args = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Represents the AB tests used on Zapier.com */
export type AbTest = {
  __typename?: 'ABTest';
  /** The ID of this AB test. */
  id: Scalars['ID'];
  /**
   * The interstate of the AB test. Used to determine if it applies to the
   * current user. Eligibility for the AB test is calculated using the formula
   * identity % interstate === 0.
   */
  interstate: Scalars['Int'];
  /** Whether or not the current user is eligible for the AB test. */
  isEligible: Scalars['Boolean'];
  /** The name of the AB test. */
  name: Scalars['String'];
  /** The variant (lane) that applies to the current user. */
  variant: Scalars['String'];
};

export type Account = {
  __typename?: 'Account';
  /** Accounts's access policy */
  accessPolicy?: Maybe<AccessPolicy>;
  /** The ID of the account's active offer, if there is one */
  activeOfferId?: Maybe<Scalars['ID']>;
  /** Allow admins to change data retention policy */
  allowDataRetentionConfig: Scalars['Boolean'];
  /** Allow Task Replay on this account */
  allowTaskReplay: Scalars['Boolean'];
  /** Gets an app restriction by id */
  appRestriction?: Maybe<AppRestriction>;
  /** List of app restrictions (denied / allowed) */
  appRestrictions?: Maybe<AppRestrictions>;
  /** Amount of app usage (users / zaps) in an account */
  appUsage?: Maybe<AppUsage>;
  /** End date for the company free trial, if it exists */
  companiesTrialEndDate?: Maybe<Scalars['String']>;
  /** The date the account's company trial ended */
  companyAccountEndDate?: Maybe<Scalars['String']>;
  /** Address of company, for invoicing purposes */
  companyAddress?: Maybe<Scalars['String']>;
  /**
   * Has the account indicated that it wants to engage with customer support?
   * True means they have indicated they opt in
   * False means they have opted out
   * Null means they haven't responded yet (so we should ask)
   */
  companyInitialEngagement?: Maybe<Scalars['Boolean']>;
  /** Name of company, for invoicing purposes. */
  companyName?: Maybe<Scalars['String']>;
  /** Currency, for billing purposes */
  currency?: Maybe<Scalars['String']>;
  /** List of rules to determine what payment methods can be used to pay in what currencies */
  currencyRuleset: Array<CurrencyRulesetItem>;
  /** Current user's role on account */
  currentUserRole: MemberRole;
  /** Date invitation was created */
  dataRetentionDays: Scalars['Int'];
  /** List of active discounts */
  discounts: Array<Discount>;
  /** A list of trial extensions the user has active */
  enabledTrialExtensions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Account entitlements */
  entitlements?: Maybe<Entitlements>;
  /** Retrieves a specific Feature Enrollment */
  featureEnrollment?: Maybe<FeatureEnrollment>;
  /** List of feature enrollment */
  featureEnrollmentList?: Maybe<Array<Maybe<FeatureEnrollment>>>;
  /** The date of the user's first account upgrade, if applicable */
  firstKnownUpgradeDate?: Maybe<Scalars['String']>;
  folder: Folder;
  folders: Array<Folder>;
  /** True if the account used to be on a company free trial */
  hasBeenInCompaniesTrial?: Maybe<Scalars['Boolean']>;
  /** True if a verified domain exists for account */
  hasVerifiedDomain: Scalars['Boolean'];
  /**
   * Held tasks rolled up by Zap
   * includeSharedWith:
   *   true: data for all Zaps user can see
   *   false: data for only owned Zaps
   */
  heldTasksAggregation: HeldTaskBannerDataResult;
  /**
   * Held tasks rolled up by the reason they were held
   * includeSharedWith:
   *   true: data for all Zaps user can see
   *   false: data for only owned Zaps
   */
  heldTasksByReason: HeldTaskByReason;
  id: Scalars['Int'];
  /** Logo image url */
  imageUrl: Scalars['String'];
  /** Email to send invoices to */
  invoiceEmail?: Maybe<Scalars['String']>;
  /**
   * Gets a preview of next period's invoice
   * (optionally switching to planId)
   */
  invoicePreview?: Maybe<Invoice>;
  /** Get a list of invoices on an account */
  invoices: Array<Invoice>;
  /** True if account has autoreplay enabled */
  isAutoReplayEnabled: Scalars['Boolean'];
  /** True if account is on a regular trial, not teams or companies */
  isChatEligible: Scalars['Boolean'];
  /** True if the account is a company account */
  isCompanyAccount: Scalars['Boolean'];
  /** True if the user's identity is controlled by an identity provider */
  isControlledByIdentityProvider: Scalars['Boolean'];
  /** True if Google domain verification is enabled for this account */
  isGoogleDomainVerificationSupported: Scalars['Boolean'];
  /** True if account is part of the experts relationship table */
  isInExpertsMvp: Scalars['Boolean'];
  /** True if the account is paying us money */
  isPaying: Scalars['Boolean'];
  /** True if SAML is required to login to account */
  isSamlRequired: Scalars['Boolean'];
  /** True if the account is a team account */
  isTeamAccount: Scalars['Boolean'];
  /** True if the account is on a free trial */
  isTrialing: Scalars['Boolean'];
  /** Is this user trialing companies features? */
  isTrialingCompanies: Scalars['Boolean'];
  /** Is this user trialing teams features? */
  isTrialingTeams: Scalars['Boolean'];
  /** Is the unlimited override on for this account */
  isUnlimited: Scalars['Boolean'];
  /** The last time a charge failed on the account */
  lastChargeFail?: Maybe<Scalars['String']>;
  /** When did the plan last change? */
  lastPlanChangeAt?: Maybe<Scalars['String']>;
  member?: Maybe<Member>;
  members?: Maybe<Members>;
  /** Account name */
  name: Scalars['String'];
  /**
   * Normalized account logo for display
   * For team accounts, it returns the account's image url
   * For personal accounts, it returns user's avatar image url
   */
  normalizedImageUrl?: Maybe<Scalars['String']>;
  /**
   * Normalized account name for display
   * For team accounts, it returns account name
   * For personal accounts, it returns user name
   */
  normalizedName: Scalars['String'];
  /** Retrieves a specific offer */
  offer?: Maybe<Offer>;
  /** Owner of the account */
  owner: AccountOwner;
  /** Get a list of payment sources on an account */
  paymentSources: Array<PaymentSource>;
  pendingMembers: Array<Member>;
  /**
   * The ID of the offer the account is eligible for, if there is one.
   * Will be undefined if the offer has expired or already been accepted.
   */
  pendingOfferId?: Maybe<Scalars['ID']>;
  /** End date for the account's billing cycle */
  periodEndDate?: Maybe<Scalars['String']>;
  /** Start date for the account's billing cycle */
  periodStartDate?: Maybe<Scalars['String']>;
  /**
   * Payment Plan Account is subscribed to
   * (use if only getting small parts of the plan that are available in the
   * accounts listing endpoint to avoid cross-realm calls otherwise use plansV2)
   */
  plan: Plan;
  /** The ID of the user's current plan group */
  planGroupId?: Maybe<Scalars['ID']>;
  /** Payment PlanV2 account is subscribed to */
  planV2: PlanV2;
  /** The planGroupId of the promotional plan the user is currently on, if any */
  promotionPlanGroupId?: Maybe<Scalars['ID']>;
  /** List of apps that are recommended for the account to use */
  recommendedApps: RecommendedApps;
  /** List of zap templates that are recommended for the account to use */
  recommendedZapTemplates: RecommendedZapTemplates;
  /** Should we email the user a copy of paid invoices? */
  sendInvoiceEmail?: Maybe<Scalars['Boolean']>;
  /**
   * Determines if the account should be shown an inline upgrade modal for the
   * Out of Tasks Inline Upgrade Nudge experiment.
   */
  showTaskUpgradeNudge?: Maybe<Scalars['Boolean']>;
  /** List of supported payment types and their corresponding backends */
  supportedPaymentMethodsv2: Array<SupportedPaymentMethod>;
  /** Object containing Gargoyle switches that may apply to the account */
  switches: Scalars['JSON'];
  task?: Maybe<Task>;
  /** The buffer multiplier for task usage limit in a billing period */
  taskBufferOverride?: Maybe<Scalars['Float']>;
  tasks?: Maybe<Tasks>;
  /** Task usage over time */
  taskUsageTrend: AccountTaskUsageTrend;
  team?: Maybe<Team>;
  /** End date for the team account, if it exists */
  teamAccountEndDate?: Maybe<Scalars['String']>;
  teams?: Maybe<Teams>;
  /** Is this account set to auto-upgrade to Team account? */
  teamsTrialAutoUpgrade?: Maybe<Scalars['Boolean']>;
  /** End date for the team free trial, if it exists */
  teamTrialEndDate?: Maybe<Scalars['String']>;
  /** List of most active Zapier users in Account */
  topUsers: Array<UserWithStats>;
  /** List of most active Zapier users in Account */
  topZaps: Array<TopZap>;
  /** List of most active Zapier users in Account */
  topZapsV2: TopZaps;
  /** Is this account set to auto-upgrade to a premium (paid, non-Team, non-Company) account? */
  trialAutoUpgrade?: Maybe<Scalars['Boolean']>;
  /** End date for the Professional trial, if it exists */
  trialEndDate?: Maybe<Scalars['String']>;
  /** Usage stats for Account */
  usage: AccountUsage;
  virtualFolders: Array<Folder>;
  /**
   * An export of Zaps on an account (filter by passing zapIds)
   * (meant to be serialized into a file and downloaded)
   */
  zapExport: Scalars['JSON'];
  /**
   * An export of Zaps in a folder
   * (meant to be serialized into a file and downloaded)
   */
  zapFolderExport: Scalars['JSON'];
};

export type AccountAppRestrictionArgs = {
  id: Scalars['ID'];
};

export type AccountAppRestrictionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AccountAppUsageArgs = {
  slug: Scalars['String'];
};

export type AccountFeatureEnrollmentArgs = {
  featureId: Scalars['ID'];
};

export type AccountFolderArgs = {
  id: Scalars['Int'];
};

export type AccountFoldersArgs = {
  includeVirtual?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AccountHeldTasksAggregationArgs = {
  includeSharedWith?: InputMaybe<Scalars['Boolean']>;
};

export type AccountHeldTasksByReasonArgs = {
  includeSharedWith?: InputMaybe<Scalars['Boolean']>;
};

export type AccountInvoicePreviewArgs = {
  currency?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['ID']>;
};

export type AccountMemberArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type AccountMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<MemberRole>;
  search?: InputMaybe<Scalars['String']>;
};

export type AccountOfferArgs = {
  offerId: Scalars['ID'];
};

export type AccountRecommendedAppsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AccountRecommendedZapTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AccountTaskArgs = {
  id: Scalars['ID'];
};

export type AccountTasksArgs = {
  app?: InputMaybe<Scalars['String']>;
  customuserId?: InputMaybe<Scalars['ID']>;
  folderId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  periodEnd?: InputMaybe<Scalars['String']>;
  periodStart?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  rootId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type AccountTaskUsageTrendArgs = {
  app?: InputMaybe<Scalars['String']>;
  customuserId?: InputMaybe<Scalars['ID']>;
  folderId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  periodEnd?: InputMaybe<Scalars['String']>;
  periodStart?: InputMaybe<Scalars['String']>;
  rootIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AccountTeamArgs = {
  id: Scalars['ID'];
};

export type AccountTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AccountTopZapsArgs = {
  app?: InputMaybe<Scalars['String']>;
  customuserId?: InputMaybe<Scalars['ID']>;
  folderId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  periodEnd?: InputMaybe<Scalars['String']>;
  periodStart?: InputMaybe<Scalars['String']>;
  rootIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AccountTopZapsV2Args = {
  app?: InputMaybe<Scalars['String']>;
  customuserId?: InputMaybe<Scalars['ID']>;
  folderId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  periodEnd?: InputMaybe<Scalars['String']>;
  periodStart?: InputMaybe<Scalars['String']>;
  rootIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AccountZapExportArgs = {
  zapIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AccountZapFolderExportArgs = {
  folderId: Scalars['ID'];
};

export type AccessPolicy = {
  __typename?: 'AccessPolicy';
  /** Level of access policy allows */
  accessLevel: AccessPolicyLevel;
  /** Account Id */
  accountId: Scalars['Int'];
  id: Scalars['Int'];
  /**
   * True if email is required to be verified before requesting
   * access to the account
   */
  isEmailVerificationRequired: Scalars['Boolean'];
};

export enum AccessPolicyLevel {
  AutoJoin = 'auto_join',
  InviteOnly = 'invite_only',
  RequestAccess = 'request_access',
}

/** Represents an app that is denied / allowed for an account */
export type AppRestriction = {
  __typename?: 'AppRestriction';
  /** Id of the app that is being restricted */
  appId?: Maybe<Scalars['String']>;
  /** A url pointing to the app's logo. */
  appImage?: Maybe<Scalars['String']>;
  /** Human readable app name */
  appName?: Maybe<Scalars['String']>;
  /** Slug of the app that is being restricted */
  appSlug?: Maybe<Scalars['String']>;
  /** Datetime app restriction was created */
  createdAt: Scalars['String'];
  /**
   * If isRestricted then allow members else deny members
   * (basically the exceptions to the isRestricted rule)
   */
  exceptions: Array<ShareResult>;
  /** Restriction Id */
  id: Scalars['ID'];
  /** True if denied / false if allowed */
  isRestricted: Scalars['Boolean'];
};

/** Used to return share search results */
export type ShareResult = {
  __typename?: 'ShareResult';
  /** Description of result */
  description: Scalars['String'];
  /** Result's record id */
  id: Scalars['ID'];
  /** Image Url */
  imageUrl?: Maybe<Scalars['String']>;
  /** Display name of result */
  name: Scalars['String'];
  /** Member role (for member type only) */
  role?: Maybe<Scalars['String']>;
  /** Result record type */
  type?: Maybe<ShareMemberType>;
};

export enum ShareMemberType {
  Member = 'member',
  Team = 'team',
}

export type AppRestrictions = LimitOffsetConnection & {
  __typename?: 'AppRestrictions';
  edges: Array<AppRestriction>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** Implements a connection for a collection that is paginated via limit/offset */
export type LimitOffsetConnection = {
  /** Meta data for this page. */
  pageInfo: LimitOffsetPageInfo;
  /** The total number of items in this collection. */
  totalCount: Scalars['Int'];
};

/** The type for the 'pageInfo' field on a LimitOffsetConnection, which implements limit/offset pagination. */
export type LimitOffsetPageInfo = {
  __typename?: 'LimitOffsetPageInfo';
  /** The number of results on this page. */
  count: Scalars['Int'];
  /** Is there another page after this one? */
  hasNextPage: Scalars['Boolean'];
  /** Is there a previous page before this one? */
  hasPreviousPage: Scalars['Boolean'];
  /** The offset relative to where this page starts. */
  offset: Scalars['Int'];
};

/** Represents the current usage of an app in an account */
export type AppUsage = {
  __typename?: 'AppUsage';
  /** App Slug */
  slug: Scalars['ID'];
  /** Number of users using app */
  userCount: Scalars['Int'];
  /** Number of zaps using app */
  zapCount: Scalars['Int'];
};

/** Determines what types of payment sources can be used with a given currency */
export type CurrencyRulesetItem = {
  __typename?: 'CurrencyRulesetItem';
  currency: Scalars['String'];
  method: PaymentSourceType;
  processor: PaymentSourceBackend;
  submethod: Scalars['String'];
  submethodDisplay: Scalars['String'];
};

export enum PaymentSourceType {
  Bank = 'bank',
  Card = 'card',
  Manual = 'manual',
  Paypal = 'paypal',
}

export enum PaymentSourceBackend {
  Braintree = 'braintree',
  Stripe = 'stripe',
}

export enum MemberRole {
  Admin = 'admin',
  Member = 'member',
  Owner = 'owner',
}

/** Discount */
export type Discount = {
  __typename?: 'Discount';
  /** Coupon name */
  couponName: Scalars['String'];
  /**
   * Coupon type. One of the following: 'sbap' (Small Business Assistance),
   * 'papa' (Premier Assistance Program), 'fr' (First Responder), or 'other'
   */
  couponType: Scalars['String'];
  /** Discount Id */
  id: Scalars['ID'];
};

export type Entitlements = {
  __typename?: 'Entitlements';
  limits: PlanLimit;
  planStatus: PlanStatus;
  quotas: PlanQuotas;
};

export type PlanLimit = {
  __typename?: 'PlanLimit';
  actionLimit: Scalars['Int'];
  autoreplayErroredTasks: Scalars['Boolean'];
  blockAndRelease: Scalars['Int'];
  memberLimit: Scalars['Int'];
  nodeBranchLimit: Scalars['Int'];
  /** How often plan allows polls to run */
  pollingInterval: Scalars['Int'];
  premiumApps: Array<Scalars['String']>;
  premiumAppsLimit: Scalars['Int'];
  throttleMultiplier: Scalars['Int'];
  /** Number of branches allowed by plan */
  zapBranchDepthLimit: Scalars['Int'];
  /** Number of steps allowed in Zap by plan */
  zapLength: Scalars['Int'];
  /** Number of live Zaps allowed by plan */
  zapLimit: Scalars['Int'];
};

export type PlanStatus = {
  __typename?: 'PlanStatus';
  amount: Scalars['Int'];
  companiesTrialEndDate?: Maybe<Scalars['String']>;
  descriptiveName: Scalars['String'];
  hasPaymentSource: Scalars['Boolean'];
  id: Scalars['Int'];
  interval: BillingInterval;
  isCompanyAccount: Scalars['Boolean'];
  isTeamAccount: Scalars['Boolean'];
  meteredPricingTiers: Scalars['String'];
  meteredTaskPricing: Scalars['Boolean'];
  name: Scalars['String'];
  periodEnd: Scalars['String'];
  periodStart: Scalars['String'];
  planType: Scalars['String'];
  teamsTrialEndDate?: Maybe<Scalars['String']>;
};

export enum BillingInterval {
  Month = 'month',
  Year = 'year',
}

export type PlanQuotas = {
  __typename?: 'PlanQuotas';
  /** Plan Task Quota */
  tasks: PlanQuota;
  /** Plan Zap Quota */
  zaps: PlanQuota;
};

export type PlanQuota = {
  __typename?: 'PlanQuota';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  percent: Scalars['Int'];
};

/** Represents features opted in by a user for an account */
export type FeatureEnrollment = {
  __typename?: 'FeatureEnrollment';
  accountId: Scalars['ID'];
  featureName: Scalars['String'];
  id: Scalars['ID'];
  isEnrolled: Scalars['Boolean'];
};

export type Folder = {
  __typename?: 'Folder';
  /** Account Id that folder belongs to */
  accountId: Scalars['Int'];
  /** Folder Id */
  id: Scalars['Int'];
  /** True if folder is shared (false for private) */
  isShared: Scalars['Boolean'];
  /** True if folder is a calculated folder */
  isVirtual: Scalars['Boolean'];
  /** Users that folder is shared with */
  members: Array<ShareMember>;
  /** Id of the folder's owner */
  owner: ShareMember;
  /**
   * Teams that folder is shared with
   * (can include the special 'all' group which is everyone)
   */
  teams: Array<ShareTeam>;
  /** Folder's title */
  title: Scalars['String'];
  /** Count of Zaps in the folder */
  zapCount: Scalars['Int'];
};

/** A member that a structure is shared with */
export type ShareMember = {
  __typename?: 'ShareMember';
  /** Description to show for this member in the UI */
  description: Scalars['String'];
  /** Member email */
  email: Scalars['String'];
  /** Member Id */
  id: Scalars['ID'];
  /** Member image URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** True if member is the owner of the shared object */
  isOwner?: Maybe<Scalars['Boolean']>;
  /** Member's full name */
  name: Scalars['String'];
  /** Value used to determine this is a ShareMember vs a ShareTeam */
  type: ShareMemberType;
};

/** A team that a structure is shared with */
export type ShareTeam = {
  __typename?: 'ShareTeam';
  /** A user-friendly label to show in the UI for this team (sharing editor) */
  description: Scalars['String'];
  /** Team Id */
  id: Scalars['ID'];
  /** Image URL of team */
  imageUrl?: Maybe<Scalars['String']>;
  /** Total count of members */
  memberCount: Scalars['Int'];
  /** Name of team */
  name: Scalars['String'];
  /** Value used to determine this is a ShareTeam vs a ShareMember */
  type: ShareMemberType;
};

/** Held tasks rolled up by Zap */
export type HeldTaskBannerDataResult = {
  __typename?: 'HeldTaskBannerDataResult';
  /** Held tasks rolled up by Zap (root) */
  roots?: Maybe<Scalars['JSON']>;
  /** Earliest date tasks start expiring */
  startsExpiringOn?: Maybe<Scalars['String']>;
  /** Total number of held tasks */
  totalHeldTaskCount?: Maybe<Scalars['Int']>;
};

/** Held tasks rolled up by reason they were held */
export type HeldTaskByReason = {
  __typename?: 'HeldTaskByReason';
  /** Array of held tasks grouped by held task reason */
  reasons: Array<HeldTaskReasonData>;
  /** Earliest date tasks start expiring */
  startsExpiringOn?: Maybe<Scalars['String']>;
  /** Total number of held tasks */
  totalHeldTaskCount: Scalars['Int'];
};

export type HeldTaskReasonData = {
  __typename?: 'HeldTaskReasonData';
  /**
   * Array of expired auth information
   * (if tasks are held by stale auths)
   */
  auths?: Maybe<Array<AuthenticationV2>>;
  /** Same as reason */
  id: Scalars['ID'];
  /** Reason why tasks were held (type) */
  reason: TaskHeldReason;
  /** Number of tasks held */
  total: Scalars['Int'];
};

/** Represents an authentication with an App that the user has allowed Zapier to access. */
export type AuthenticationV2 = {
  __typename?: 'AuthenticationV2';
  accountId: Scalars['ID'];
  /** Can this auth be shared by this user? */
  canShare: Scalars['Boolean'];
  /** Date authentication was created */
  created: Scalars['String'];
  /** ID of the user that created this Auth */
  customuserId: Scalars['ID'];
  /** Auth description */
  description?: Maybe<Scalars['String']>;
  /** If this connection has a destination API selected */
  destinationSelectedApi?: Maybe<Scalars['ID']>;
  /** The ID of this authentication. */
  id: Scalars['ID'];
  /** User's identifier to log into auth (if needed) */
  identifier?: Maybe<Scalars['String']>;
  /** Is this Auth private? */
  isPrivate: Scalars['Boolean'];
  /** Is this auth shared? */
  isShared: Scalars['Boolean'];
  /** Whether this authentication is stale or not. */
  isStale: Scalars['Boolean'];
  /** Date this auth was last changed */
  lastchanged: Scalars['String'];
  /** Users that auth is shared with */
  members: Array<ShareMember>;
  /** The full user object that represents the owning member */
  owner: Member;
  /** The permissions the current user has for this auth */
  permissions: AuthPermissions;
  /**
   * References the App that this authentication is for.
   * Note that, for CLI apps, this contains the version suffix as well. Example: `MailchimpCLIAPI@1.0.23`.
   */
  selectedApi: Scalars['String'];
  /** URL slug for public apps */
  serviceSlug?: Maybe<Scalars['String']>;
  /** Sorted list of members and teams this authentication is shared with */
  sharedWith: Array<ShareEntity>;
  /** Is this a private auth connection or has the user shared it with the rest of their account? */
  sharedWithAll: Scalars['Boolean'];
  /**
   * Teams that auth is shared with
   * (can include the special 'all' team which is everyone)
   */
  teams: Array<ShareTeam>;
  /**
   * The title given to this authentication. This is either a custom title given by the user,
   * or auto-generated by us when this authentication object is created.
   */
  title: Scalars['String'];
  /** The nubmer of Zaps using this connection */
  zapCount: Scalars['Int'];
};

export type Member = {
  __typename?: 'Member';
  /** Can current user edit member */
  canEdit: Scalars['Boolean'];
  /** Members's email address */
  email: Scalars['String'];
  /** Hash of Member's email address */
  emailHash: Scalars['String'];
  id: Scalars['String'];
  /** Url of Member's image */
  imageUrl?: Maybe<Scalars['String']>;
  /** Does member represent the current user */
  isCurrentUser: Scalars['Boolean'];
  /** Member's name */
  name?: Maybe<Scalars['String']>;
  /** Invitation / Member Id */
  recordId: Scalars['Int'];
  /** Role invitee will take on as a member */
  role: MemberRole;
  /** Member's status */
  status: MemberStatus;
  /** Member's usage stats */
  usage?: Maybe<MemberUsage>;
};

export enum MemberStatus {
  Invitation = 'invitation',
  Member = 'member',
  Request = 'request',
}

export type MemberUsage = {
  __typename?: 'MemberUsage';
  /** Number of tasks member has used in current period */
  numTasks: Scalars['Int'];
  /** Number of zaps member has created */
  numZaps: Scalars['Int'];
};

/** Represents the permissions that the current user has for an auth */
export type AuthPermissions = {
  __typename?: 'AuthPermissions';
  /** Can the current user delete this auth? */
  delete: Scalars['Boolean'];
  /** Can the current user edit this auth? */
  edit: Scalars['Boolean'];
  /** Can the current user reconnect this auth? */
  reconnect: Scalars['Boolean'];
  /** Can the current user edit sharing for this auth? */
  share: Scalars['Boolean'];
  /** Can the current user test this auth? */
  test: Scalars['Boolean'];
  /** Can the current user transfer this auth to a new owner? */
  transfer: Scalars['Boolean'];
  /** Can the current user use this auth in a Zap? */
  use: Scalars['Boolean'];
};

/** ShareEntity is either a ShareMember or ShareTeam */
export type ShareEntity = ShareMember | ShareTeam;

export enum TaskHeldReason {
  AccessBlacklistedApp = 'access_blacklisted_app',
  BlacklistedApp = 'blacklisted_app',
  DedupeChange = 'dedupe_change',
  PaymentIssue = 'paymentIssue',
  PlanLimit = 'plan_limit',
  StaleAuth = 'stale_auth',
  StepLimit = 'step_limit',
  TaskLimit = 'task_limit',
  Throttled = 'throttled',
  TooMany = 'too_many',
  Unknown = 'unknown',
}

export type Invoice = {
  __typename?: 'Invoice';
  /** Total amount due with invoice */
  amountDue: Scalars['Int'];
  /** Datetime Invoice was created */
  createdAt: Scalars['String'];
  /** Invoice currency */
  currency?: Maybe<Scalars['String']>;
  /** Optinal discount (if applied) */
  discount?: Maybe<LineItemDiscount>;
  /** Is the payment for the Invoice pending */
  hasPendingPayment: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Date of invoice, in UTC */
  invoicedAt?: Maybe<Scalars['String']>;
  /** Is Invoice closed */
  isClosed: Scalars['Boolean'];
  /** Has Invoice been paid */
  isPaid: Scalars['Boolean'];
  /** True if Invoice has been refunded */
  isRefunded: Scalars['Boolean'];
  /** True if invoice period is not complete */
  isUpcoming: Scalars['Boolean'];
  /** Line Items included in invoice */
  items: Array<LineItem>;
  /** Total when Invoice was first created (null if no change) */
  originalTotal?: Maybe<Scalars['Int']>;
  /** Payment details (if already paid) */
  payment?: Maybe<LineItemPayment>;
  /** The Payment Intent for this invoice */
  paymentIntent?: Maybe<PaymentIntent>;
  /** End of invoice period */
  periodEnd: Scalars['String'];
  /** Start of invoice period */
  periodStart: Scalars['String'];
  /** URL for downloading printable version of invoice */
  printableUrl: Scalars['String'];
  /** Human readable reason */
  reason: Scalars['String'];
  /** Reason code invoice was created */
  reasonCode: LineItemReason;
  /** Existing balance at start of invoice period */
  startingBalance: Scalars['Int'];
  /** Invoice Status */
  status?: Maybe<InvoiceStatus>;
  /** Subtotal of line items */
  subtotal: Scalars['Int'];
  /** Total of all items in invoice */
  total: Scalars['Int'];
};

export type LineItemDiscount = {
  __typename?: 'LineItemDiscount';
  coupon?: Maybe<LineItemCoupon>;
  customer?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type LineItemCoupon = {
  __typename?: 'LineItemCoupon';
  amountOff?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Int']>;
  timesRedeemed?: Maybe<Scalars['Int']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  /** Line Item amount due */
  amount: Scalars['Int'];
  /** Line item currency */
  currency?: Maybe<Scalars['String']>;
  /** Line item description */
  description: Scalars['String'];
  id: Scalars['ID'];
  /** Optional additional information */
  metadata?: Maybe<LineItemMetaData>;
};

export type LineItemMetaData = {
  __typename?: 'LineItemMetaData';
  numTasks?: Maybe<Scalars['Int']>;
  periodEnd?: Maybe<Scalars['String']>;
  periodStart?: Maybe<Scalars['String']>;
  pricePerTask?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  taskLedgerTransactionId?: Maybe<Scalars['ID']>;
  zapierPlanId: Scalars['ID'];
};

export type LineItemPayment = {
  __typename?: 'LineItemPayment';
  amount: Scalars['Int'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  source?: Maybe<PaymentSource>;
  status: Scalars['String'];
};

export type PaymentSource = {
  __typename?: 'PaymentSource';
  /**
   * The deatils of the source
   * (will be different shapes depending on type)
   */
  details?: Maybe<PaymentSourceDetails>;
  id: Scalars['ID'];
  /** The method of payment (bank, card, paypal, ...etc) */
  method?: Maybe<PaymentSourceType>;
  /** The submethod of payment (jcp, american-express, ach, etc) */
  submethod?: Maybe<Scalars['String']>;
  /**
   * The type of payment source (bank, card, ...etc)
   * @deprecated Use method instead
   */
  type?: Maybe<PaymentSourceType>;
};

export type PaymentSourceDetails =
  | PaymentSourceBank
  | PaymentSourceCard
  | PaymentSourcePaypal;

/** Represents a Bank payment source */
export type PaymentSourceBank = {
  __typename?: 'PaymentSourceBank';
  accountHolderName: Scalars['String'];
  accountType: BankAccountType;
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  bankName: Scalars['String'];
  last4: Scalars['String'];
  ownershipType: BankOwnershipType;
  routingNumber: Scalars['String'];
  verified: Scalars['Boolean'];
};

export enum BankAccountType {
  Checking = 'checking',
  Savings = 'savings',
}

export enum BankOwnershipType {
  Business = 'business',
  Personal = 'personal',
}

/** Represents a Credit Card payment source */
export type PaymentSourceCard = {
  __typename?: 'PaymentSourceCard';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  expiry: Scalars['String'];
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  last4: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** Represents a Paypal payment source */
export type PaymentSourcePaypal = {
  __typename?: 'PaymentSourcePaypal';
  email: Scalars['String'];
  token?: Maybe<Scalars['String']>;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  amount: Scalars['Int'];
  clientSecret: Scalars['String'];
  currency: Scalars['String'];
  customer: Scalars['ID'];
  id: Scalars['ID'];
  invoice: Scalars['String'];
  paymentSource: Scalars['String'];
  processor: Scalars['String'];
  status: Scalars['String'];
};

export enum LineItemReason {
  AnnualMetered = 'annual_metered',
  PeriodEnded = 'period_ended',
  UpgradeOrDowngrade = 'upgrade_or_downgrade',
}

export enum InvoiceStatus {
  Error = 'error',
  Forgiven = 'forgiven',
  Overdue = 'overdue',
  Paid = 'paid',
  Pending = 'pending',
  Refunded = 'refunded',
  Scheduled = 'scheduled',
}

export type Members = LimitOffsetConnection & {
  __typename?: 'Members';
  edges: Array<Member>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** Offer */
export type Offer = {
  __typename?: 'Offer';
  acceptedAt?: Maybe<Scalars['String']>;
  accountId: Scalars['ID'];
  createdAt?: Maybe<Scalars['String']>;
  /** The datetime the offer is no longer allowed to be accepted. */
  expiry?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * The plan the user will end up after accepting the offer. Used with multi-interval
   * offers.
   */
  targetPlanId?: Maybe<Scalars['ID']>;
  variant: OfferVariant;
};

/** Offer Variant */
export type OfferVariant = {
  __typename?: 'OfferVariant';
  campaign: OfferCampaign;
  /**
   * The plan the user will end up after accepting the offer. Used with single-interval
   * offers.
   */
  destinationPlan?: Maybe<OfferPlan>;
  id: Scalars['ID'];
  /** True if this variant is an experiment control group. */
  isControl: Scalars['Boolean'];
  monthlyCost: Scalars['Int'];
  name: Scalars['String'];
  /**
   * The plan group the promotional plan is in, if applicable. Used for allowing the user
   * to choose between billing intervals.
   */
  promotionPlanGroup?: Maybe<OfferPlanGroup>;
  terms?: Maybe<Scalars['String']>;
  totalCost: Scalars['Int'];
};

/** Offer Campaign */
export type OfferCampaign = {
  __typename?: 'OfferCampaign';
  id: Scalars['ID'];
  maxUses: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** Offer Plan */
export type OfferPlan = {
  __typename?: 'OfferPlan';
  amount: Scalars['Int'];
  displayShortName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interval: Scalars['String'];
  name: Scalars['String'];
};

/** Offer Plan Group */
export type OfferPlanGroup = {
  __typename?: 'OfferPlanGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AccountOwner = {
  __typename?: 'AccountOwner';
  /** Account owner's email address */
  email: Scalars['String'];
  /** Account owner's id */
  id: Scalars['ID'];
  /** Account owner's name */
  name: Scalars['String'];
};

export type Plan = {
  __typename?: 'Plan';
  /** Plan allows company features */
  allowCompanies: Scalars['Boolean'];
  /** Plan allows Import / Export of Zaps */
  allowImportExport: Scalars['Boolean'];
  /** Amount per month */
  amount: Scalars['Int'];
  /** Amount per billing interval */
  billingAmount: Scalars['Int'];
  /** Plan billing interval */
  billingInterval: BillingInterval;
  /** Long description of plan */
  description: Scalars['String'];
  /** A more verbose name for a plan. Example: "Professional Plan with 10,000 tasks". */
  descriptiveName: Scalars['String'];
  displayName: Scalars['String'];
  /** Features included in plan */
  features: Array<PlanFeature>;
  /** Heading of features section */
  featuresTag: Scalars['String'];
  /** Plan allows auto replay of tasks */
  hasAutoReplay: Scalars['Boolean'];
  /** Plan allows metered billing */
  hasMeteredBilling: Scalars['Boolean'];
  /** Plan allows multi-step zaps */
  hasMultiStepZaps: Scalars['Boolean'];
  /** Plan allows paths */
  hasPaths: Scalars['Boolean'];
  /** Plan allows premium apps */
  hasPremiumApps: Scalars['Boolean'];
  /** Plan allows teams */
  hasTeams: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Plan billing intervals */
  intervals: Array<PlanInterval>;
  /** This is the current account's plan */
  isCurrentPlan: Scalars['Boolean'];
  /** Plan is a member of a plan group */
  isInPlanGroup: Scalars['Boolean'];
  /** Various limits related to the plan */
  limits: PlanLimits;
  /** Plan name */
  name: Scalars['String'];
  /** The task limit currently applied to the plan */
  selectedTaskLimitVariant?: Maybe<PlanTaskLimitVariant>;
  /** Short variant of name string */
  shortName: Scalars['String'];
  /** List of available task limits for the plan */
  taskLimitVariants: Array<PlanTaskLimitVariant>;
  /** Plan task limit */
  tasks: Scalars['Int'];
  /** Tiers of per-task costs for plans with metered billing */
  tiers: Array<PlanTier>;
  /** The label for a collection of plans with identical features but different task limits. Examples: "Starter", "Professional". */
  type: Scalars['String'];
  /** Plan zap limit */
  zaps: Scalars['Int'];
  /** How often zaps are evaluated in plan (in minutes) */
  zapsRunInterval: Scalars['Int'];
};

export type PlanFeature = {
  __typename?: 'PlanFeature';
  /** Optional URL to navigate to when feature is clicked. */
  href?: Maybe<Scalars['String']>;
  /** Feature name */
  name: Scalars['String'];
  /** Long feature description */
  tooltip?: Maybe<Scalars['String']>;
};

export type PlanInterval = {
  __typename?: 'PlanInterval';
  /** Billing amount of interval */
  amount: Scalars['Int'];
  id: Scalars['ID'];
  /** Interval (i.e. monthly / yearly) */
  interval: BillingInterval;
  /** Amount per month */
  monthlyAmount: Scalars['Int'];
};

export type PlanLimits = {
  __typename?: 'PlanLimits';
  action_limit: Scalars['Int'];
  member_limit: Scalars['Int'];
  polling_interval: Scalars['Int'];
  premium_apps_limit: Scalars['Int'];
  throttle_multiplier: Scalars['Int'];
  zap_length: Scalars['Int'];
  zap_limit: Scalars['Int'];
};

export type PlanTaskLimitVariant = {
  __typename?: 'PlanTaskLimitVariant';
  /** Cost of variant per interval */
  intervals: Array<PlanInterval>;
  /** Variant Name */
  name: Scalars['String'];
  /** Task Limit */
  tasks: Scalars['Int'];
};

export type PlanTier = {
  __typename?: 'PlanTier';
  /** Max number of tasks to be in tier (-1 for infinity) */
  numTasks: Scalars['Int'];
  /** Price per task in tier */
  pricePerTask: Scalars['Float'];
};

export type PlanV2 = {
  __typename?: 'PlanV2';
  /** Plan allows company features */
  allowCompanies: Scalars['Boolean'];
  /** Amount per interval */
  amount: Scalars['Int'];
  /** Long description of plan */
  description?: Maybe<Scalars['String']>;
  /**
   * Features included in plan
   * Mostly used to show features list and tooltips
   */
  features: Array<PlanFeature>;
  /** Plan allows auto replay of tasks */
  hasAutoReplay: Scalars['Boolean'];
  /** Plan allows metered billing */
  hasMeteredBilling: Scalars['Boolean'];
  /** Plan allows multi-step zaps */
  hasMultiStepZaps: Scalars['Boolean'];
  /** Plan allows paths */
  hasPaths: Scalars['Boolean'];
  /** Plan allows premium apps */
  hasPremiumApps: Scalars['Boolean'];
  /** Plan allows teams */
  hasTeams: Scalars['Boolean'];
  id: Scalars['ID'];
  /** The plan billing interval */
  interval: BillingInterval;
  /** Plan is a member of a plan group */
  isInPlanGroup: Scalars['Boolean'];
  /** Member limit for team-enabled accounts */
  memberLimit: Scalars['Int'];
  /** Plan name */
  name: Scalars['String'];
  /** Maximum number of premium apps */
  premiumAppsLimit: Scalars['Int'];
  /** Plan task limit */
  tasks: Scalars['Int'];
  /** Tiers of per-task costs for plans with metered billing */
  tiers: Array<PlanTier>;
  /**
   * The type this plan belongs to
   * e.g. Starter
   */
  type: Scalars['String'];
  /** Maximum number of Zaps */
  zapLimit: Scalars['Int'];
  /** Plan zap limit */
  zaps: Scalars['Int'];
  /** How often zaps are evaluated in minutes */
  zapsRunInterval: Scalars['Int'];
};

export type RecommendedApps = LimitOffsetConnection & {
  __typename?: 'RecommendedApps';
  edges: Array<RecommendedApp>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** Represents App that is recommend for the Account to use */
export type RecommendedApp = {
  __typename?: 'RecommendedApp';
  /** App Id */
  id: Scalars['ID'];
  /** App Image Url */
  imageUrl?: Maybe<Scalars['String']>;
  /** App Name */
  name: Scalars['String'];
  /** App popularity ranking */
  popularity: Scalars['Int'];
  /** Url of App info page */
  serviceUrl: Scalars['String'];
  /** App slug */
  slug: Scalars['String'];
  /** App's homepage url */
  url?: Maybe<Scalars['String']>;
  /** Number of Zaps that use App */
  zapUsageCount: Scalars['Int'];
};

export type RecommendedZapTemplates = LimitOffsetConnection & {
  __typename?: 'RecommendedZapTemplates';
  edges: Array<RecommendedZapTemplate>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export type RecommendedZapTemplate = {
  __typename?: 'RecommendedZapTemplate';
  /** Description of this Zap Template in HTML format. */
  descriptionHtml: Scalars['DeprecatedHTML'];
  /** The app used for the "head" (i.e. first step) of this Zap Template. */
  headService: ServiceV2;
  /** The unique ID of this Zap Template. */
  id: Scalars['ID'];
  /** A unique slug generated for this Zap Template, based on the title. */
  slug: Scalars['String'];
  /** The status of this Zap Template. */
  status: Scalars['String'];
  /**
   * Metadata of the Zap steps that are part of this Zap Template.
   * Currently a JSON scalar but we should better define its shape!
   */
  steps: Scalars['JSON'];
  /** The app used for the "tail" (i.e. last step) of this Zap Template. */
  tailService: ServiceV2;
  /**
   * The title of this Zap Template, if any. May be empty or null if this is a brand new
   * Zap template.
   */
  title?: Maybe<Scalars['String']>;
  /** The URL to the SEO page of this Zap Template. */
  url: Scalars['String'];
};

/** THIS IS A DEPRECATED TYPE. DO NOT USE IT! */
export type ServiceV2 = {
  __typename?: 'ServiceV2';
  actions?: Maybe<ServiceActionTypesV2>;
  ageInDays?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['Int']>;
  appUrl?: Maybe<Scalars['String']>;
  authType?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<ServiceCategoryV2>>>;
  daysSinceLastUpdate?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  hasFilters?: Maybe<Scalars['Boolean']>;
  hashtag?: Maybe<Scalars['String']>;
  hasReads?: Maybe<Scalars['Boolean']>;
  hasSearches?: Maybe<Scalars['Boolean']>;
  hasSearchesOrWrites?: Maybe<Scalars['Boolean']>;
  hasUpfrontFields?: Maybe<Scalars['Boolean']>;
  hasWrites?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Scalars['JSON']>;
  integrationOverviewHtml?: Maybe<Scalars['String']>;
  inviteUrl?: Maybe<Scalars['String']>;
  isBeta?: Maybe<Scalars['Boolean']>;
  isBuiltIn?: Maybe<Scalars['Boolean']>;
  isDeprecated?: Maybe<Scalars['Boolean']>;
  isFeatured?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isInvite?: Maybe<Scalars['Boolean']>;
  isPremium?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isUpcoming?: Maybe<Scalars['Boolean']>;
  learnMoreUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  primaryColor?: Maybe<Scalars['String']>;
  requestCount?: Maybe<Scalars['Int']>;
  serviceId?: Maybe<Scalars['Int']>;
  sharingTags?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  zapUsageCount?: Maybe<Scalars['Int']>;
};

/** THIS IS A DEPRECATED TYPE. DO NOT USE IT! */
export type ServiceActionTypesV2 = {
  __typename?: 'ServiceActionTypesV2';
  filters?: Maybe<Array<Maybe<ServiceActionV2>>>;
  reads?: Maybe<Array<Maybe<ServiceReadActionV2>>>;
  searches?: Maybe<Array<Maybe<ServiceActionV2>>>;
  searchesOrWrites?: Maybe<Array<Maybe<ServiceSearchOrWriteActionV2>>>;
  writes?: Maybe<Array<Maybe<ServiceActionV2>>>;
};

/** THIS IS A DEPRECATED TYPE. DO NOT USE IT! */
export type ServiceActionV2 = {
  __typename?: 'ServiceActionV2';
  helpText?: Maybe<Scalars['String']>;
  helpTextHtml?: Maybe<Scalars['String']>;
  hide?: Maybe<Scalars['Boolean']>;
  important?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  needs?: Maybe<Scalars['JSON']>;
  noun?: Maybe<Scalars['String']>;
  typeOf?: Maybe<Scalars['String']>;
};

/** THIS IS A DEPRECATED TYPE. DO NOT USE IT! */
export type ServiceReadActionV2 = {
  __typename?: 'ServiceReadActionV2';
  helpText?: Maybe<Scalars['String']>;
  helpTextHtml?: Maybe<Scalars['String']>;
  hide?: Maybe<Scalars['Boolean']>;
  hookDirectionsHtml?: Maybe<Scalars['String']>;
  hookLegacyUrl?: Maybe<Scalars['String']>;
  hookUrl?: Maybe<Scalars['String']>;
  important?: Maybe<Scalars['Boolean']>;
  isHook?: Maybe<Scalars['Boolean']>;
  isHookNotification?: Maybe<Scalars['Boolean']>;
  isHookPollable?: Maybe<Scalars['Boolean']>;
  isHookSubscription?: Maybe<Scalars['Boolean']>;
  isHookToPoll?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  needs?: Maybe<Scalars['JSON']>;
  noun?: Maybe<Scalars['String']>;
  typeOf?: Maybe<Scalars['String']>;
};

/** THIS IS A DEPRECATED TYPE. DO NOT USE IT! */
export type ServiceSearchOrWriteActionV2 = {
  __typename?: 'ServiceSearchOrWriteActionV2';
  helpText?: Maybe<Scalars['String']>;
  helpTextHtml?: Maybe<Scalars['String']>;
  hide?: Maybe<Scalars['Boolean']>;
  important?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  needs?: Maybe<Scalars['JSON']>;
  noun?: Maybe<Scalars['String']>;
  searchDelegate?: Maybe<Scalars['String']>;
  typeOf?: Maybe<Scalars['String']>;
  writeDelegate?: Maybe<Scalars['String']>;
};

/** THIS IS A DEPRECATED TYPE. DO NOT USE IT! */
export type ServiceCategoryV2 = {
  __typename?: 'ServiceCategoryV2';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['ID']>;
};

/** Determines what payment processor to use for a given payment method */
export type SupportedPaymentMethod = {
  __typename?: 'SupportedPaymentMethod';
  method: PaymentSourceType;
  paymentProcessor: PaymentSourceBackend;
  /** @deprecated Use method instead */
  type: PaymentSourceType;
};

/** Represents a Task (in Task History) */
export type Task = {
  __typename?: 'Task';
  /** True if Task can be replayed */
  canReplay: Scalars['Boolean'];
  /** Zap includes paths */
  hasPaths: Scalars['Boolean'];
  /**
   * The reason why the task was held (if applicable)
   * **If you see an 'unknown' then the resolver needs to be updated**
   */
  heldReason?: Maybe<TaskHeldReason>;
  /** Name of stale auth in task (if exists) */
  heldStaleAuth?: Maybe<Scalars['String']>;
  /** Task Id */
  id: Scalars['ID'];
  /** Is the Task (or one its forks) currently running */
  isRunning: Scalars['Boolean'];
  /** Task Node info */
  nodes: Array<TaskNode>;
  /** When the task started running */
  startTime: Scalars['String'];
  /**
   * Current status of task
   * **If you see an 'unknown' then the resolver needs to be updated**
   */
  status: TaskStatus;
  /** Counts of tasks used in run */
  tasks?: Maybe<TasksUsed>;
  /** Zap */
  zap: ZapV2;
  /** Owner of Zap */
  zapOwner?: Maybe<Member>;
  /** List of step apps */
  zapServices: Array<Scalars['String']>;
};

/**
 * Represents an execution step in a Task History Task
 * (i.e. the Webhook Trigger step in the run)
 */
export type TaskNode = {
  __typename?: 'TaskNode';
  /** Will be true if the children of this node contain paths */
  childrenHavePaths: Scalars['Boolean'];
  /** Human-readable description of what happened (or didn't happen) */
  description: Scalars['String'];
  id: Scalars['ID'];
  /** The Zap Node that this Task Node is associated with */
  node: TaskZapNode;
  /** The step number of this TaskNode (1 indexed for display) */
  number: Scalars['Int'];
  /** The fork information associated with this Node */
  sample?: Maybe<TaskNodeSample>;
  /** Overall Status of Task Node */
  status?: Maybe<TaskStatus>;
  /** The fork uuid of this TaskNode */
  step?: Maybe<Scalars['String']>;
  /** Time this TaskNode was executed */
  time?: Maybe<Scalars['String']>;
  /** Type of node this is (node / path / pathGroup) */
  type: TaskNodeType;
};

/** Represents a (partial) Zap Node associated with a TaskNode */
export type TaskZapNode = {
  __typename?: 'TaskZapNode';
  /** Action description */
  action?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Node meta information */
  meta?: Maybe<Scalars['JSON']>;
  /** Node params */
  params?: Maybe<Scalars['JSON']>;
  /** Parent node id */
  parent?: Maybe<Scalars['ID']>;
  /** API used in the node */
  selectedApi?: Maybe<Scalars['String']>;
  /** Type of Node */
  type: ZapNodeType;
};

export enum ZapNodeType {
  Filter = 'filter',
  Read = 'read',
  Search = 'search',
  SearchOrWrite = 'search_or_write',
  Write = 'write',
}

/** Represents the sample (i.e. fork) information associated with a TaskNode */
export type TaskNodeSample = {
  __typename?: 'TaskNodeSample';
  /** Will be non-null for errored TaskNodes */
  error?: Maybe<TaskNodeSampleError>;
  /**
   * The fork id
   * (can't use 'id' since because multiple Samples can be associated with a forkId)
   */
  forkId: Scalars['ID'];
  /** The inputs passed to this sample */
  input?: Maybe<Scalars['JSON']>;
  /** The output passed out of this sample */
  output?: Maybe<Scalars['JSON']>;
  /** The date this sample is scheduled to run (if is in scheduled status) */
  rescheduledTime?: Maybe<Scalars['String']>;
  /** Why this sample stopped execution (if it didn't complete) */
  whyStop: WhyStop;
};

/** Represents an error that occured during a TaskNode execution */
export type TaskNodeSampleError = {
  __typename?: 'TaskNodeSampleError';
  /** The error code */
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** The error status */
  status?: Maybe<Scalars['String']>;
  /** Step id associated with error */
  step: Scalars['ID'];
  /** The error message */
  title?: Maybe<Scalars['String']>;
};

/** Represents why a TaskNode stopped executing before completion */
export type WhyStop = {
  __typename?: 'WhyStop';
  /** Why execution stopped */
  message?: Maybe<Scalars['String']>;
  /** The filter rules that passed / failed */
  ruleDumps?: Maybe<Array<Scalars['String']>>;
  /** The filter rule ids */
  ruleIds?: Maybe<Array<Scalars['String']>>;
};

export enum TaskStatus {
  Delayed = 'delayed',
  Delete = 'delete',
  Deleted = 'deleted',
  Error = 'error',
  Filtered = 'filtered',
  Halted = 'halted',
  Held = 'held',
  Pending = 'pending',
  Replay = 'replay',
  Scheduled = 'scheduled',
  Skipped = 'skipped',
  Success = 'success',
  Throttled = 'throttled',
  Unknown = 'unknown',
}

export enum TaskNodeType {
  Node = 'node',
  Path = 'path',
  PathGroup = 'pathGroup',
}

export type TasksUsed = {
  __typename?: 'TasksUsed';
  total?: Maybe<Scalars['Int']>;
  used?: Maybe<Scalars['Int']>;
};

export type ZapV2 = {
  __typename?: 'ZapV2';
  /** The account that this Zap belongs to */
  account?: Maybe<Account>;
  /** Account that Zap belongs to */
  accountId: Scalars['ID'];
  /** Zap description */
  description?: Maybe<Scalars['String']>;
  /**
   * Zap Edit Mode
   * * If 'unknown' comes up it's because we couldn't recognize
   * the edit mode or it's missing
   */
  editMode: ZapEditMode;
  /** Folders that the Zap is in */
  folderIds: Array<Scalars['ID']>;
  /** Zap's held tasks */
  heldTasks?: Maybe<HeldTaskMap>;
  id: Scalars['ID'];
  /** Will be true if the zap is instantly triggered */
  isInstant: Scalars['Boolean'];
  /** True if the Zap is currently paused for any reason */
  isPaused: Scalars['Boolean'];
  /** True if Zap is currently paused by account plan limitation */
  isPausedByPlan: Scalars['Boolean'];
  /** Will be true if Zap is shared with other members */
  isShared: Scalars['Boolean'];
  /** Will be true if Zap is in trash */
  isTrashed: Scalars['Boolean'];
  /** Zap's type ('workflow' or 'transfer') */
  kind?: Maybe<Scalars['String']>;
  /** Datetime Zap was last changed */
  lastchanged: Scalars['String'];
  /** List of nodes on the Zap */
  nodes: Array<ZapNode>;
  /** Owner of Zap */
  owner: ZapOwner;
  /** State of public zap sharing */
  shareVisibility?: Maybe<ZapShareVisibility>;
  /** The source_url, if any, that created the Zap. */
  sourceUrl?: Maybe<Scalars['String']>;
  /** Current state of zap (on / off / draft) */
  state: ZapState;
  /** Zap's custom timezone (i.e. America/Detroit) */
  timezone?: Maybe<Scalars['String']>;
  /** Zap's name */
  title?: Maybe<Scalars['String']>;
  /** Zap's usage for an (optional) given period */
  usage: TopZapTasks;
};

export type ZapV2UsageArgs = {
  periodEnd?: InputMaybe<Scalars['String']>;
  periodStart?: InputMaybe<Scalars['String']>;
};

export enum ZapEditMode {
  Guided = 'guided',
  Normal = 'normal',
  Simple = 'simple',
  Unknown = 'unknown',
}

/**
 * Represents data coming from
 * /api/v3/stream/held?account_id={account_id}
 */
export type HeldTaskMap = {
  __typename?: 'HeldTaskMap';
  /** Date held tasks start expiring */
  startsExpiringOn: Scalars['String'];
  /** Total held task count for this zap */
  total: Scalars['Int'];
};

export type ZapNode = {
  __typename?: 'ZapNode';
  /** Action description */
  action: Scalars['String'];
  /** Auth Node uses */
  auth?: Maybe<AuthenticationV2>;
  /** Id of Auth used in the Zap Node */
  authId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  /** Id of parent node (will be null for root) */
  parentId?: Maybe<Scalars['ID']>;
  /** Id of root node (will be null for root) */
  rootId?: Maybe<Scalars['ID']>;
  /** API used in the node */
  selectedApi?: Maybe<Scalars['String']>;
  /** Type of Node */
  type: ZapNodeType;
};

export type ZapOwner = {
  __typename?: 'ZapOwner';
  code?: Maybe<Scalars['String']>;
  /** Owner's email address */
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Owner's image url */
  imageUrl?: Maybe<Scalars['String']>;
  /** Owner's full name */
  name?: Maybe<Scalars['String']>;
  /** Owner's timezone */
  timezone?: Maybe<Scalars['String']>;
};

export enum ZapShareVisibility {
  Disabled = 'disabled',
  Global = 'global',
  Private = 'private',
  Public = 'public',
  Team = 'team',
}

export enum ZapState {
  Draft = 'draft',
  Off = 'off',
  On = 'on',
}

/** Top Zap Task Statistics */
export type TopZapTasks = {
  __typename?: 'TopZapTasks';
  /** Number of billable Tasks */
  billable: Scalars['Int'];
  /**
   * Number of times Zap errored
   * @deprecated Use statuses.error instead
   */
  error: Scalars['Int'];
  /** Run counts by status */
  statuses: RunStatusAggregation;
  /**
   * Number of times Zap was triggered successfully
   * @deprecated Use statuses.success instead
   */
  success: Scalars['Int'];
};

/** Count of runs broken down by each possible task status */
export type RunStatusAggregation = {
  __typename?: 'RunStatusAggregation';
  /** Number of billable tasks Zap used */
  billable?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in delayed status */
  delayed?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in delete status */
  delete?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in deleted status */
  deleted?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in error status */
  error: Scalars['Int'];
  /** Number of times Zap run resulted in filtered status */
  filtered?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in halted status */
  halted?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in held status */
  held?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in pending status */
  pending?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in replay status */
  replay?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in scheduled status */
  scheduled?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in skipped status */
  skipped?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in success status */
  success: Scalars['Int'];
  /** Number of times Zap run resulted in throttled status */
  throttled?: Maybe<Scalars['Int']>;
  /** Number of times Zap run resulted in unknown status */
  unknown?: Maybe<Scalars['Int']>;
};

export type Tasks = LimitOffsetConnection & {
  __typename?: 'Tasks';
  edges: Array<Task>;
  pageInfo: LimitOffsetPageInfo;
  totalActionable: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** Trend of Task Usage by interval */
export type AccountTaskUsageTrend = {
  __typename?: 'AccountTaskUsageTrend';
  /** Number of billable tasks */
  billableTasksCount: Scalars['Int'];
  /** Interval of breakdown rollup */
  interval: TaskAggregationInterval;
  /** Total usage rolled up by status */
  statusAggregation: RunStatusAggregation;
  /** Usage rolled up by interval */
  tasksBreakdown: Array<TaskStatusDay>;
  /** Total number of runs */
  totalRunCount: Scalars['Int'];
  /**
   * Total number of runs (NOT TASKS BEWARE!!)
   * @deprecated Use totalRunCount instead
   */
  totalTasksCount: Scalars['Int'];
};

export enum TaskAggregationInterval {
  Daily = 'daily',
  Monthly = 'monthly',
  Yearly = 'yearly',
}

/** Represents a single day of Zap runs broken down by status */
export type TaskStatusDay = {
  __typename?: 'TaskStatusDay';
  date: Scalars['String'];
  statuses: RunStatusAggregation;
};

/** Represents a team structure inside of an account (different from a 'Teams' plan) */
export type Team = {
  __typename?: 'Team';
  /** Team avatar image url */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Current user's membership status for this team */
  currentUserStatus: TeamMembershipStatus;
  /** Team Description */
  description?: Maybe<Scalars['String']>;
  /** Team Id */
  id: Scalars['ID'];
  /** Total count of team members */
  memberCount: Scalars['Int'];
  /** First four team members for team preview */
  memberPreview: Array<TeamMember>;
  /** Paged listing of team member requests */
  memberRequests?: Maybe<TeamMemberRequests>;
  /** Paged listing of team members with optional search string */
  members?: Maybe<TeamMembers>;
  /** Team Name */
  name: Scalars['String'];
  /** The owner of the team */
  owner?: Maybe<TeamOwner>;
};

/** Represents a team structure inside of an account (different from a 'Teams' plan) */
export type TeamMemberRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

/** Represents a team structure inside of an account (different from a 'Teams' plan) */
export type TeamMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export enum TeamMembershipStatus {
  Member = 'member',
  None = 'none',
  Owner = 'owner',
  RequestedAccess = 'requestedAccess',
}

/** Represents a user's membership into a Team */
export type TeamMember = {
  __typename?: 'TeamMember';
  /**
   * Team member avatar url
   * @deprecated use imageUrl instead
   */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Team Member email address */
  description: Scalars['String'];
  /**
   * Team Member email address
   * @deprecated use description instead
   */
  email: Scalars['String'];
  /** ID of Team Membership (not the member) */
  id: Scalars['ID'];
  /** Member image URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** Team Member Name */
  name: Scalars['String'];
  /** Member type */
  type: ShareMemberType;
  /** Custom user id of the Team Member */
  userId: Scalars['ID'];
};

export type TeamMemberRequests = LimitOffsetConnection & {
  __typename?: 'TeamMemberRequests';
  edges: Array<TeamMemberRequest>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export type TeamMemberRequest = {
  __typename?: 'TeamMemberRequest';
  /** Team Member email address */
  description: Scalars['String'];
  /** ID of Team Member Request (not the member) */
  id: Scalars['ID'];
  /** Member image URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** Team Member Name */
  name: Scalars['String'];
  /** Custom user id of the Team Member */
  userId: Scalars['ID'];
};

export type TeamMembers = LimitOffsetConnection & {
  __typename?: 'TeamMembers';
  edges: Array<TeamMember>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export type TeamOwner = {
  __typename?: 'TeamOwner';
  /** Team Owner's Email */
  email: Scalars['String'];
  /** Team Owner's ID */
  id: Scalars['Int'];
  /** Team Owner's Avatar Url */
  imageUrl?: Maybe<Scalars['String']>;
  /** Team Owner's Name */
  name: Scalars['String'];
};

export type Teams = LimitOffsetConnection & {
  __typename?: 'Teams';
  edges: Array<Team>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** Represents a user and their usage stats */
export type UserWithStats = {
  __typename?: 'UserWithStats';
  /** User's email address */
  email: Scalars['String'];
  /** User Id */
  id: Scalars['ID'];
  /** User's image URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** User's name */
  name: Scalars['String'];
  /** User's usage statistics */
  stats: UserStats;
};

/** User Usage Stats */
export type UserStats = {
  __typename?: 'UserStats';
  /** Number of hours saved using Zapier */
  hoursSaved: Scalars['Int'];
  /** Number of active Zaps user has */
  liveZaps: Scalars['Int'];
  /** Number of paused Zaps user has */
  pausedZaps: Scalars['Int'];
};

/** Top Zap report */
export type TopZap = {
  __typename?: 'TopZap';
  id: Scalars['ID'];
  /** The last time the Zap ran */
  lastRun: Scalars['String'];
  /** Usage data for zap */
  tasks: TopZapTasks;
  /**
   * Zap record
   * @deprecated use zapV2 instead
   */
  zap: Zap;
  /** Owner of Zap */
  zapOwner?: Maybe<Member>;
  /** Zap record */
  zapV2: ZapV2;
};

/** Deprecated: use ZapV2 instead */
export type Zap = {
  __typename?: 'Zap';
  folderIds: Array<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isShared: Scalars['Boolean'];
  /** Zap's type ('workflow' or 'transfer') */
  kind?: Maybe<Scalars['String']>;
  lastchanged: Scalars['String'];
  /** List of nodes on the Zap */
  nodes: Array<ZapNode>;
  owner?: Maybe<Owner>;
  title?: Maybe<Scalars['String']>;
};

export type Owner = {
  __typename?: 'Owner';
  code?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type TopZaps = LimitOffsetConnection & {
  __typename?: 'TopZaps';
  edges: Array<TopZapV2>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** Top Zap report */
export type TopZapV2 = {
  __typename?: 'TopZapV2';
  id: Scalars['ID'];
  /** The last time the Zap ran */
  lastRun: Scalars['String'];
  /** Usage data for zap */
  tasks: RunStatusAggregation;
  /** Owner of Zap */
  zapOwner?: Maybe<Member>;
  /** Zap record */
  zapV2: ZapV2;
};

/** Represents usage stats for an Account */
export type AccountUsage = {
  __typename?: 'AccountUsage';
  hoursSaved: Scalars['Int'];
  periodEnd: Scalars['String'];
  periodReset: Scalars['String'];
  periodStart: Scalars['String'];
  tasks: AccountTaskUsage;
  zaps: AccountZapUsage;
};

/** Task usage stats */
export type AccountTaskUsage = {
  __typename?: 'AccountTaskUsage';
  limit: Scalars['Int'];
  total: Scalars['Int'];
};

/** Zap usage stats */
export type AccountZapUsage = {
  __typename?: 'AccountZapUsage';
  draft: Scalars['Int'];
  limit: Scalars['Int'];
  off: Scalars['Int'];
  on: Scalars['Int'];
  total: Scalars['Int'];
};

export type DateRangeType = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type Activities = LimitOffsetConnection & {
  __typename?: 'activities';
  edges: Array<AuditLogActivity>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** Activties that populate a Zap's audit log */
export type AuditLogActivity = {
  __typename?: 'AuditLogActivity';
  /** Action type, eg zap.switched_on or zap.deleted */
  action: Scalars['String'];
  /** Customuser that is responsible for this activity */
  actor?: Maybe<Member>;
  /** When this activity happened */
  dateTime: Scalars['String'];
  /** Plain text representing what happened in this activity */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Customuser that is responsible for this activity
   * @deprecated Use actor instead
   */
  user: AuditLogActivityOwner;
};

export type AuditLogActivityOwner = {
  __typename?: 'AuditLogActivityOwner';
  email: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
};

/**
 * The marketing aspect of an app, intended for the app directory. You don't
 * want this if you are using the editor, look at Service (or maybe a future
 * Implementation type).
 */
export type App = {
  __typename?: 'App';
  ageInDays?: Maybe<Scalars['Int']>;
  appUrl?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<ServiceCategory>>>;
  daysSinceLastUpdate?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  hashtag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Scalars['GenericScalar']>;
  integrationOverviewHtml?: Maybe<Scalars['String']>;
  inviteUrl?: Maybe<Scalars['String']>;
  isBeta?: Maybe<Scalars['Boolean']>;
  isBuiltIn?: Maybe<Scalars['Boolean']>;
  isFeatured?: Maybe<Scalars['Boolean']>;
  isPremium?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isUpcoming?: Maybe<Scalars['Boolean']>;
  learnMoreUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Only valid for the singular app query. */
  pairedApps?: Maybe<Array<Maybe<PairedApp>>>;
  popularity?: Maybe<Scalars['Int']>;
  primaryColor?: Maybe<Scalars['String']>;
  requestCount?: Maybe<Scalars['Int']>;
  service?: Maybe<Service>;
  /** Also known as selected_api internally. */
  serviceId?: Maybe<Scalars['String']>;
  sharingTags?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  zapUsageCount?: Maybe<Scalars['Int']>;
};

/**
 * The marketing aspect of an app, intended for the app directory. You don't
 * want this if you are using the editor, look at Service (or maybe a future
 * Implementation type).
 */
export type AppPairedAppsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type ServiceCategory = {
  __typename?: 'ServiceCategory';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['ID']>;
};

export type PairedApp = {
  __typename?: 'PairedApp';
  ageInDays?: Maybe<Scalars['Int']>;
  appUrl?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<ServiceCategory>>>;
  daysSinceLastUpdate?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  hashtag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Scalars['GenericScalar']>;
  integrationOverviewHtml?: Maybe<Scalars['String']>;
  inviteUrl?: Maybe<Scalars['String']>;
  isBeta?: Maybe<Scalars['Boolean']>;
  isBuiltIn?: Maybe<Scalars['Boolean']>;
  isFeatured?: Maybe<Scalars['Boolean']>;
  isPremium?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isUpcoming?: Maybe<Scalars['Boolean']>;
  learnMoreUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Only valid for the singular app query. */
  pairedApps?: Maybe<Array<Maybe<PairedApp>>>;
  pairIntegrations?: Maybe<Scalars['Int']>;
  popularity?: Maybe<Scalars['Int']>;
  primaryColor?: Maybe<Scalars['String']>;
  requestCount?: Maybe<Scalars['Int']>;
  service?: Maybe<Service>;
  /** Also known as selected_api internally. */
  serviceId?: Maybe<Scalars['String']>;
  sharingTags?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  zapUsageCount?: Maybe<Scalars['Int']>;
};

export type PairedAppPairedAppsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/**
 * This is a rather difficult "combo" type, where the data is backed
 * by both snapbook.Server and registry.Implementation via
 * the special engine.registry ORM.
 *
 * See the alternative App (and maybe a future Implementation) types
 * for the respective broken apart (easier and faster) interfaces.
 */
export type Service = {
  __typename?: 'Service';
  actions?: Maybe<ServiceActionTypes>;
  ageInDays?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['Int']>;
  appUrl?: Maybe<Scalars['String']>;
  authType?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<ServiceCategory>>>;
  daysSinceLastUpdate?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  hasFilters?: Maybe<Scalars['Boolean']>;
  hashtag?: Maybe<Scalars['String']>;
  hasReads?: Maybe<Scalars['Boolean']>;
  hasSearches?: Maybe<Scalars['Boolean']>;
  hasSearchesOrWrites?: Maybe<Scalars['Boolean']>;
  hasUpfrontFields?: Maybe<Scalars['Boolean']>;
  hasWrites?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Scalars['GenericScalar']>;
  integrationOverviewHtml?: Maybe<Scalars['String']>;
  inviteUrl?: Maybe<Scalars['String']>;
  isBeta?: Maybe<Scalars['Boolean']>;
  isBuiltIn?: Maybe<Scalars['Boolean']>;
  isDeprecated?: Maybe<Scalars['Boolean']>;
  isFeatured?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isInvite?: Maybe<Scalars['Boolean']>;
  isPremium?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isUpcoming?: Maybe<Scalars['Boolean']>;
  learnMoreUrl?: Maybe<Scalars['String']>;
  metaServiceUpdates?: Maybe<Array<Maybe<MetaServiceUpdate>>>;
  name?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['Int']>;
  primaryColor?: Maybe<Scalars['String']>;
  requestCount?: Maybe<Scalars['Int']>;
  serviceId?: Maybe<Scalars['Int']>;
  sharingTags?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  zapUsageCount?: Maybe<Scalars['Int']>;
};

/**
 * This is a rather difficult "combo" type, where the data is backed
 * by both snapbook.Server and registry.Implementation via
 * the special engine.registry ORM.
 *
 * See the alternative App (and maybe a future Implementation) types
 * for the respective broken apart (easier and faster) interfaces.
 */
export type ServiceMetaServiceUpdatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ServiceActionTypes = {
  __typename?: 'ServiceActionTypes';
  filters?: Maybe<Array<Maybe<ServiceAction>>>;
  reads?: Maybe<Array<Maybe<ServiceReadAction>>>;
  searches?: Maybe<Array<Maybe<ServiceAction>>>;
  searchesOrWrites?: Maybe<Array<Maybe<ServiceSearchOrWriteAction>>>;
  writes?: Maybe<Array<Maybe<ServiceAction>>>;
};

export type ServiceAction = {
  __typename?: 'ServiceAction';
  helpText?: Maybe<Scalars['String']>;
  helpTextHtml?: Maybe<Scalars['String']>;
  hide?: Maybe<Scalars['Boolean']>;
  important?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  needs?: Maybe<Scalars['GenericScalar']>;
  noun?: Maybe<Scalars['String']>;
  typeOf?: Maybe<Scalars['String']>;
};

export type ServiceReadAction = {
  __typename?: 'ServiceReadAction';
  bulkAction?: Maybe<Scalars['String']>;
  helpText?: Maybe<Scalars['String']>;
  helpTextHtml?: Maybe<Scalars['String']>;
  hide?: Maybe<Scalars['Boolean']>;
  hookDirectionsHtml?: Maybe<Scalars['String']>;
  hookLegacyUrl?: Maybe<Scalars['String']>;
  hookUrl?: Maybe<Scalars['String']>;
  important?: Maybe<Scalars['Boolean']>;
  isHook?: Maybe<Scalars['Boolean']>;
  isHookNotification?: Maybe<Scalars['Boolean']>;
  isHookPollable?: Maybe<Scalars['Boolean']>;
  isHookSubscription?: Maybe<Scalars['Boolean']>;
  isHookToPoll?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  needs?: Maybe<Scalars['GenericScalar']>;
  noun?: Maybe<Scalars['String']>;
  typeOf?: Maybe<Scalars['String']>;
};

export type ServiceSearchOrWriteAction = {
  __typename?: 'ServiceSearchOrWriteAction';
  helpText?: Maybe<Scalars['String']>;
  helpTextHtml?: Maybe<Scalars['String']>;
  hide?: Maybe<Scalars['Boolean']>;
  important?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  needs?: Maybe<Scalars['GenericScalar']>;
  noun?: Maybe<Scalars['String']>;
  searchDelegate?: Maybe<Scalars['String']>;
  typeOf?: Maybe<Scalars['String']>;
  writeDelegate?: Maybe<Scalars['String']>;
};

export type MetaServiceUpdate = {
  __typename?: 'MetaServiceUpdate';
  blogPost?: Maybe<BlogPost>;
  update?: Maybe<Update>;
};

/** For best results, name fields the same as in api.schema.service.types.Update */
export type BlogPost = {
  __typename?: 'BlogPost';
  author?: Maybe<UserAuthorType>;
  categories?: Maybe<Array<Maybe<Category>>>;
  date?: Maybe<Scalars['UTCDateTime']>;
  excerptHtml?: Maybe<Scalars['String']>;
  excerptText?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Scalars['GenericScalar']>;
  lastChangedDate?: Maybe<Scalars['UTCDateTime']>;
  matchedServices?: Maybe<Array<Maybe<App>>>;
  publishedDate?: Maybe<Scalars['UTCDateTime']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  services?: Maybe<Array<Maybe<App>>>;
  sharingTags?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Useful for by-lines of the User variety */
export type UserAuthorType = {
  __typename?: 'UserAuthorType';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Category = {
  __typename?: 'Category';
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** For best results, name fields the same as in ..blog.types.BlogPost */
export type Update = {
  __typename?: 'Update';
  author?: Maybe<AuthorType>;
  date?: Maybe<Scalars['UTCDateTime']>;
  excerptHtml?: Maybe<Scalars['String']>;
  excerptText?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Scalars['GenericScalar']>;
  sharingTags?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Useful for by-lines of the CustomUser variety */
export type AuthorType = {
  __typename?: 'AuthorType';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AppV2 = {
  __typename?: 'AppV2';
  /** How many days ago was this app added to Zapier. */
  ageInDays: Scalars['Int'];
  /** Returns alternatives for a given app slug. */
  appAlternatives: AppAlternativeConnection;
  /** The URL for the Zapier app profile page of this app. Replaces 'appUrl' from ThickServiceQuery. */
  appProfileUrl: Scalars['String'];
  appRequests: Array<AppRequest>;
  /**
   * The type of authentication this app requires. Can be "oauth" or "other" or null.
   * * This comes from the implementation so if you request it the implementation will be fetched *
   */
  authType?: Maybe<Scalars['String']>;
  /** The "banner" to display for this app. Can be "premium", "beta", etc. Can also be an empty string. */
  banner: Scalars['String'];
  /**
   * Will be true if connections can be made to this app
   * (otherwise no auth is required)
   */
  canConnect: Scalars['Boolean'];
  /** The canonical ID of this app. */
  canonicalId: Scalars['String'];
  /** This is true if the app has the capability to lookup a user's profile information using a 3rd party's API, false otherwise. */
  canProvideProfile: Scalars['Boolean'];
  /** The categories associated with this app. */
  categories: Array<AppV2Category>;
  currentImplementation?: Maybe<AppImplementation>;
  /** The current_implementation_id of this App */
  currentImplementationId?: Maybe<Scalars['String']>;
  currentImplementationMeta?: Maybe<AppImplementationMeta>;
  /** A description of this app. */
  description: Scalars['String'];
  /** Get all of the discover zap template groups associated with this app. */
  discoverZapTemplateGroups: ZapTemplateGroupsConnection;
  /** The official URL of this app. E.g. the typeform app would have url "https://www.typeform.com/". Replaces 'url' from ThickServiceQuery. */
  externalUrl?: Maybe<Scalars['String']>;
  hashtag?: Maybe<Scalars['String']>;
  /** Does this app has a stale auth */
  hasStaleAuth?: Maybe<Scalars['Boolean']>;
  /** The ID of this app. */
  id: Scalars['ID'];
  /** A url pointing to the high-resolution version of this app's logo. */
  image?: Maybe<Scalars['String']>;
  /** An object containing 4 different sizes of the app logo. */
  images?: Maybe<AppImages>;
  /**
   * A blob of HTML used for SEO on the /apps pages.
   * @deprecated Use integrationOverviewHtmlAst instead.
   */
  integrationOverview?: Maybe<Scalars['DeprecatedHTML']>;
  /** A blob of HTML used for SEO on the /apps pages, in AST format. */
  integrationOverviewHtmlAst?: Maybe<Scalars['HTMLAST']>;
  /**
   * DO NOT USE THIS FIELD. It's only here for compatibility purposes with the old `service`/`services` queries that existed before the App/AppImplementation types existed.
   * @deprecated DO NOT rely on this field. Use the id field instead.
   */
  internalId: Scalars['Int'];
  /**
   * URL to invite yourself to the private implementation of this App.
   * This is typically used when we want to signify that an App is in "Early Access" stage.
   * Note that apps that have an inviteUrl are not guaranteed to have an implementation associated with it yet.
   */
  inviteUrl?: Maybe<Scalars['String']>;
  /** Is this app in beta? */
  isBeta: Scalars['Boolean'];
  /** Is this app a built-in app? */
  isBuiltIn: Scalars['Boolean'];
  /** Is this app a featured app? */
  isFeatured: Scalars['Boolean'];
  /** Is this app premium? */
  isPremium: Scalars['Boolean'];
  /**
   * Is this app public?
   * @deprecated Every app is public, so this field always evaluates to True, which makes it superfluous.
   */
  isPublic: Scalars['Boolean'];
  /** Is this app an upcoming app? */
  isUpcoming: Scalars['Boolean'];
  /** The date on which this app was added to Zapier, in UTC format. */
  launchDate: Scalars['String'];
  /** An URL where you can learn more about this app. */
  learnMoreUrl?: Maybe<Scalars['String']>;
  /** Returns media for a given app. */
  media: Array<AppMedia>;
  /** Returns meta-updates for this app. */
  metaUpdates: AppMetaUpdatesConnection;
  /** The name of this app. */
  name: Scalars['String'];
  /**
   * Returns a list of apps that are commonly paired with this one.
   * Excludes any of the built-in ("by Zapier") apps.
   */
  pairedApps: Array<AppPairing>;
  /** The status of the Partner associated with this App. */
  partnerStatus?: Maybe<PartnerStatus>;
  /** The popularity rank of this app. */
  popularity: Scalars['Int'];
  pricingPlans: Array<AppPricingPlan>;
  /** The primary color used to represent this app. */
  primaryColor?: Maybe<Scalars['String']>;
  /** The number of people who have requested this app to be added to Zapier. Only applies to apps that are 'isUpcoming: true'. Defaults to 0, if not applicable. */
  requestCount: Scalars['Int'];
  /** Returns our review of this app, if available. */
  reviewPage?: Maybe<AppReviewPage>;
  /** Selected API will be available for custom integrations */
  selectedApi?: Maybe<Scalars['String']>;
  /** Used for SEO. Sharing meta tags to add to the '/apps' page of an app. */
  sharingTags?: Maybe<Scalars['String']>;
  /** The slug that represents this app. The 'slug' is also what we typically use as a natural key. */
  slug: Scalars['String'];
  /**
   * Returns a list of apps and total count of apps that are commonly paired with this one.
   * Excludes any of the built-in ("by Zapier") apps.
   */
  totalPairedApps?: Maybe<PairedApps>;
  /** Get all of the app tutorials associated with this app. */
  tutorials: TutorialsConnection;
  /**
   * Returns the total count of ZTs which feature this app.
   * Optionally filter the ZTs by an inclusive list of additional featured app slugs.
   */
  zapTemplatesCount: Scalars['Int'];
  /** The number of Zaps that use this app. */
  zapUsageCount: Scalars['Int'];
};

export type AppV2AppAlternativesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AppV2AppRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type AppV2DiscoverZapTemplateGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  secondaryAppSlug?: InputMaybe<Scalars['String']>;
};

export type AppV2MediaArgs = {
  slug?: InputMaybe<Scalars['String']>;
};

export type AppV2MetaUpdatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AppV2PairedAppsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  targetAppSlugs?: InputMaybe<Array<Scalars['String']>>;
};

export type AppV2PricingPlansArgs = {
  slug?: InputMaybe<Scalars['String']>;
};

export type AppV2TotalPairedAppsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  targetAppSlugs?: InputMaybe<Array<Scalars['String']>>;
};

export type AppV2TutorialsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AppV2ZapTemplatesCountArgs = {
  featuringAllAdditionalAppSlugs?: InputMaybe<
    Array<InputMaybe<Scalars['String']>>
  >;
};

export type AppAlternativeConnection = LimitOffsetConnection & {
  __typename?: 'AppAlternativeConnection';
  edges: Array<AppAlternative>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export type AppAlternative = {
  __typename?: 'AppAlternative';
  /** Information describing the details of the app alternative */
  app: AppV2;
  /** The total number of CommentVotes with a comment. */
  comments: Scalars['Int'];
  /** CommentVote a vote and/or comment for or against this alternative. */
  commentVotes: Array<CommentVote>;
  /** The slug of the App proposed as an alternative. */
  comparison: Scalars['String'];
  /** The primary key of the app alternative. */
  id: Scalars['Int'];
  /** Sum of count of votes for minus sum of votes against this alternative. */
  score: Scalars['Int'];
};

export type CommentVote = {
  __typename?: 'CommentVote';
  /** The comment string. */
  comment: Scalars['String'];
  /** The date the comment was created. */
  createdAt: Scalars['String'];
  /** The primary key of the Comment Vote. */
  id: Scalars['Int'];
  /** The author of the comment. */
  user: CommentAuthor;
  /** The vote for this alternative. */
  vote: Scalars['Boolean'];
};

export type CommentAuthor = {
  __typename?: 'CommentAuthor';
  /** The gravatar of the author */
  image: Scalars['String'];
  /** The name of the author */
  name?: Maybe<Scalars['String']>;
};

export type AppRequest = {
  __typename?: 'AppRequest';
  /** Comment submitted */
  comment: Scalars['String'];
  /** Company of the requester */
  company?: Maybe<Scalars['String']>;
  /** Date of creation */
  createdAt: Scalars['String'];
  /** Id of the AppRequest */
  id: Scalars['ID'];
  /** First + Last name of the requester */
  name: Scalars['String'];
  /** Thumbnail photo of the requester */
  photoUrl: Scalars['String'];
};

export type AppV2Category = {
  __typename?: 'AppV2Category';
  /** Returns apps associated with a category. */
  apps: AppsConnection;
  description: Scalars['String'];
  /** Returns featured apps associated with a category. */
  featuredApps: AppsConnection;
  /** A featured blog entry or customer story. */
  featuredEntry?: Maybe<BlogPostV2>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Returns apps paired with apps in these categories. */
  pairedApps: AppsConnection;
  role?: Maybe<AppCategoryRole>;
  slug: Scalars['ID'];
  /** Returns subcategories of a category. */
  subCategories: AppCategoryConnection;
  typeOf: CategoryType;
};

export type AppV2CategoryAppsArgs = {
  filterByOtherCategorySlug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  nameContains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AppSortOrder>;
};

export type AppV2CategoryFeaturedAppsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AppSortOrder>;
};

export type AppV2CategoryPairedAppsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AppV2CategorySubCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum AppSortOrder {
  Actionadded = 'ACTIONADDED',
  Alphabetical = 'ALPHABETICAL',
  Created = 'CREATED',
  Popularity = 'POPULARITY',
  Recent = 'RECENT',
}

export type AppsConnection = LimitOffsetConnection & {
  __typename?: 'AppsConnection';
  edges: Array<AppV2>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export type BlogPostV2 = {
  __typename?: 'BlogPostV2';
  /** The post author */
  author: BlogAuthorV2;
  /** The category to use if building a URL with this blog post. */
  canonicalCategory?: Maybe<BlogPostCategoryV2>;
  /** Categories associated with the blog post */
  categories?: Maybe<Array<BlogPostCategoryV2>>;
  /**
   * An excerpt is a shortened version of the html
   * @deprecated Create an HTMLAST field or a number of normalized data fields instead.
   */
  excerptHtml: Scalars['DeprecatedHTML'];
  /** Same as above, but with HTML removed */
  excerptText: Scalars['String'];
  /**
   * The HTML content of the post
   * @deprecated Create an HTMLAST field or a number of normalized data fields instead.
   */
  html: Scalars['DeprecatedHTML'];
  /** The HTML content of the post, in AST format. */
  htmlAst: Scalars['HTMLAST'];
  /** The primary key of the blog post */
  id: Scalars['ID'];
  /** The hero image of the post */
  image: Scalars['String'];
  /** Images associated with the blog post */
  images: BlogImage;
  /** The date the post was last changed */
  lastChangedDate: Scalars['String'];
  /** The URL of the post itself on Zapier */
  postUrl: Scalars['String'];
  /**
   * The primary service associated with the blog post, if it exists. Some posts are about things like productivity
   * and don't have any services associated with them.
   * Example: Twitter for an app tutorial about twitter.
   */
  primaryService?: Maybe<AppV2>;
  /** The date the post was published */
  publishedDate: Scalars['String'];
  /** The read time in minutes, formatted mm:ss, of the blog post. */
  readTimeMinutes?: Maybe<Scalars['String']>;
  /** Apps linked to this blog post */
  services: Array<Maybe<AppV2>>;
  /**
   * The sharing tags (Facebook, Twitter, etc) of the blog post
   * @deprecated Create an HTMLAST field or a number of normalized data fields instead.
   */
  sharingTags: Scalars['DeprecatedHTML'];
  /** The slug of the post */
  slug: Scalars['String'];
  /** The status of the blog post (published, draft, internal) used to determine index tags. */
  status: BlogPostStatus;
  /**
   * Structured data to display with the blog post. This data is used for SEO/SERP purposes to help
   * Google digest our page and display rich search results.
   */
  structuredData: ArticleStructuredData;
  /** The subtitle of the post */
  subtitle?: Maybe<Scalars['String']>;
  /** The title of the post */
  title: Scalars['String'];
  /** The API URL of the post */
  url: Scalars['String'];
};

export type BlogAuthorV2 = {
  __typename?: 'BlogAuthorV2';
  /** Long form text representing the authors biography */
  biography?: Maybe<Scalars['String']>;
  /** The email of the author */
  email: Scalars['String'];
  /** The primary key of the author */
  id: Scalars['Int'];
  /** The image of the author */
  image?: Maybe<Scalars['String']>;
  /** The name of the author */
  name: Scalars['String'];
  /** The Twitter handle of the author, no @ symbol */
  twitterUsername?: Maybe<Scalars['String']>;
};

export type BlogPostCategoryV2 = {
  __typename?: 'BlogPostCategoryV2';
  /** The description of the category. Markdown enabled. */
  body: Scalars['String'];
  /** The date the category was created. */
  date: Scalars['String'];
  /**
   * The rendered HTML of the body.
   * @deprecated Create an HTMLAST field or a number of normalized data fields instead.
   */
  html: Scalars['DeprecatedHTML'];
  /** The date the category was changed. */
  lastchanged: Scalars['String'];
  /** The slug of the category. */
  slug: Scalars['String'];
  /** The title of the category. */
  title: Scalars['String'];
};

export type BlogImage = {
  __typename?: 'BlogImage';
  /** A list of image URLs present in the blog post. This list can be empty if there are no images. */
  body?: Maybe<Array<Scalars['String']>>;
  /** The wide hero image to display at the top of the blog post. */
  hero: Scalars['String'];
  /** The square thumbnail of the blog post. */
  thumbnail: Scalars['String'];
};

export enum BlogPostStatus {
  /** Draft blog posts are visible to everyone, but not indexed by Google */
  Draft = 'draft',
  /** Internal blog posts are only visible to the company */
  Internal = 'internal',
  /** Published blog posts are visible to everyone, and indexed by Google */
  Published = 'published',
}

/** Structured data shows up in the head of the page and helps Google digest our site. */
export type ArticleStructuredData = {
  __typename?: 'ArticleStructuredData';
  /** Author of the article. */
  author: AuthorStructuredData;
  /** The date modified of the article. */
  dateModified: Scalars['String'];
  /** The date published of the article. */
  datePublished: Scalars['String'];
  /** The description of the article. */
  description: Scalars['String'];
  /** The headline of the article. */
  headline: Scalars['String'];
  /** Image(s) of the article. */
  image: Array<Scalars['String']>;
  /** The URL of the article. */
  mainEntityOfPage: Scalars['String'];
  /** Publishing information associated with the article. */
  publisher: PublisherStructuredData;
};

export type AuthorStructuredData = {
  __typename?: 'AuthorStructuredData';
  /** The full author name. */
  name: Scalars['String'];
};

export type PublisherStructuredData = {
  __typename?: 'PublisherStructuredData';
  /** The legal name of the publisher. */
  legalName: Scalars['String'];
  /** The logo of the publisher. */
  logo: Scalars['String'];
  /** The name of the publisher. */
  name: Scalars['String'];
  /** The URL of the publisher. */
  url: Scalars['String'];
};

/**
 * These category statuses correspond to the relationship of categories to other categories. There are certain situations where we'd only want to display child categories, parent categories, or other situations
 * where we don't care and just want all the categories.
 */
export enum AppCategoryRole {
  /** All categories, either parent or child. */
  All = 'all',
  /** A child category has a parent. */
  Child = 'child',
  /** A parent category has no children. */
  Parent = 'parent',
}

export type AppCategoryConnection = LimitOffsetConnection & {
  __typename?: 'AppCategoryConnection';
  edges: Array<AppV2Category>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** These category types correspond to how the category is generated and maintained. Curated categories are maintained by a human, auto categories are maintained by robots in a cron job, and other categories are manually created but not necessarily maintained. */
export enum CategoryType {
  Auto = 'auto',
  Curated = 'curated',
  Other = 'other',
}

/**
 * The AppImplementation is a read-only type that represents all the capabilities of an app's implementation for Zapier.
 * Note that actual Implementations might be built differently depending on the integration platform used by the developer, but
 * the `AppImplementation` type is the common interface that all of those platforms must expose for the user workflows of Zapier
 * to understand and consume them (the editor, the flow engine, the "make a zap" module in the home page, etc.).
 */
export type AppImplementation = {
  __typename?: 'AppImplementation';
  actions: AppImplementationActions;
  /** The type of authentication this app requires. Can be "oauth" or "other" or null. */
  authType?: Maybe<Scalars['String']>;
  /** Possible values: deprecated, beta, by-invite, premium, or empty string. */
  banner: Scalars['String'];
  /** The ID of this implementation. We use what's commonly known as 'selected_api' as the ID because it's guaranteed to be unique and never change. */
  id: Scalars['ID'];
  /** An object containing 4 different sizes of the app logo. */
  images?: Maybe<AppImages>;
  isBeta: Scalars['Boolean'];
  isDeprecated: Scalars['Boolean'];
  isInviteOnly: Scalars['Boolean'];
  isPremium: Scalars['Boolean'];
  isPrivateOnly: Scalars['Boolean'];
  /** The name of the app this implementation belongs to. */
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export type AppImplementationActions = {
  __typename?: 'AppImplementationActions';
  filters: Array<AppImplementationAction>;
  reads: Array<AppImplementationReadAction>;
  searches: Array<AppImplementationAction>;
  searchesOrWrites: Array<AppImplementationSearchOrWriteAction>;
  writes: Array<AppImplementationAction>;
};

export type AppImplementationAction = {
  __typename?: 'AppImplementationAction';
  helpText: Scalars['String'];
  /** @deprecated Use helpTextHtmlAst instead. */
  helpTextHtml: Scalars['DeprecatedHTML'];
  helpTextHtmlAst: Scalars['HTMLAST'];
  hide: Scalars['Boolean'];
  important: Scalars['Boolean'];
  key: Scalars['ID'];
  label: Scalars['String'];
  needs?: Maybe<Scalars['JSON']>;
  noun?: Maybe<Scalars['String']>;
  typeOf: Scalars['String'];
};

export type AppImplementationReadAction = {
  __typename?: 'AppImplementationReadAction';
  bulkAction?: Maybe<Scalars['String']>;
  helpText: Scalars['String'];
  /** @deprecated Use helpTextHtmlAst instead. */
  helpTextHtml: Scalars['DeprecatedHTML'];
  helpTextHtmlAst: Scalars['HTMLAST'];
  hide: Scalars['Boolean'];
  important: Scalars['Boolean'];
  isHook: Scalars['Boolean'];
  key: Scalars['ID'];
  label: Scalars['String'];
  needs?: Maybe<Scalars['JSON']>;
  noun?: Maybe<Scalars['String']>;
  typeOf: Scalars['String'];
};

export type AppImplementationSearchOrWriteAction = {
  __typename?: 'AppImplementationSearchOrWriteAction';
  helpText: Scalars['String'];
  /** @deprecated Use helpTextHtmlAst instead. */
  helpTextHtml: Scalars['DeprecatedHTML'];
  helpTextHtmlAst: Scalars['HTMLAST'];
  hide: Scalars['Boolean'];
  important: Scalars['Boolean'];
  key: Scalars['ID'];
  label: Scalars['String'];
  needs?: Maybe<Scalars['JSON']>;
  noun?: Maybe<Scalars['String']>;
  typeOf: Scalars['String'];
};

export type AppImages = {
  __typename?: 'AppImages';
  url_128x128: Scalars['String'];
  url_16x16: Scalars['String'];
  url_32x32: Scalars['String'];
  url_64x64: Scalars['String'];
};

/** Meta information associated with a particular AppImplementation */
export type AppImplementationMeta = {
  __typename?: 'AppImplementationMeta';
  ageInDays?: Maybe<Scalars['Int']>;
  /** The type of authentication this app requires. Can be "oauth" or "other" or null. */
  authType?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  categories: Array<AppV2Category>;
  hasFilters: Scalars['Boolean'];
  hasReads: Scalars['Boolean'];
  hasSearches: Scalars['Boolean'];
  hasSearchesOrWrites: Scalars['Boolean'];
  hasUpfrontFields: Scalars['Boolean'];
  hasWrites: Scalars['Boolean'];
  /** The ID of the implementation. We use what's commonly known as 'selected_api' as the ID because it's guaranteed to be unique and never change. */
  id: Scalars['ID'];
  isBeta: Scalars['Boolean'];
  isBuiltIn: Scalars['Boolean'];
  isDeprecated: Scalars['Boolean'];
  isFeatured: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isInvite: Scalars['Boolean'];
  isPremium: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  isUpcoming: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  popularity: Scalars['Int'];
  slug?: Maybe<Scalars['String']>;
};

export type ZapTemplateGroupsConnection = LimitOffsetConnection & {
  __typename?: 'ZapTemplateGroupsConnection';
  /** Named collection of ZapTemplates for an app */
  edges: Array<DiscoverZapTemplateGroup>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** A DiscoverZapTemplateGroup is a model which allows users to discover groups of Zap Templates. */
export type DiscoverZapTemplateGroup = {
  __typename?: 'DiscoverZapTemplateGroup';
  /** A long-form description of the group. */
  body: Scalars['String'];
  date: Scalars['String'];
  /** A short-form description of the group. */
  excerpt: Scalars['String'];
  id: Scalars['ID'];
  lastchanged: Scalars['String'];
  /** The title of the group. */
  name: Scalars['String'];
  /** All of the Zap Templates included in the group. */
  zapTemplates: Array<ZapTemplateV2>;
};

/** Represents a ZapTemplateV2, also known as a guided recipe. */
export type ZapTemplateV2 = {
  __typename?: 'ZapTemplateV2';
  /** The canonical ID of this Zap Template. */
  canonicalId: Scalars['String'];
  /**
   * Description of this Zap Template in HTML format.
   * @deprecated Use descriptionHtmlAst instead.
   */
  descriptionHtml: Scalars['DeprecatedHTML'];
  /** Description of this Zap Template in HTML AST format. */
  descriptionHtmlAst: Scalars['HTMLAST'];
  /**
   * The URL to the editor landing page for this Zap Template. From here you can
   * create a Zap based on this Zap Template.
   */
  editorUrl: Scalars['String'];
  /** The app used for the "head" (i.e. first step) of this Zap Template. */
  headService: ServiceV2;
  /** The unique ID of this Zap Template. */
  id: Scalars['ID'];
  /**
   * Labels based on GuidedRecipeRank entries.
   * These are used to determine ZTs for beginners, company ZTs and so on.
   */
  labels: Array<Maybe<Scalars['String']>>;
  /** Returns the first text paragraph of 'descriptionHtmlAst' */
  metaDescription?: Maybe<Scalars['String']>;
  /**
   * A list of all the apps used by steps in this Zap Template.
   * FIXME: is this an ordered list or not?
   */
  services: Array<ServiceV2>;
  /** A unique slug generated for this Zap Template, based on the title. */
  slug: Scalars['String'];
  /** The status of this Zap Template. */
  status: Scalars['String'];
  /** Labels used to render Zap Template previews */
  stepLabels: Array<ZapTemplateStepLabel>;
  /**
   * Metadata of the Zap steps that are part of this Zap Template.
   * Currently a JSON scalar but we should better define its shape!
   */
  steps: Scalars['JSON'];
  /** The app used for the "tail" (i.e. last step) of this Zap Template. */
  tailService: ServiceV2;
  /**
   * The ID of the root node of a Zap that is used as the "editor" of this ZT.
   * This Zap is used by the new ZT editor, where edits to the ZT can be made.
   * Nullable because it's only available for ZTs on the new ZT editor.
   */
  templateRootNodeId?: Maybe<Scalars['Int']>;
  /**
   * The title of this Zap Template, if any. May be empty or null if this is a brand new
   * Zap template.
   */
  title?: Maybe<Scalars['String']>;
  /** The URL to the SEO page of this Zap Template. */
  url: Scalars['String'];
};

export type ZapTemplateStepLabel = {
  __typename?: 'ZapTemplateStepLabel';
  /** The icon of the App involved with this step. */
  icon?: Maybe<Scalars['String']>;
  /** The id of the App involved with this step. */
  id: Scalars['ID'];
  /** The label describing what the step does. */
  label: Scalars['String'];
  /** The name of the App involved with this step. */
  name: Scalars['String'];
  /** The slug of the App involved with this step. */
  slug: Scalars['String'];
};

export type AppMedia = {
  __typename?: 'AppMedia';
  /** The caption */
  caption?: Maybe<Scalars['String']>;
  /** Timestamps */
  createdAt?: Maybe<Scalars['String']>;
  /** Whether the media is featured. */
  featured: Scalars['Boolean'];
  /** The primary key of the media. */
  id: Scalars['Int'];
  /** The tags on the media. */
  tags: Array<Scalars['String']>;
  /** The type of media - 'image' or 'video'. */
  type: MediaTypes;
  updatedAt?: Maybe<Scalars['String']>;
  /** The URL of the media. */
  url: Scalars['String'];
};

export enum MediaTypes {
  Image = 'IMAGE',
  Video = 'VIDEO',
}

export type AppMetaUpdatesConnection = LimitOffsetConnection & {
  __typename?: 'AppMetaUpdatesConnection';
  /** Edges can be null if an app has no tutorials. */
  edges?: Maybe<Array<AppMetaUpdate>>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/**
 * An App MetaUpdate represents recent information about an app that we want
 * to surface to our users. They can come from multiple sources, so we use an union
 * to represent it.
 */
export type AppMetaUpdate = AppIntegrationUpdate | BlogPostV2;

/**
 * An app integration update announcement that we publish when new features
 * are added to an app integration or if a new integration was just released.
 * See this doc for more details: https://zapier.quip.com/aTF0ArmPYXuZ/Updates-Posts-Process
 */
export type AppIntegrationUpdate = {
  __typename?: 'AppIntegrationUpdate';
  /** The update author */
  author: BlogAuthorV2;
  /** The datetime where this update was created. */
  date: Scalars['String'];
  /** A small excerpt of the contents of this update. */
  excerptText: Scalars['String'];
  id: Scalars['ID'];
  /** The hero image of the update */
  image: Scalars['String'];
  /** The images contained inside this update. */
  images: AppIntegrationUpdateImage;
  /** The URL of the dedicated page for this update. */
  postUrl: Scalars['String'];
  /** The slug of the update */
  slug: Scalars['String'];
  /** The title of this update. */
  title: Scalars['String'];
  /** The URL of the API JSON response for this update. */
  url: Scalars['String'];
};

/** Represents the images contained inside of an AppIntegration Update */
export type AppIntegrationUpdateImage = {
  __typename?: 'AppIntegrationUpdateImage';
  /**
   * A list of all images inside the body of this update. Can be an empty list if there
   * are no images in this update.
   */
  body: Array<Scalars['String']>;
  /** The hero image used in this update. Defaults to a placeholder image. */
  hero: Scalars['String'];
  /** The thumbnail of the hero image. Defaults to a placeholder image. */
  thumbnail: Scalars['String'];
};

export type AppPairing = {
  __typename?: 'AppPairing';
  app: AppV2;
  integrationsCount: Scalars['Int'];
};

export type PartnerStatus = {
  __typename?: 'PartnerStatus';
  /**
   * The end date of the current period (e.g. quarter) for the partner
   * to improve their integration. At which point we will evalulate
   * and consider upgrading/downgrading partners to the prev/next tier.
   */
  deadline?: Maybe<Scalars['String']>;
  /** The current tier the partner is in. */
  tier?: Maybe<PartnerTier>;
};

/**
 * All tiers available to a Partner. All partners start at BRONZE
 * and move up the ladder up to PLATINUM when they are a high quality
 * integration.
 */
export enum PartnerTier {
  Beta = 'BETA',
  Bronze = 'BRONZE',
  Gold = 'GOLD',
  Platinum = 'PLATINUM',
  Silver = 'SILVER',
}

export type AppPricingPlan = {
  __typename?: 'AppPricingPlan';
  /** The description of the pricing plan, optional. */
  description?: Maybe<Scalars['String']>;
  /** The list of features of the pricing plan. */
  features: Array<Scalars['String']>;
  /** The primary key of the app pricing plan */
  id: Scalars['Int'];
  /** If the pricing plan is active or not. */
  isActive: Scalars['Boolean'];
  /** The name of the pricing plan */
  name: Scalars['String'];
  /** The price of the pricing plan. */
  price: Scalars['String'];
  /** If the pricing plan is published or not. Do not display unpublished pricing plans. */
  published: Scalars['Boolean'];
  /** The unit of the pricing plan, optional. */
  unit?: Maybe<Scalars['String']>;
  /** The API URL of the pricing plan */
  url: Scalars['String'];
};

export type AppReviewPage = {
  __typename?: 'AppReviewPage';
  /** The author of this review */
  author: AppReviewAuthor;
  /**
   * Datetime when this review was published, in simplified extended ISO format
   * (`YYYY-MM-DDTHH:mm:ss.sssZ`). E.g.: 2018-04-20T13:00:00Z
   */
  date: Scalars['String'];
  /**
   * A list of features this app has, in HTML format.
   * @deprecated Use featuresHtmlAst instead.
   */
  featuresHtml: Scalars['DeprecatedHTML'];
  /** A list of features this app has, in HTMLAST format. */
  featuresHtmlAst: Scalars['HTMLAST'];
  /** A screenshot of this app to be used as the hero image of this review. */
  homepageScreenshot: AppReviewScreenshot;
  id: Scalars['ID'];
  /**
   * Datetime when this review was last changed, in simplified extended ISO format
   * (`YYYY-MM-DDTHH:mm:ss.sssZ`). E.g.: 2018-04-20T13:00:00Z
   */
  lastChanged: Scalars['String'];
  /** Some screenshots of this app in action. */
  photos: Array<AppReviewScreenshot>;
  /**
   * The description of the pricing scheme of this app, in HTML format.
   * @deprecated Use pricingHtmlAst instead.
   */
  pricingHtml: Scalars['DeprecatedHTML'];
  /** The description of the pricing scheme of this app, in HTMLAST format. */
  pricingHtmlAst: Scalars['HTMLAST'];
  /** The rating we gave to this app in our review. */
  rating?: Maybe<Scalars['Float']>;
  /**
   * The body of this review, in HTML format.
   * @deprecated Use reviewHtmlAst instead.
   */
  reviewHtml: Scalars['DeprecatedHTML'];
  /** The body of this review, in HTMLAST format. */
  reviewHtmlAst: Scalars['HTMLAST'];
  /** Other apps that are similar to this one. */
  similarApps?: Maybe<Array<AppV2>>;
};

export type AppReviewAuthor = {
  __typename?: 'AppReviewAuthor';
  id: Scalars['ID'];
  image: Scalars['String'];
  name: Scalars['String'];
};

export type AppReviewScreenshot = {
  __typename?: 'AppReviewScreenshot';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type PairedApps = {
  __typename?: 'PairedApps';
  appsPairing: Array<AppPairing>;
  count: Scalars['Int'];
};

export type TutorialsConnection = LimitOffsetConnection & {
  __typename?: 'TutorialsConnection';
  /** Edges can be null if an app has no tutorials. */
  edges?: Maybe<Array<BlogPostV2>>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** An application. */
export type Application = {
  __typename?: 'Application';
  /** The canonical ID of the application. */
  id: Scalars['ID'];
  /** Whether this is an upcoming application. */
  isUpcoming: Scalars['Boolean'];
  /** The legacy ID of the application. */
  legacyId: Scalars['Int'];
  /** The name of the application. */
  name: Scalars['String'];
  /** The slug that represents this application. */
  slug: Scalars['String'];
};

/** Represents an App recommendation for a user. */
export type AppRecommendation = {
  __typename?: 'AppRecommendation';
  /** Current implementation Id */
  currentImplementationId: Scalars['ID'];
  /** The ID of this recommended app. */
  id: Scalars['ID'];
  /** A url pointing to the high-resolution version of this app's logo. */
  image?: Maybe<Scalars['String']>;
  /** Whether or not the app is considered premium. */
  isPremium: Scalars['Boolean'];
  /** The name of this app. */
  name: Scalars['String'];
  /** The slug of this recommended app. */
  slug: Scalars['String'];
};

export type Authentication = {
  __typename?: 'Authentication';
  id?: Maybe<Scalars['ID']>;
  isStale?: Maybe<Scalars['Boolean']>;
  selectedApi?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AuthenticationV2Connection = LimitOffsetConnection & {
  __typename?: 'AuthenticationV2Connection';
  edges: Array<AuthenticationV2>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export type BanditRecommendation = {
  __typename?: 'BanditRecommendation';
  /** The id of the recommended result */
  id?: Maybe<Scalars['ID']>;
  /** The identity of the user for the recommendation */
  identity: Scalars['ID'];
  /** Name of the experiment */
  name: Scalars['String'];
  /** List of recommendations generated by Bandit for the experiment */
  recommendation: Array<Scalars['String']>;
  /** Date at which recommendation was reported successful */
  successAt?: Maybe<Scalars['String']>;
};

export type BlogPostConnection = LimitOffsetConnection & {
  __typename?: 'BlogPostConnection';
  /** Edges can be null based on the filtering parameters provided. */
  edges?: Maybe<Array<BlogPostV2>>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** Represents a currency supported on Zapier.com */
export type Currency = {
  __typename?: 'Currency';
  /** The country icon to display alongside the currency. */
  icon: Scalars['String'];
  /** The ID of this currency. */
  id: Scalars['ID'];
  /**
   * To determine the value of a price in another currency, take the USD value
   * and multiply it by this value.
   */
  multiplier: Scalars['Float'];
  /** Short form name of the currency. */
  name: Scalars['String'];
  /** Character symbol that represents the currency. */
  symbol: Scalars['String'];
  /** Whether or not the currency is zero-decimal/decimal-less */
  zeroDecimal: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']>;
  hasActiveZaps?: Maybe<Scalars['Boolean']>;
  hasGoogleSSO?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  identity?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  recommendedBlogPosts?: Maybe<Array<Maybe<BlogPost>>>;
  recommendedZapTemplates?: Maybe<ZapTemplatePaginatedList>;
  suggestedZapTemplateSortingAlgorithm?: Maybe<Scalars['String']>;
};

export type UserRecommendedBlogPostsArgs = {
  categorySlug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

export type UserRecommendedZapTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

export type ZapTemplatePaginatedList = {
  __typename?: 'ZapTemplatePaginatedList';
  edges?: Maybe<Array<Maybe<ZapTemplateEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ZapTemplateEdge = {
  __typename?: 'ZapTemplateEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ZapTemplate>;
};

export type ZapTemplate = {
  __typename?: 'ZapTemplate';
  activation?: Maybe<Scalars['Float']>;
  awesomeness?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  editorUrl?: Maybe<Scalars['String']>;
  headService?: Maybe<Service>;
  id?: Maybe<Scalars['ID']>;
  matchedServices?: Maybe<Array<Maybe<Service>>>;
  rank?: Maybe<Scalars['Int']>;
  services?: Maybe<Array<Maybe<Service>>>;
  sharingTags?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  steps?: Maybe<Scalars['GenericScalar']>;
  tailService?: Maybe<Service>;
  templateRootNodeId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Int']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
};

/** Represents a logged-in User of Zapier. */
export type UserV2 = {
  __typename?: 'UserV2';
  /** Frequency for user to be alerted when there is an issue with a Zap Action */
  alertActions: AlertTriggersAction;
  /** Frequency for user to be alerted when there is an issue with a Zap Trigger */
  alertTriggers: AlertTriggersAction;
  /** If the user was automatically provisioned via SCIM */
  autoProvisioned?: Maybe<Scalars['Boolean']>;
  /**
   * The site-wide banner message to display to all users, if any. The Support team
   * uses this banner as part of their incident response process. The banner content
   * is set via Rover: https://admin.zapier.com/rover/banner/
   */
  bannerMessage?: Maybe<Scalars['String']>;
  /** The account id this user is authenticated with. */
  currentAccountId: Scalars['String'];
  /** The email that this user used to sign up for Zapier. */
  email: Scalars['String'];
  /** The first name of this user. */
  firstName: Scalars['String'];
  /** The full name of this user. */
  fullName: Scalars['String'];
  /** Whether this user has any Zaps that are active. */
  hasActiveZaps: Scalars['Boolean'];
  /**
   * Whether this user has associated a Google account with their Zapier account.
   * These are typically users who logged in via Google single sign-on.
   */
  hasGoogleSSO: Scalars['Boolean'];
  /** A dictionary of profile notifications. */
  hasSeenNotifications: ProfileNotifications;
  /** The (customuser) ID of this user. */
  id: Scalars['ID'];
  /** Image Url for user avatar */
  imageUrl: Scalars['String'];
  /** True, only if the user is part of the Zapier developer platform. */
  isDeveloper: Scalars['Boolean'];
  /** True if the user has confirmed their email address */
  isEmailConfirmed: Scalars['Boolean'];
  /** True, only if the user is logged in. */
  isLoggedIn: Scalars['Boolean'];
  /** True if the user is currently masquerading as another user. */
  isMasquerade: Scalars['Boolean'];
  /** Disables encrypted communication between partners and zapier.com */
  isSslCheckDisabled?: Maybe<Scalars['Boolean']>;
  /** True, only if the user is a flagged as a Zapier staff memeber. */
  isStaff: Scalars['Boolean'];
  /** False, if the account's email is not a temporary email. */
  isTemporary: Scalars['Boolean'];
  /** True if user uses two factor authentication to log in */
  isTfaEnabled: Scalars['Boolean'];
  /** The last name of this user. */
  lastName: Scalars['String'];
  /** Token from user's last password reset */
  lastPasswordResetToken?: Maybe<Scalars['String']>;
  /** The recommendation profile of this user. It can be `null` when users have not gone through the onboarding flow and have not update their profile in settings to add Role and Organization. */
  recommendationProfile?: Maybe<RecommendationProfile>;
  /** Account Roles */
  roles: Array<AccountRole>;
  /** List of SSO Identites associated with user */
  ssoIdentities: Array<SsoIdentity>;
  /** Suggested apps for this user. */
  suggestedApps: Array<SuggestedApp>;
  /** Suggested zap templates for this user. */
  suggestedZapTemplates: Array<SuggestedZapTemplate>;
  /** Schedule to get a summary of the tasks Zapier has performed */
  summarySchedule: SummarySchedule;
  /** Whether this user is eligible for types of support. */
  supportEligibility: SupportEligibility;
  /** Gargoyle switch listing */
  switches: Scalars['JSON'];
  /** Id of the timezone the user set for themselves */
  timezoneId?: Maybe<Scalars['String']>;
};

export enum AlertTriggersAction {
  Always = 'always',
  Never = 'never',
  OnlyTrigger = 'only_trigger',
  Repeated = 'repeated',
}

export type ProfileNotifications = {
  __typename?: 'ProfileNotifications';
  jobsCta?: Maybe<Scalars['Boolean']>;
};

/** Represents a User's Profile. It's created during onboarding and contains information that is useful for personalization and it is, as of this writing, used to improve ZTs recommendations. */
export type RecommendationProfile = {
  __typename?: 'RecommendationProfile';
  /** The inferred name of the organization the user belongs to. */
  inferredOrganizationName?: Maybe<Scalars['String']>;
  /** The name of the organization this user belongs to. */
  organizationName?: Maybe<Scalars['String']>;
  /** The role of this user. */
  role?: Maybe<RecommendationProfileRole>;
  /** The id of the user's recommendation profile role */
  roleId?: Maybe<Scalars['ID']>;
};

/** Represents a User's role. This information is currently used to improve recommendations for this user. */
export type RecommendationProfileRole = {
  __typename?: 'RecommendationProfileRole';
  /** The canonical ID of the role. */
  canonicalId: Scalars['String'];
  /** The ID of the role. */
  id: Scalars['ID'];
  /** The name of the role. */
  name: Scalars['String'];
  /** The slug of the role. */
  slug?: Maybe<Scalars['String']>;
  /** Suggested apps for this role. */
  suggestedApps: SuggestedAppConnection;
  /** Suggested use cases for this role. */
  suggestedUseCases: SuggestedUseCaseConnection;
  /** Suggested zap templates for this role. */
  suggestedZapTemplates: SuggestedZapTemplateConnection;
};

/** Represents a User's role. This information is currently used to improve recommendations for this user. */
export type RecommendationProfileRoleSuggestedAppsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

/** Represents a User's role. This information is currently used to improve recommendations for this user. */
export type RecommendationProfileRoleSuggestedUseCasesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

/** Represents a User's role. This information is currently used to improve recommendations for this user. */
export type RecommendationProfileRoleSuggestedZapTemplatesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

/** A suggested App connection. */
export type SuggestedAppConnection = {
  __typename?: 'SuggestedAppConnection';
  /** Edges. */
  edges: Array<SuggestedApp>;
  /** Page info. */
  pageInfo: SuggestedAppPageInfo;
  /** The total number of results. */
  totalCount: Scalars['Int'];
};

/** A suggested App. */
export type SuggestedApp = {
  __typename?: 'SuggestedApp';
  /** The App's properties */
  app?: Maybe<AppV2>;
  /** The canonical ID of the suggested app. This is a system wide canonical ID. */
  appCanonicalId: Scalars['ID'];
};

/** Page info for suggested Apps. */
export type SuggestedAppPageInfo = {
  __typename?: 'SuggestedAppPageInfo';
  /** An opaque cursor for the next page of results (null if there are no more results). */
  nextCursor?: Maybe<Scalars['String']>;
  /** An opaque cursor for the previous page of results (null if this is the first page of results). */
  previousCursor?: Maybe<Scalars['String']>;
};

/** A suggested Use Case connection. */
export type SuggestedUseCaseConnection = {
  __typename?: 'SuggestedUseCaseConnection';
  /** Edges. */
  edges: Array<SuggestedUseCase>;
  /** Page info. */
  pageInfo: SuggestedUseCasePageInfo;
  /** The total number of results. */
  totalCount: Scalars['Int'];
};

/** A suggested Use Case. */
export type SuggestedUseCase = {
  __typename?: 'SuggestedUseCase';
  /** The Use Case. */
  useCase?: Maybe<UseCase>;
  /** The ID of the Use Case. */
  useCaseCanonicalId: Scalars['ID'];
};

/**
 * Use Case represents a task that the user wants to do.
 * E.g; Message my leads
 */
export type UseCase = {
  __typename?: 'UseCase';
  /** The canonical ID of the Use Case */
  canonicalId: Scalars['String'];
  /** Description of the Use Case */
  description: Scalars['String'];
  /** Name of the color in the design system to use for the UseCase's icon */
  iconColor: Scalars['String'];
  /** Name of the icon in the design system to use for the UseCase */
  iconName: Scalars['String'];
  /** The ID of this Use Case */
  id: Scalars['ID'];
  /** Slug of the Use Case */
  slug: Scalars['String'];
  /** Steps required to make this Use Case */
  steps: Array<UseCaseStep>;
  /** One-line summary of the Use Case */
  summaryLine: Scalars['String'];
  /** Title summarizing the Use Case */
  title: Scalars['String'];
  /** Number of active zaps of this Use Case */
  usedByCount: Scalars['Int'];
};

/**
 * Represents a step inside a given Use Case
 * E.g; Get leads from a source
 */
export type UseCaseStep = {
  __typename?: 'UseCaseStep';
  /** Actions required to complete a step */
  actions: UseCaseActions;
  /** Endpoint to fetch actions for this step */
  actionsUrl: Scalars['String'];
  /** Category representing app */
  appCategory: Scalars['String'];
  /** Get all actions for a specific app with no substring search */
  getUseCaseStepActions: Array<Maybe<UseCaseAction>>;
  /** The ID of this step */
  id: Scalars['ID'];
  /** Prompt representing the title of a step */
  prompt: Scalars['String'];
  /** Search all actions for a specific app */
  searchUseCaseActionsByAppName: Array<Maybe<UseCaseAction>>;
  /** Id of the Use Case this step belongs to */
  useCaseId: Scalars['ID'];
  /** Slug of the Use Case this step belongs to */
  useCaseSlug: Scalars['String'];
};

/**
 * Represents a step inside a given Use Case
 * E.g; Get leads from a source
 */
export type UseCaseStepActionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

/**
 * Represents a step inside a given Use Case
 * E.g; Get leads from a source
 */
export type UseCaseStepGetUseCaseStepActionsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  previousAppImplementationId?: InputMaybe<Scalars['String']>;
  previousKey?: InputMaybe<Scalars['String']>;
  previousStepId?: InputMaybe<Scalars['ID']>;
  stepId?: InputMaybe<Scalars['ID']>;
};

/**
 * Represents a step inside a given Use Case
 * E.g; Get leads from a source
 */
export type UseCaseStepSearchUseCaseActionsByAppNameArgs = {
  appNameContains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  previousAppImplementationId?: InputMaybe<Scalars['String']>;
  previousKey?: InputMaybe<Scalars['String']>;
  previousStepId?: InputMaybe<Scalars['ID']>;
  stepId?: InputMaybe<Scalars['ID']>;
};

export type UseCaseActions = CursorBasedConnection & {
  __typename?: 'UseCaseActions';
  /** List of Use Cases */
  edges: Array<UseCaseAction>;
  /** Current results page info including next and previous cursors */
  pageInfo: CursorBasedPageInfo;
  /** Total results available */
  totalCount: Scalars['Int'];
};

/** Implements a connection for a collection that is paginated via cursors. */
export type CursorBasedConnection = {
  /** Meta data for this page. */
  pageInfo: CursorBasedPageInfo;
  /** The total number of items in this collection. */
  totalCount: Scalars['Int'];
};

/** The type for the 'pageInfo' field on a CursorBasedConnection, which implements cursor-based pagination. */
export type CursorBasedPageInfo = {
  __typename?: 'CursorBasedPageInfo';
  /** Opaque cursor of the last item returned */
  endCursor: Scalars['String'];
  /** Is there another page after this one? */
  hasNextPage: Scalars['Boolean'];
  /** Is there a previous page before this one? */
  hasPreviousPage: Scalars['Boolean'];
  /** Opaque cursor of the first item returned */
  startCursor: Scalars['String'];
};

/**
 * Represents an action inside a step for a given Use Case
 * E.g; Fetch leads from Google Sheet
 */
export type UseCaseAction = {
  __typename?: 'UseCaseAction';
  /** App implementing this action */
  appImplementationId: Scalars['String'];
  /** App logo */
  appLogo: Scalars['String'];
  /** Name of the App */
  appName: Scalars['String'];
  /**
   * Key representing an app action.
   * Can be empty if action is not supported by the Use Case.
   */
  key?: Maybe<Scalars['String']>;
  /**
   * Name of the app action.
   * Can be empty if action is not supported by the Use Case.
   */
  name?: Maybe<Scalars['String']>;
};

/** Page info for suggested Use Cases. */
export type SuggestedUseCasePageInfo = {
  __typename?: 'SuggestedUseCasePageInfo';
  /** An opaque cursor for the next page of results (null if there are no more results). */
  nextCursor?: Maybe<Scalars['String']>;
  /** An opaque cursor for the previous page of results (null if this is the first page of results).  */
  previousCursor?: Maybe<Scalars['String']>;
};

/** A suggested Zap Template connection. */
export type SuggestedZapTemplateConnection = {
  __typename?: 'SuggestedZapTemplateConnection';
  /** Edges. */
  edges: Array<SuggestedZapTemplate>;
  /** Page info. */
  pageInfo: SuggestedZapTemplatePageInfo;
  /** The total number of results. */
  totalCount: Scalars['Int'];
};

/** A suggested Zap Template. */
export type SuggestedZapTemplate = {
  __typename?: 'SuggestedZapTemplate';
  /** The Zap Template. */
  zapTemplate?: Maybe<ZapTemplateV2>;
  /** The canonical ID of this ZapTemplate. This is a system wide canonical id. */
  zapTemplateCanonicalId: Scalars['ID'];
};

/** Page info for suggested Zap Templates. */
export type SuggestedZapTemplatePageInfo = {
  __typename?: 'SuggestedZapTemplatePageInfo';
  /** An opaque cursor for the next page of results (null if there are no more results). */
  nextCursor?: Maybe<Scalars['String']>;
  /** An opaque cursor for the previous page of results (null if this is the first page of results). */
  previousCursor?: Maybe<Scalars['String']>;
};

export type AccountRole = {
  __typename?: 'AccountRole';
  accountId: Scalars['ID'];
  role: MemberRole;
};

export type SsoIdentity = {
  __typename?: 'SSOIdentity';
  /** The email associated with the identity */
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** SSO Provider name */
  provider: Scalars['String'];
};

export enum SummarySchedule {
  Daily = 'daily',
  Never = 'never',
  Weekly = 'weekly',
}

export type SupportEligibility = {
  __typename?: 'SupportEligibility';
  /** Is this user eligible to email support? */
  isEmailSupportEligible: Scalars['Boolean'];
  /** Is this user eligible for onboarding chat? */
  isOnboardingChatEligible: Scalars['Boolean'];
  /** Is this user eligible to premier support? */
  isPremierSupportEligible: Scalars['Boolean'];
};

export enum HttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Invalid = 'INVALID',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
}

export type DebugResponse = {
  __typename?: 'DebugResponse';
  /** A message, if the response is 200-299 */
  message?: Maybe<Scalars['String']>;
};

export type DomainMembers = LimitOffsetConnection & {
  __typename?: 'DomainMembers';
  edges: Array<DomainMember>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export type DomainMember = {
  __typename?: 'DomainMember';
  /** Date member joined Zapier */
  dateJoined: Scalars['String'];
  /** Member's email address */
  email: Scalars['String'];
  id: Scalars['Int'];
  /** If member is a member of company account */
  isCompanyMember: Scalars['Boolean'];
  /** If the member has confirmed their email address */
  isEmailConfirmed: Scalars['Boolean'];
  /** If member has Mfa enabled on their account */
  isMfaEnabled: Scalars['Boolean'];
  /** Last time member logged into Zapier */
  lastLogin?: Maybe<Scalars['String']>;
  /** Member's task usage stat */
  taskUsage: Scalars['Int'];
};

/**
 * Combined Domain / DomainRequest shape
 * The backend models this as two different objects but we are modeling them
 * as the same object with two different statuses.
 */
export type Domain = {
  __typename?: 'Domain';
  /** Id of Account that owns Domain */
  accountId: Scalars['Int'];
  /**
   * Challenge text to be entered into DNS settings
   * (can be null if domain was created manually)
   */
  code?: Maybe<Scalars['String']>;
  /** Domain url */
  domain: Scalars['String'];
  /**
   * Domain id
   * (this can be null if there is a request but no domain yet)
   */
  domainId?: Maybe<Scalars['Int']>;
  /**
   * Id of the request to create the domain
   * (can be null if domain was created manually)
   */
  domainRequestId?: Maybe<Scalars['Int']>;
  /** Date request will expire */
  expiry?: Maybe<Scalars['String']>;
  /**
   * Id to make record unique
   * (since both domainId or domainRequestId can be null)
   */
  id: Scalars['String'];
  /** Date request was last attempted to be verified */
  lastVerificationAttempt?: Maybe<Scalars['String']>;
  /**
   * Id of Organization that owns domain
   * (can be null if domain is not yet verified)
   */
  organizationId?: Maybe<Scalars['Int']>;
  /** Domain status code */
  status: DomainRequestStatus;
};

/**
 * Domain request status code:
 * E = Expired,
 * P = Pending,
 * V = Verified
 */
export enum DomainRequestStatus {
  E = 'E',
  P = 'P',
  V = 'V',
}

export type FolderDiscovery = {
  __typename?: 'FolderDiscovery';
  account?: Maybe<Account>;
  accountId: Scalars['ID'];
};

export type ForeverSession = {
  __typename?: 'ForeverSession';
  /** The signonidentity of the user this forever session belongs to. */
  signonidentity?: Maybe<SignOnIdentity>;
};

export type SignOnIdentity = {
  __typename?: 'SignOnIdentity';
  /** The email associated with this identity. */
  email?: Maybe<Scalars['String']>;
  /** The way this identity signed up for Zapier. */
  signupType?: Maybe<Scalars['String']>;
};

/** A geolocated currency suggestion based on location headers from CloudFront */
export type GeolocatedCurrency = {
  __typename?: 'GeolocatedCurrency';
  countryCode?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
};

export type AppStats = {
  __typename?: 'AppStats';
  authCount: Scalars['Int'];
  memberCount: Scalars['Int'];
  selectedApi: Scalars['ID'];
  zapCount: Scalars['Int'];
};

/** Represents relationship between an Expert and a Client */
export type ExpertRelationship = {
  __typename?: 'ExpertRelationship';
  /** Client Account ID */
  clientAccountId: Scalars['ID'];
  /** Client CustomUser ID */
  clientCustomuserId: Scalars['ID'];
  /** Expert CustomUser ID */
  expertCustomuserId: Scalars['ID'];
  /** Expert Email */
  expertEmail: Scalars['String'];
  /** ID */
  id: Scalars['ID'];
  /** State */
  state: Scalars['String'];
};

export type SharedZap = {
  __typename?: 'SharedZap';
  /** An array of apps used by the SharedZap. */
  apps: Array<AppV2>;
  /** An array of related app slugs. */
  appSlugs: Array<Scalars['String']>;
  /** The creator of the shared zap. */
  creator: SharedZapCreator;
  /** The description of the shared zap. */
  description: Scalars['String'];
  /** The guided recipe for the shared zap. */
  guidedRecipe: SharedZapGuidedRecipe;
  /** The ID of the shared zap. */
  id: Scalars['ID'];
  /** The link hash used to identify the shared zap. */
  linkHash: Scalars['String'];
  /** The node_id of the parent Zap */
  node_id: Scalars['ID'];
  /** The origin divergence state of the shared zap. */
  originDivergenceState: DivergenceState;
  /** The sharing state of the shared zap. */
  shareVisibility: SharingState;
  /** The title of the shared zap. */
  title: Scalars['String'];
};

export type SharedZapCreator = {
  __typename?: 'SharedZapCreator';
  /** The gravatar URL of the creator */
  gravatarUrl?: Maybe<Scalars['String']>;
  /** The primary key of the creator */
  id: Scalars['ID'];
  /** The name of the creator */
  name: Scalars['String'];
};

export type SharedZapGuidedRecipe = {
  __typename?: 'SharedZapGuidedRecipe';
  /** The date the guided recipe was created */
  date: Scalars['String'];
  /** The primary key of the shared zap guided recipe */
  id: Scalars['ID'];
};

export enum DivergenceState {
  Diverged = 'diverged',
  Synced = 'synced',
}

export enum SharingState {
  Disabled = 'disabled',
  Global = 'global',
  Private = 'private',
  Public = 'public',
}

/** Paginated HelpDocs_Generic, as returned by the helpDocs_getAppContent query. */
export type HelpDocs_GenericsConnection = LimitOffsetConnection & {
  __typename?: 'HelpDocs_GenericsConnection';
  /** Edges can be null based on the filtering parameters provided. */
  edges: Array<HelpDocs_Generic>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** Generic. */
export type HelpDocs_Generic = HelpDocs_Content & {
  __typename?: 'HelpDocs_Generic';
  app?: Maybe<AppV2>;
  bodyAst: Scalars['HTMLAST'];
  canonicalPath: Scalars['String'];
  category?: Maybe<HelpDocs_Category>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastUpdated: Scalars['String'];
  published: Scalars['Boolean'];
  slug: Scalars['String'];
  suggested: HelpDocs_Suggested;
  title: Scalars['String'];
  type: HelpDocs_ContentType;
};

/** Fields shared between the content types. */
export type HelpDocs_Content = {
  canonicalPath: Scalars['String'];
  category?: Maybe<HelpDocs_Category>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastUpdated: Scalars['String'];
  published: Scalars['Boolean'];
  slug: Scalars['String'];
  suggested: HelpDocs_Suggested;
  type: HelpDocs_ContentType;
};

/** Category (hierachical model). */
export type HelpDocs_Category = {
  __typename?: 'HelpDocs_Category';
  canonicalPath: Scalars['String'];
  children: Array<HelpDocs_Category>;
  content: Array<HelpDocs_ContentLink>;
  description: Scalars['String'];
  id: Scalars['ID'];
  parent?: Maybe<HelpDocs_Category>;
  slug: Scalars['String'];
  title: Scalars['String'];
  video?: Maybe<HelpDocs_Video>;
};

/** Content link, as used by HelpDocs_Suggested and helpDocs_CategoryContent. */
export type HelpDocs_ContentLink = {
  __typename?: 'HelpDocs_ContentLink';
  /** Unique ID */
  _id?: Maybe<Scalars['ID']>;
  canonicalPath: Scalars['String'];
  categoryId: Scalars['String'];
  content: HelpDocs_Content;
  id: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
  type: HelpDocs_ContentType;
};

/** All possible values for the type fields. */
export enum HelpDocs_ContentType {
  Faq = 'faq',
  Generic = 'generic',
  Reference = 'reference',
  Troubleshooting = 'troubleshooting',
  Tutorial = 'tutorial',
}

/** Video. */
export type HelpDocs_Video = {
  __typename?: 'HelpDocs_Video';
  id: Scalars['ID'];
  length: Scalars['Int'];
  series: Scalars['String'];
  slug: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

/**
 * List of automatic suggested other content.
 *
 * TODO: Rename this to HelpDocs_GroupedContentLinks in a way that we don't break
 *       cached frontends with fragments on HelpDocs_Suggested.
 */
export type HelpDocs_Suggested = {
  __typename?: 'HelpDocs_Suggested';
  faq: Array<HelpDocs_ContentLink>;
  generic: Array<HelpDocs_ContentLink>;
  reference: Array<HelpDocs_ContentLink>;
  troubleshooting: Array<HelpDocs_ContentLink>;
  tutorial: Array<HelpDocs_ContentLink>;
};

/** All possible (generalized) types of steps. */
export enum HelpDocs_ActionType {
  Action = 'action',
  Search = 'search',
  Trigger = 'trigger',
}

/** Tutorial content, as returned by the helpDocs_Content query. */
export type HelpDocs_Tutorial = HelpDocs_Content & {
  __typename?: 'HelpDocs_Tutorial';
  canonicalPath: Scalars['String'];
  category?: Maybe<HelpDocs_Category>;
  conclusionAst: Scalars['HTMLAST'];
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  introductionAst: Scalars['HTMLAST'];
  lastUpdated: Scalars['String'];
  published: Scalars['Boolean'];
  slug: Scalars['String'];
  steps: Array<HelpDocs_InstructionStep>;
  suggested: HelpDocs_Suggested;
  title: Scalars['String'];
  type: HelpDocs_ContentType;
};

/** Step, as used in HelpDocs_Troubleshooting and HelpDocs_Tutorial. */
export type HelpDocs_InstructionStep = {
  __typename?: 'HelpDocs_InstructionStep';
  bodyAst: Scalars['HTMLAST'];
  id: Scalars['ID'];
  showNumber: Scalars['Boolean'];
  slug: Scalars['String'];
  suggested: HelpDocs_Suggested;
  title: Scalars['String'];
};

/** All possible content namespaces, for slug-based queries. */
export enum HelpDocs_Namespace {
  App = 'app',
  Help = 'help',
}

/** Paginated HelpDocs_Faq, as returned by the helpDocs_getFaqs query. */
export type HelpDocs_FaqsConnection = LimitOffsetConnection & {
  __typename?: 'HelpDocs_FaqsConnection';
  /** Edges can be null based on the filtering parameters provided. */
  edges: Array<HelpDocs_Faq>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

/** FAQ content, as returned by the helpDocs_Faqs and helpDocs_Content queries. */
export type HelpDocs_Faq = HelpDocs_Content & {
  __typename?: 'HelpDocs_Faq';
  answerAst: Scalars['HTMLAST'];
  canonicalPath: Scalars['String'];
  category?: Maybe<HelpDocs_Category>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastUpdated: Scalars['String'];
  published: Scalars['Boolean'];
  question: Scalars['String'];
  slug: Scalars['String'];
  suggested: HelpDocs_Suggested;
  type: HelpDocs_ContentType;
};

export type IdentityProvider = {
  __typename?: 'IdentityProvider';
  /** Account ID the IdP belongs to */
  accountId: Scalars['Int'];
  /** This is the callback URL that the IdP will redirect the user back to (us). */
  acs?: Maybe<Scalars['String']>;
  /** The audience of the SAML request (usually the issuer) */
  audience?: Maybe<Scalars['String']>;
  /**
   * Certificate string/blob that user provides. Django
   * will never return this value, but the proxy can
   * return a placeholder value for it.
   */
  certificate: Scalars['String'];
  /** Date string for when the IdP record was created. */
  createdAt: Scalars['String'];
  /** SSO Debug URL */
  debugSsoUrl: Scalars['String'];
  /** Determine if the Identity Provider is enabled for all users. */
  enabled: Scalars['Boolean'];
  /** Entity ID / Issuer for the IdP */
  entityId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /**
   * Tenant Identifier. Can be used for configuring SAML connectors
   * from IdP App Catalogues.
   */
  identifier?: Maybe<Scalars['String']>;
  /** IdP's Single logout URL (theirs) */
  idpSloUrl?: Maybe<Scalars['String']>;
  /** Optional mapping for an IdP */
  mapping: IdentityProviderMapping;
  /** The Recipient of the SAML request */
  recipient?: Maybe<Scalars['String']>;
  /** If the Single Logout requests should be signed */
  signedSlo?: Maybe<Scalars['Boolean']>;
  /** The certificate that can be sent to the IDP for SLO signing */
  sloCertificate?: Maybe<Scalars['String']>;
  /** The signing algorithm used for Single Logout request */
  sloSigAlg?: Maybe<Scalars['String']>;
  /** Service Provider Single Logout URL (ours) */
  spSloUrl?: Maybe<Scalars['String']>;
  /** Service Provider SSO URL (ours) */
  spSsoUrl: Scalars['String'];
  /** Single sign on URL */
  ssoUrl?: Maybe<Scalars['String']>;
};

/**
 * Optional mapping for an IdP. If user does not provide values
 * Django will use default values and these fields will be null.
 */
export type IdentityProviderMapping = {
  __typename?: 'IdentityProviderMapping';
  /** Email URL for mapping */
  email?: Maybe<Scalars['String']>;
  /** First name URL for mapping */
  firstName?: Maybe<Scalars['String']>;
  /** Last name URL for mapping */
  lastName?: Maybe<Scalars['String']>;
};

/**
 * For an integration to go from private to public on the Platform, the partner
 * must submit a review. This represents that review as it exists within the
 * bouncer app. A review has a status that maps to the integration's progress
 * through the review. Every review is related to specific integration and a
 * version/implementation for that integration.
 */
export type IntegrationReview = {
  __typename?: 'IntegrationReview';
  createdAt: Scalars['String'];
  /** All review feedback items for the integration of the review. */
  feedbackItems: Array<Maybe<IntegrationReviewFeedbackItem>>;
  id: Scalars['ID'];
  /** The Integration associated with this review. */
  integration: PlatformIntegration;
  /** The ID of the submitted integration. */
  integrationId: Scalars['ID'];
  isResubmission: Scalars['Boolean'];
  /** The last Zapier staff member to interact with this review. */
  lastReviewedBy?: Maybe<Reviewer>;
  /** Data collected from the partner's publishing form. */
  publishingInfo: IntegrationPublishingInfo;
  /** The current status of the review */
  status: IntegrationReviewStatus;
  /**
   * The ID of the email thread that was started when this review was
   * created.
   */
  ticketId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['String'];
  /** The version submitted for publishing. */
  version?: Maybe<Scalars['String']>;
};

export type IntegrationReviewFeedbackItem = {
  __typename?: 'IntegrationReviewFeedbackItem';
  body: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isBlocking: Scalars['Boolean'];
  title: Scalars['String'];
  type: IntegrationReviewFeedbackItemType;
  updatedAt: Scalars['String'];
};

/** Types for a review feedback item. */
export enum IntegrationReviewFeedbackItemType {
  Bug = 'BUG',
  FeatureRequest = 'FEATURE_REQUEST',
}

/**
 * The wrapping abstraction for a SaaS product on the Zapier Platform. Integrations can have many
 * implementations (historically known as AppVersions).
 */
export type PlatformIntegration = {
  __typename?: 'PlatformIntegration';
  /**
   * A list of all version numbers that have ever existed for this integration.
   * Includes public, private and deprecated versions.
   */
  allVersions: Array<Scalars['String']>;
  /** The business category of the integration chosen at the time of creation. */
  appCategory?: Maybe<Scalars['String']>;
  /** User defined details on the category if `appCategory` is "other". */
  appCategoryOther?: Maybe<Scalars['String']>;
  /** The versions of platform-core in use by implementations of this integration. */
  coreVersions: Array<Scalars['String']>;
  /** The date this integration was created. */
  date?: Maybe<Scalars['String']>;
  /** A short description of the integration and/or SaaS product. */
  description: Scalars['String'];
  /** The public homepage of the integration's SaaS product. */
  homepageUrl?: Maybe<Scalars['String']>;
  /** The id of the integration. */
  id: Scalars['ID'];
  /** A JPEG image for the integration. Using the SaaS product's logo. */
  image?: Maybe<Scalars['String']>;
  /** An implementation specified by version. We default to the integration's `latestVersion`. */
  implementation?: Maybe<PlatformImplementation>;
  /** All implementations (versions) that have been created for an integration. */
  implementations: Array<PlatformImplementation>;
  /**
   * Some determination of the developer's intention for creating this integration.
   * Helps us know if the integration is to go public on the platform or used privately.
   */
  intention?: Maybe<DeveloperIntention>;
  /** The URL sent to admins and invitees to use the integration while still private. */
  inviteUrl?: Maybe<Scalars['String']>;
  /**
   * Indicates that the integration is a new public app that has been approved by app review.
   * Integrations are in beta for three months.
   */
  isBeta: Scalars['Boolean'];
  /** A single Loki issue. */
  issue?: Maybe<PlatformIntegrationIssue>;
  /** All Loki issues for an integration. These include Bugs and Feature Requests. */
  issues?: Maybe<PlatformIntegrationIssues>;
  /** A unique key used to derive the selected_api of each implementation. i.e. `MailChimpCLIAPI` */
  key: Scalars['String'];
  /** The latest version of platform-core available on npm */
  latestCoreNpmVersion: Scalars['String'];
  /** The version of platform-core used by the most recent implementation of the integration */
  latestCoreVersion: Scalars['String'];
  /** The latest version number of this integration. */
  latestVersion?: Maybe<Scalars['String']>;
  /** The integration's settings for notifications. */
  notificationSettings: PlatformIntegrationNotificationSettings;
  /**
   * If true, indicates that a private integration has submitted to go public
   * and is now being vetted for early access.
   */
  pending: Scalars['Boolean'];
  /**
   * If true, indicates that an integration is publicly accessible, without an invite link.
   * The integration has been approved via the app review process.
   */
  public: Scalars['Boolean'];
  /** Values given by the partner in order to submit to publish on the Platform. */
  publishingInfo?: Maybe<IntegrationPublishingInfo>;
  /** The associated bouncer review for this integration. */
  review?: Maybe<IntegrationReview>;
  /** The role of the developer who created this integration within the integration's SaaS company/product. */
  role?: Maybe<DeveloperRole>;
  /** The id of the Service linked to this integration. Does not exist if the integration is not public. */
  serviceId?: Maybe<Scalars['Int']>;
  /** The slug of the integration for building pages. */
  slug?: Maybe<Scalars['String']>;
  /** Usage data for this integration such as how many Zaps use this integration. */
  stats?: Maybe<Scalars['JSON']>;
  /** The status of this integration. */
  status?: Maybe<Scalars['String']>;
  /** The title of the integration. Usually is the name of the SaaS product. */
  title: Scalars['String'];
  /** Active version numbers for the integration. Does not include deprecated versions/implemenations */
  versions: Array<Scalars['String']>;
};

/**
 * The wrapping abstraction for a SaaS product on the Zapier Platform. Integrations can have many
 * implementations (historically known as AppVersions).
 */
export type PlatformIntegrationImplementationArgs = {
  version?: InputMaybe<Scalars['String']>;
};

/**
 * The wrapping abstraction for a SaaS product on the Zapier Platform. Integrations can have many
 * implementations (historically known as AppVersions).
 */
export type PlatformIntegrationIssueArgs = {
  id: Scalars['Int'];
};

/**
 * The wrapping abstraction for a SaaS product on the Zapier Platform. Integrations can have many
 * implementations (historically known as AppVersions).
 */
export type PlatformIntegrationIssuesArgs = {
  orderBy?: InputMaybe<IssueOrderBy>;
  orderDirection?: InputMaybe<IssueOrderDirection>;
  page?: InputMaybe<Scalars['Int']>;
};

/**
 * The actual implementation of an integration on the Zapier Platform.
 * Implementations are versioned—often referred to by the version as "Version 2.2.0"—and
 * can eventaully be deprecated. In the past, these were known as AppVersions. An integration
 * can have many implementations. The implementation is what Zaps call into when executing.
 * Implementations are executed in AWS Lambda.
 */
export type PlatformImplementation = {
  __typename?: 'PlatformImplementation';
  /** Analytics that are collected for a given implementation. */
  analytics: ImplementationAnalytics;
  /** The id of the integration this implementation is a part of */
  appId: Scalars['ID'];
  /** The changes that went into this current version/implementation */
  changelog?: Maybe<Scalars['String']>;
  /** Metadata about a single type of app check. */
  check?: Maybe<ImplementationViolationMeta>;
  /**
   * Violations that are found for a given implementation.
   * They include style-checks and app-review violations as well as any other issues that might prevent publishing.
   */
  checks: ImplementationValidationChecks;
  /** The latest version of platform-core available on npm. Used to determine if this implementation is on an out-dated version of core. */
  coreNpmVersion: Scalars['String'];
  /** Date of creation for this implementation */
  date: Scalars['String'];
  /**
   * The actual definition for each API invocation and authentication for a partner app's API integration on the Platform.
   * While this field is nomally reserved for implementations built using the CLI, we normalize definitions here. We first look
   * for definition, and if it's empty, use definitionOverride. This way we have a definition regardless of whether it was created
   * on the CLI or visual builder. CLI implementations may not have anything defined in definitionOverride.
   */
  definition?: Maybe<ImplementationDefinition>;
  /** Is the implementation the default one new Zaps are created on? Could be `production` or `non-production`. Production indicates it is the default. */
  deployment?: Maybe<Scalars['String']>;
  /**
   * When the implementation is set to be deprecated. When choosing to deprecate an implementation,
   * a team can choose from two weeks from requesting date up to a year.
   */
  deprecationDate?: Maybe<Scalars['String']>;
  /**
   * A map of environment variables used in the implementations execution. These are executed under
   * `process.env` in the implmentations node runtime in lambda.
   */
  environment?: Maybe<Scalars['JSON']>;
  /**
   * Essentially a timestamp for a session editing an integration. Provides a means of supporting
   * multiple devs working on the same implementation at once.
   */
  etag: Scalars['String'];
  /** The id of the implementation. */
  id: Scalars['ID'];
  /** A link used to give users access to the implementation before it is public. */
  inviteUrl?: Maybe<Scalars['String']>;
  /**
   * Was this implementation created with the visual builder? An integration could have some
   * implementations created with visual builder and others created with the CLI. This denotes
   * what interface was used to create the implementation.
   */
  isUi?: Maybe<Scalars['Boolean']>;
  /** The redirect uri used for Oauth2 flow if the authentication setup is Oauth2. */
  oauthRedirectUri?: Maybe<Scalars['String']>;
  /**
   * The platform version bound to this implementation. Platform version refers to the version of
   * platform-schema, which is the source of truth for validation the integration's definition.
   */
  platformVersion: Scalars['String'];
  /** The implementation's unique identifier used by Zaps. */
  selectedApi: Scalars['String'];
  /** The number of users that have created Zaps with this implementation. */
  userCount: Scalars['Int'];
  /**
   * The version number of the implementation. We use semantic versioning—the first implementation
   * for any integration is always `1.0.0`.
   */
  version: Scalars['String'];
};

/**
 * The actual implementation of an integration on the Zapier Platform.
 * Implementations are versioned—often referred to by the version as "Version 2.2.0"—and
 * can eventaully be deprecated. In the past, these were known as AppVersions. An integration
 * can have many implementations. The implementation is what Zaps call into when executing.
 * Implementations are executed in AWS Lambda.
 */
export type PlatformImplementationCheckArgs = {
  id: Scalars['ID'];
};

/**
 * The actual implementation of an integration on the Zapier Platform.
 * Implementations are versioned—often referred to by the version as "Version 2.2.0"—and
 * can eventaully be deprecated. In the past, these were known as AppVersions. An integration
 * can have many implementations. The implementation is what Zaps call into when executing.
 * Implementations are executed in AWS Lambda.
 */
export type PlatformImplementationChecksArgs = {
  mode?: InputMaybe<Scalars['String']>;
};

export type ImplementationAnalytics = {
  __typename?: 'ImplementationAnalytics';
  /** Analytics of creates */
  creates: Array<Maybe<ImplementationAnalyticsVerb>>;
  /** Analytics of searches */
  searches: Array<Maybe<ImplementationAnalyticsVerb>>;
  /** Timestamp when the data is fetched */
  timestamp?: Maybe<Scalars['Int']>;
  /** Analytics of triggers */
  triggers: Array<Maybe<ImplementationAnalyticsVerb>>;
};

export type ImplementationAnalyticsVerb = {
  __typename?: 'ImplementationAnalyticsVerb';
  name: Scalars['String'];
  zapsLive?: Maybe<Scalars['Int']>;
  zapsPaused?: Maybe<Scalars['Int']>;
  zapsTotal?: Maybe<Scalars['Int']>;
};

export type ImplementationViolationMeta = {
  __typename?: 'ImplementationViolationMeta';
  doc: ImplementationViolationDoc;
};

export type ImplementationViolationDoc = {
  __typename?: 'ImplementationViolationDoc';
  body: Scalars['String'];
  title: Scalars['String'];
};

export type ImplementationValidationChecks = {
  __typename?: 'ImplementationValidationChecks';
  /** Checks that failed and were classified as warning level checks */
  activationTasks: ImplementationViolationsCheckWrapper;
  /** Checks that failed and were classified as error level checks */
  errors: ImplementationViolationsCheckWrapper;
  /** The validations contain at least one failure in `warnings` */
  hasActivationTasks: Scalars['Boolean'];
  /** The validations contain at least one failure in `errors` */
  hasErrors: Scalars['Boolean'];
  /** The validations contain at least one failure within `errors`,  `activationTasks`, or `warnings` */
  hasFailures: Scalars['Boolean'];
  /** The validations contain at least one failure in `suggestions` */
  hasWarnings: Scalars['Boolean'];
  /** All checks are passing and there are 0 failed checks. */
  isPassing: Scalars['Boolean'];
  /** The checks that passed validation */
  passes: Array<Maybe<ImplementationCheckResult>>;
  /** The total number of validation checks that were run. */
  totalChecks: Scalars['Int'];
  /**
   * The total number of failed checks returned from validation.
   * This aggregates each `message` found in each check.
   */
  totalFailures: Scalars['Int'];
  /** Checks that failed and were classified as suggestion level checks */
  warnings: ImplementationViolationsCheckWrapper;
};

export type ImplementationViolationsCheckWrapper = {
  __typename?: 'ImplementationViolationsCheckWrapper';
  results: Array<Maybe<ImplementationViolationsCheck>>;
  totalFailures: Scalars['Int'];
};

export type ImplementationViolationsCheck = {
  __typename?: 'ImplementationViolationsCheck';
  type: Scalars['String'];
  violations: Array<ImplementationCheckViolation>;
};

export type ImplementationCheckViolation = {
  __typename?: 'ImplementationCheckViolation';
  results: Array<ImplementationCheckResult>;
  type: Scalars['String'];
};

export type ImplementationCheckResult = {
  __typename?: 'ImplementationCheckResult';
  /**
   * Field that you can append to the base URL
   * to link a user to a Godzilla page where the violation happens
   */
  deepLink?: Maybe<Scalars['String']>;
  /** A message returned from a single validation check */
  message?: Maybe<Scalars['String']>;
  /** Documentation related to the returned violation */
  meta: ImplementationViolationMeta;
  /**
   * The reference to the check's documentation. Each check refers to a tag such as `D0123`.
   * The tag categorizes the level (D) and the ID (0123) of the check
   */
  tag?: Maybe<Scalars['String']>;
};

export type ImplementationDefinition = {
  __typename?: 'ImplementationDefinition';
  authentication?: Maybe<PlatformAuthentication>;
  creates: Array<PlatformApiInvocation>;
  id: Scalars['ID'];
  platformVersion: Scalars['String'];
  searches: Array<PlatformApiInvocation>;
  searchOrCreates: Array<PlatformApiInvocation>;
  triggers: Array<PlatformApiInvocation>;
  version: Scalars['String'];
};

export type PlatformAuthentication = {
  __typename?: 'PlatformAuthentication';
  connectionLabel?: Maybe<Scalars['String']>;
  fields?: Maybe<Scalars['JSON']>;
  test: Scalars['JSON'];
  type: AuthenticationType;
};

export enum AuthenticationType {
  Basic = 'basic',
  Custom = 'custom',
  Digest = 'digest',
  Oauth2 = 'oauth2',
  Session = 'session',
}

export type PlatformApiInvocation = {
  __typename?: 'PlatformApiInvocation';
  display: InvocationDisplay;
  key: Scalars['String'];
  noun: Scalars['String'];
  operation: Scalars['JSON'];
};

export type InvocationDisplay = {
  __typename?: 'InvocationDisplay';
  description: Scalars['String'];
  hidden: Scalars['Boolean'];
  important: Scalars['Boolean'];
  label: Scalars['String'];
};

/**
 * A means of capturing how the developer intends to use this integration. Is it for public use,
 * or only to be used internally within the company?
 */
export enum DeveloperIntention {
  Global = 'global',
  Invite = 'invite',
  Private = 'private',
}

/** A bug or feature request reported in Loki. Provides a means of Zapiens communicating with partners within the product. */
export type PlatformIntegrationIssue = {
  __typename?: 'PlatformIntegrationIssue';
  absoluteId: Scalars['ID'];
  /** The integration associated to this issue. */
  app: PlatformIssueApp;
  appVersions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The name of the person this issue is assigned to. */
  assignee?: Maybe<Scalars['String']>;
  /** The person that created this issue. */
  author: PlatformIssueUser;
  /** The body of the issue describing what the problem is. */
  body?: Maybe<Scalars['String']>;
  /** All comments associated with this issue. */
  comments?: Maybe<Array<PlatformIssueComment>>;
  /** The number of comments on this issue. */
  commentsCount: Scalars['Int'];
  createdAt: Scalars['String'];
  /** The partner tagged to this issue. */
  developer: PlatformIssueUser;
  /** A record of how this issue has changed over time. */
  events?: Maybe<Array<PlatformIssueEvent>>;
  id: Scalars['Int'];
  /** Does this issue prevent the integration from being public on the App Directory. */
  isBlocking: Scalars['Boolean'];
  /** Can partners see this issue or is this internal only. */
  isPublic: Scalars['Boolean'];
  lastActivityAt?: Maybe<Scalars['String']>;
  linkedJiraIssueKey?: Maybe<Scalars['String']>;
  /** The number of Zapier customers that are affected by this issue. */
  numInterestedUsers?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  priorityChangedAt?: Maybe<Scalars['String']>;
  priorityOverride?: Maybe<Scalars['Int']>;
  priorityOverrideChangedAt?: Maybe<Scalars['String']>;
  priorityRank?: Maybe<Scalars['Int']>;
  /** The selected_api associated with this issue. */
  selectedApi?: Maybe<Scalars['String']>;
  /** The enum value of this issue’s status. */
  status?: Maybe<Scalars['Int']>;
  /** The human readable status of this issue. */
  statusDisplay?: Maybe<Scalars['String']>;
  /** Collection of issue Comments and Events in chronological order of occurance. */
  stream?: Maybe<Array<Maybe<PlatformStreamItem>>>;
  tags?: Maybe<Array<Maybe<PlatformIssueTag>>>;
  /** The title of the issue. */
  title?: Maybe<Scalars['String']>;
  trackedGithubIssueId?: Maybe<Scalars['String']>;
  trackedGithubRepoSlug?: Maybe<Scalars['String']>;
  typeOf?: Maybe<Scalars['Int']>;
  /** The type as to be displayed by the UI. Could `Bug` or `Feature Request`. */
  typeOfDisplay?: Maybe<Scalars['String']>;
  waitingOnThirdPartySince?: Maybe<Scalars['String']>;
};

/** The integration Loki is referring to in issues. */
export type PlatformIssueApp = {
  __typename?: 'PlatformIssueApp';
  selectedApi?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * A user that can interact with Loki issues. This person can leave comments or be listed as a
 * point of contact.
 */
export type PlatformIssueUser = {
  __typename?: 'PlatformIssueUser';
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  dateJoined: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gravatar?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** Is this user a Zapian? */
  isStaff?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notifyVia?: Maybe<Scalars['Int']>;
  /**
   * Should this user get notifications when there are Loki updates to issues for integration's
   * they are listed as a developer for?
   */
  shouldNotify?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  zapierUserId?: Maybe<Scalars['Int']>;
};

/** A comment for a Loki issue. Comments can be from Zapier employees or partners. */
export type PlatformIssueComment = {
  __typename?: 'PlatformIssueComment';
  author: PlatformIssueUser;
  body: Scalars['String'];
  /** Comment threads can be grouped here. */
  children?: Maybe<Array<Maybe<PlatformIssueComment>>>;
  createdAt: Scalars['String'];
  errorMsg?: Maybe<Scalars['String']>;
  htmlBody?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isPublic: Scalars['Boolean'];
  markdownBody?: Maybe<Scalars['String']>;
};

/**
 * Any event that occurs for the issue. Collects events like creation,
 * assignment, issue lifecycle, etc.
 */
export type PlatformIssueEvent = {
  __typename?: 'PlatformIssueEvent';
  contentObject?: Maybe<PlatformIssueEventContent>;
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  /** An id for the type of event this is. We only display types <= 6 in the UI. */
  typeOf: Scalars['Int'];
  /** The display name of the event type. */
  typeOfDisplay: Scalars['String'];
  user?: Maybe<PlatformIssueUser>;
};

/** Metadata about a Loki event. */
export type PlatformIssueEventContent = {
  __typename?: 'PlatformIssueEventContent';
  backgroundColor?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** A collection of Loki comments and events that have been created for the issue. */
export type PlatformStreamItem = {
  __typename?: 'PlatformStreamItem';
  dataType: IssueStreamType;
  id: Scalars['Int'];
};

export enum IssueStreamType {
  Comments = 'comments',
  Events = 'events',
}

/** A means of adding metadata to a Loki issue. */
export type PlatformIssueTag = {
  __typename?: 'PlatformIssueTag';
  backgroundColor?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isPublic?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};

export enum IssueOrderBy {
  CreatedAt = 'created_at',
  Priority = 'priority',
}

export enum IssueOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type PlatformIntegrationIssues = {
  __typename?: 'PlatformIntegrationIssues';
  count: Scalars['Int'];
  currentPageIndex: Scalars['Int'];
  pages?: Maybe<Array<Maybe<Scalars['Int']>>>;
  results?: Maybe<Array<Maybe<PlatformIntegrationIssue>>>;
  totalPages: Scalars['Int'];
};

/**
 * Configures how a integration's development team is notified of updates to their Loki issues.
 * The default is send notifications to the `PlatformIssueUser` associated with the integration
 * as `developer`. This can be overridden by adding an additional contact.
 */
export type PlatformIntegrationNotificationSettings = {
  __typename?: 'PlatformIntegrationNotificationSettings';
  ccContact?: Maybe<PlatformIssueUser>;
  developer: PlatformIssueUser;
  /** Should we send notifications to the developer or just the CC Contact? */
  shouldNotifyDeveloper: Scalars['Boolean'];
};

/**
 * Form data used to facilitate reviews. This data is ephemeral within bouncer. Once an integration is published, these fields
 * will move to the integration's Service.
 */
export type IntegrationPublishingInfo = {
  __typename?: 'IntegrationPublishingInfo';
  /** URL for the integration's API documentation */
  apiDocsUrl?: Maybe<Scalars['String']>;
  /** The number of hours Zapier should expect for a response from the partner. */
  expectedResponseTime?: Maybe<Scalars['String']>;
  /** The marketing homepage/landing page of the integration's product. */
  homepageUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The partner contact for all things marketing */
  marketingContactEmail?: Maybe<Scalars['String']>;
  /**
   * Declares whether payment is required for customers to use the partner's product API. If payments
   * are required, they are either as a flat fee or per API request.
   */
  paidApi?: Maybe<PartnerApiPaymentType>;
  /** The primary color of the integration's product branding. */
  primaryColor?: Maybe<Scalars['String']>;
  /** The secondary color of the integration's product branding. */
  secondaryColor?: Maybe<Scalars['String']>;
  /** The parter contact for technical issues */
  technicalContactEmail?: Maybe<Scalars['String']>;
  /** Any notes for a test account given to Zapier by the partner for their integration's product. */
  testAccountNotes?: Maybe<Scalars['String']>;
  /** Password for a test account given to Zapier by the partner for their integration's product. */
  testAccountPassword?: Maybe<Scalars['String']>;
  /** Username for a test account given to Zapier by the partner for their integration's product. */
  testAccountUsername?: Maybe<Scalars['String']>;
  /** The partner twitter account used to manage the brand of the integration's app. */
  twitterUsername?: Maybe<Scalars['String']>;
};

export enum PartnerApiPaymentType {
  ApiCall = 'api_call',
  FlatFee = 'flat_fee',
  No = 'no',
}

/** The role selected by the integration's creator. */
export enum DeveloperRole {
  Contractor = 'contractor',
  Employee = 'employee',
  User = 'user',
}

export type Reviewer = {
  __typename?: 'Reviewer';
  createdAt: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  ssoUid?: Maybe<Scalars['ID']>;
};

/** Lifecycle statuses for a Platform Integration Review. */
export enum IntegrationReviewStatus {
  Approved = 'APPROVED',
  InReview = 'IN_REVIEW',
  IsResubmission = 'IS_RESUBMISSION',
  NotSubmitted = 'NOT_SUBMITTED',
  PushedBack = 'PUSHED_BACK',
  Rejected = 'REJECTED',
}

export type IntegrationReviewFeedbackSnippet = {
  __typename?: 'IntegrationReviewFeedbackSnippet';
  body: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  type: IntegrationReviewFeedbackItemType;
};

export type Internal_User = Internal_UserBase & {
  __typename?: 'Internal_User';
  abTests: Array<Internal_AbTest>;
  accountMemberships: Array<Internal_AccountMembership>;
  alertActions: Scalars['String'];
  alertTriggers: Scalars['String'];
  aliases: Array<Scalars['String']>;
  dateJoined: Scalars['String'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  implementations: Array<Internal_Implementation>;
  isDeveloper: Scalars['Boolean'];
  isExpert: Scalars['Boolean'];
  isHellbanned: Scalars['Boolean'];
  isHighValue: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  mailgun: Internal_Mailgun;
  notes: Array<Internal_Note>;
  timezone?: Maybe<Scalars['String']>;
  zaps: Internal_Zaps_Connection;
};

export type Internal_UserImplementationsArgs = {
  role: Internal_Implementation_Role;
};

export type Internal_UserZapsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  role: Internal_Zaps_Role;
};

export type Internal_UserBase = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type Internal_AbTest = {
  __typename?: 'Internal_ABTest';
  id: Scalars['ID'];
  isControl: Scalars['Boolean'];
  isEligible: Scalars['Boolean'];
  lane: Scalars['String'];
  name: Scalars['String'];
};

export type Internal_AccountMembership = {
  __typename?: 'Internal_AccountMembership';
  account: Internal_Account;
  id: Scalars['ID'];
  role: Internal_AccountMembership_Role;
};

export type Internal_Account = {
  __typename?: 'Internal_Account';
  cannotResetTrial?: Maybe<Scalars['String']>;
  companyAccountEndDate?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  customerId?: Maybe<Scalars['String']>;
  /** @deprecated Zapier will only support Teller */
  customerType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isChatEligible: Scalars['Boolean'];
  isTeamAccount: Scalars['Boolean'];
  isTrialing: Scalars['Boolean'];
  isTrialingCompanies: Scalars['Boolean'];
  isUnlimited: Scalars['Boolean'];
  name: Scalars['String'];
  periodEnd?: Maybe<Scalars['String']>;
  periodStart?: Maybe<Scalars['String']>;
  plan: Internal_Plan;
  planGroup: Internal_PlanGroup;
  teamAccountEndDate?: Maybe<Scalars['String']>;
  trialEndDate?: Maybe<Scalars['String']>;
  unlimitedUntil?: Maybe<Scalars['String']>;
  usage: Internal_Account_Usage;
};

export type Internal_Plan = {
  __typename?: 'Internal_Plan';
  id?: Maybe<Scalars['ID']>;
  interval: Internal_Plan_Interval;
  isPaid: Scalars['Boolean'];
  meteredTaskPricing: Scalars['Boolean'];
  name: Scalars['String'];
};

export enum Internal_Plan_Interval {
  Month = 'month',
  Year = 'year',
}

export type Internal_PlanGroup = {
  __typename?: 'Internal_PlanGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Internal_Account_Usage = {
  __typename?: 'Internal_Account_Usage';
  id: Scalars['ID'];
  tasks: Internal_Account_Usage_Group;
  zaps: Internal_Account_Usage_Group;
};

export type Internal_Account_Usage_Group = {
  __typename?: 'Internal_Account_Usage_Group';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  percent: Scalars['Int'];
};

export enum Internal_AccountMembership_Role {
  Admin = 'admin',
  Member = 'member',
  Owner = 'owner',
}

export enum Internal_Implementation_Role {
  Owner = 'owner',
  User = 'user',
}

export type Internal_Implementation = {
  __typename?: 'Internal_Implementation';
  apiDocsUrl?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  banner: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  helpDocsUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intention?: Maybe<Scalars['String']>;
  inviteUrl?: Maybe<Scalars['String']>;
  isAdmin: Scalars['Boolean'];
  isEarlyAccess: Scalars['Boolean'];
  isInternallyMaintained: Scalars['Boolean'];
  isPending: Scalars['Boolean'];
  isPremium: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  serviceId?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type Internal_Mailgun = {
  __typename?: 'Internal_Mailgun';
  bounced?: Maybe<Scalars['Boolean']>;
  complained?: Maybe<Scalars['Boolean']>;
  unsubscribed?: Maybe<Scalars['Boolean']>;
};

export type Internal_Note = {
  __typename?: 'Internal_Note';
  author: Internal_Note_Author;
  date: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type Internal_Note_Author = Internal_UserBase & {
  __typename?: 'Internal_Note_Author';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export enum Internal_Zaps_Role {
  Owner = 'owner',
  User = 'user',
}

export type Internal_Zaps_Connection = LimitOffsetConnection & {
  __typename?: 'Internal_Zaps_Connection';
  edges: Array<Internal_Zap>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export type Internal_Zap = {
  __typename?: 'Internal_Zap';
  id: Scalars['ID'];
  isInstant: Scalars['Boolean'];
  kind?: Maybe<Scalars['String']>;
  lastUserChange?: Maybe<Scalars['String']>;
  paused?: Maybe<Scalars['Boolean']>;
  selectedApis: Array<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  stepCount: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  tplDiverged?: Maybe<Scalars['Boolean']>;
  tplId?: Maybe<Scalars['Int']>;
};

export type Internal_UsersConnection = LimitOffsetConnection & {
  __typename?: 'Internal_UsersConnection';
  edges: Array<Internal_User>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export type Invitation = {
  __typename?: 'Invitation';
  /**
   * Account Details for Invitation
   * (will be non-null when fetching by code)
   */
  account?: Maybe<InvitationAccount>;
  /** Date invitation was created */
  createdAt: Scalars['String'];
  /** Account Details for Inviter */
  createdBy?: Maybe<InvitationCreatedBy>;
  /** Invitee's email address */
  email: Scalars['String'];
  /** Hash of Invitee's email address */
  emailHash: Scalars['String'];
  id: Scalars['String'];
  /** If the invitation is an access request */
  isAccessRequest: Scalars['Boolean'];
  /** Role invitee will take on as a member */
  role: MemberRole;
  /** Status of invitation */
  status: Scalars['String'];
};

export type InvitationAccount = {
  __typename?: 'InvitationAccount';
  id: Scalars['Int'];
  /** Account Logo Url */
  logoUrl: Scalars['String'];
  /** Account Name */
  name: Scalars['String'];
};

export type InvitationCreatedBy = {
  __typename?: 'InvitationCreatedBy';
  /** Inviter's email address */
  email: Scalars['String'];
  /** Inviter's Name */
  fullName: Scalars['String'];
};

export type AppIssue = {
  __typename?: 'AppIssue';
  absolute_id: Scalars['ID'];
  app: IssueApp;
  app_versions?: Maybe<Array<Maybe<Scalars['String']>>>;
  assignee?: Maybe<Scalars['String']>;
  author: IssueUser;
  body?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<Maybe<IssueComment>>>;
  comments_count: Scalars['Int'];
  created_at: Scalars['String'];
  developer?: Maybe<AppDeveloper>;
  events?: Maybe<Array<Maybe<IssueEvent>>>;
  id: Scalars['Int'];
  is_public: Scalars['Boolean'];
  last_activity_at?: Maybe<Scalars['String']>;
  linked_jira_issue_key?: Maybe<Scalars['String']>;
  num_interested_users?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  priority_changed_at?: Maybe<Scalars['String']>;
  priority_override?: Maybe<Scalars['Int']>;
  priority_override_changed_at?: Maybe<Scalars['String']>;
  priority_rank?: Maybe<Scalars['Int']>;
  selected_api?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  status_display?: Maybe<Scalars['String']>;
  stream?: Maybe<Array<Maybe<StreamItem>>>;
  tags?: Maybe<Array<Maybe<IssueTag>>>;
  title?: Maybe<Scalars['String']>;
  tracked_github_issue_id?: Maybe<Scalars['String']>;
  tracked_github_repo_slug?: Maybe<Scalars['String']>;
  type_of?: Maybe<Scalars['Int']>;
  type_of_display?: Maybe<Scalars['String']>;
  waiting_on_third_party_since?: Maybe<Scalars['String']>;
};

export type IssueApp = {
  __typename?: 'IssueApp';
  selected_api?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type IssueUser = {
  __typename?: 'IssueUser';
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  date_joined: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  gravatar?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_staff?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notify_via?: Maybe<Scalars['Int']>;
  should_notify?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  zapier_user_id?: Maybe<Scalars['Int']>;
};

export type IssueComment = {
  __typename?: 'IssueComment';
  author: IssueUser;
  body: Scalars['String'];
  children?: Maybe<Array<Maybe<IssueComment>>>;
  created_at: Scalars['String'];
  error_msg?: Maybe<Scalars['String']>;
  html_body?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_public: Scalars['Boolean'];
  markdown_body?: Maybe<Scalars['String']>;
};

export type AppDeveloper = {
  __typename?: 'AppDeveloper';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  date_joined?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notify_via?: Maybe<Scalars['Int']>;
  should_notify?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  zapier_user_id?: Maybe<Scalars['Int']>;
};

export type IssueEvent = {
  __typename?: 'IssueEvent';
  content_object?: Maybe<IssueEventContent>;
  created_at: Scalars['String'];
  id: Scalars['Int'];
  type_of: Scalars['Int'];
  type_of_display?: Maybe<Scalars['String']>;
  user?: Maybe<IssueUser>;
};

export type IssueEventContent = {
  __typename?: 'IssueEventContent';
  background_color?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type StreamItem = {
  __typename?: 'StreamItem';
  data_type: StreamType;
  id: Scalars['Int'];
  type_of?: Maybe<Scalars['Int']>;
};

export enum StreamType {
  Comments = 'comments',
  Events = 'events',
}

export type IssueTag = {
  __typename?: 'IssueTag';
  background_color?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_public?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};

export type JoinableAccount = {
  __typename?: 'JoinableAccount';
  /** User has pending access request to team */
  accessRequested: Scalars['Boolean'];
  /** Can join account without requesting access */
  canJoin: Scalars['Boolean'];
  id: Scalars['Int'];
  /** Logo image url */
  imageUrl: Scalars['String'];
  /**
   * True if email is required to be verified before requesting
   * access to the account
   */
  isEmailVerificationRequired: Scalars['Boolean'];
  /** Account name */
  name: Scalars['String'];
  /** Owner of the account */
  owner: AccountOwner;
};

export type OAuth = {
  __typename?: 'OAuth';
  /** Information on the OAuth object */
  client: OAuthClient;
  id: Scalars['ID'];
  /** List of scopes that access has been granted to */
  scopes: Array<Scopes>;
};

export type OAuthClient = {
  __typename?: 'OAuthClient';
  /** Logo for the oauth */
  image?: Maybe<Scalars['String']>;
  /** Name of the service given authorization to */
  name?: Maybe<Scalars['String']>;
};

export type Scopes = {
  __typename?: 'Scopes';
  /** User-facing description of the scope. */
  desc?: Maybe<Scalars['String']>;
  /** Scope given access to. Could be "profile" or "zap" for instance */
  key?: Maybe<Scalars['String']>;
};

/** Onboarding information for the user */
export type Onboarding = {
  __typename?: 'Onboarding';
  /** Date time of this object's creation */
  createdAt: Scalars['String'];
  /** Unique value identifying this onboarding */
  id: Scalars['ID'];
  /** User's intent for signing up */
  intent?: Maybe<OnboardingIntent>;
  /** User's intent detail - **if the user's intent is uncertain, this will be required** */
  intentDetail?: Maybe<Scalars['String']>;
  /** Status of onboarding */
  status: OnboardingStatus;
};

/** Describes the different intents a user has when signing up */
export enum OnboardingIntent {
  /** When users want to discover what Zapier can do for them */
  General = 'general',
  /** When users have some specific apps they want to connect */
  Specific = 'specific',
  /** When users want to do something else - when this option is selected, users will have the option to provide intentionDetails */
  Uncertain = 'uncertain',
}

export enum OnboardingStatus {
  /** When a user clicks the submit button on the last page of onboarding */
  Complete = 'complete',
  /** When a user clicks the skip button on the last page of onboarding */
  Skipped = 'skipped',
  /** When a user is displayed the onboarding page (currently app/onboarding) */
  Started = 'started',
}

export type PairDescription = {
  __typename?: 'PairDescription';
  shouldIndex?: Maybe<Scalars['Boolean']>;
};

export type PairDescriptionV2 = {
  __typename?: 'PairDescriptionV2';
  /**
   * Deprecated: use canonicalUrlV2 instead.
   * @deprecated Use canonicalUrlV2 instead. This field's type definition claims the value is non-nullable, where in fact the API might return a null value.
   */
  canonicalUrl: Scalars['String'];
  /**
   * The canonical URL of the service pair. If it doesn't match the page that it is being requested for, we should
   * include it in the head of the page so that Google can put the right one in its index.
   */
  canonicalUrlV2?: Maybe<Scalars['String']>;
  shouldIndex: Scalars['Boolean'];
};

/** A typical Partner at Zapier. */
export type Partner = {
  __typename?: 'Partner';
  /**
   * The parent's current health score according to bugs, features,
   * and other metrics.
   */
  health?: Maybe<PartnerDashboardHealth>;
  /** The partner's program status. */
  status?: Maybe<PartnerStatus>;
  /**
   * The partner's integration usage according to number of users
   * using the integration in 28 days.
   */
  usage?: Maybe<PartnerDashboardUsage>;
};

export type PartnerDashboardHealth = {
  __typename?: 'PartnerDashboardHealth';
  /** The current health score for the Zapier integration. */
  currentScore?: Maybe<PartnerHealth>;
  /**
   * Indicates if the partner has completed the upgrade requirements to go to the next
   * tier level.
   */
  hasCompleted?: Maybe<Scalars['Boolean']>;
  /** The health numbers as reported by our backend systems. */
  statistics?: Maybe<PartnerDashboardHealthStatistics>;
  /** The tier requirement information for the partner's health score. */
  tier?: Maybe<PartnerDashboardHealthTier>;
};

/** The available health scores for the partner's integration. */
export enum PartnerHealth {
  Exceptional = 'EXCEPTIONAL',
  Healthy = 'HEALTHY',
  /**
   * A health score may be NA, or not available, if the partner has recently been
   * promoted public.
   */
  Na = 'NA',
  Poor = 'POOR',
}

export type PartnerDashboardHealthStatistics = {
  __typename?: 'PartnerDashboardHealthStatistics';
  /** The number of open and public bugs as reported from Loki. */
  bugs?: Maybe<Scalars['Int']>;
  /** The number of open and public feature requests as reported from Loki. */
  featureRequests?: Maybe<Scalars['Int']>;
  /**
   * The number of issues (bugs or feature requests) that are visible to partners. This
   * is not strictly bugs + featureRequests (since they may include closed issues).
   */
  issues?: Maybe<Scalars['Int']>;
  /** The percent responded for all bugs and issues that were visible to partners. */
  percentResponded?: Maybe<Scalars['Float']>;
};

export type PartnerDashboardHealthTier = {
  __typename?: 'PartnerDashboardHealthTier';
  /**
   * The minimum health score required to stay in the current tier. Failing to keep
   * this health score may downgrade an integration's tier.
   */
  minimum?: Maybe<Scalars['String']>;
  /**
   * A value from 0.0 to 1.0 representing if the partner has accomplished the
   * upgrade rate.
   */
  percent?: Maybe<Scalars['Float']>;
  /** The health score value when accomplished may upgrade an integration's tier. */
  upgrade?: Maybe<Scalars['String']>;
};

export type PartnerDashboardUsage = {
  __typename?: 'PartnerDashboardUsage';
  /** The current active user count. */
  currentActive?: Maybe<Scalars['Int']>;
  /** Indicates if the partner has exceeded the usage tier upgrade requirement. */
  hasCompleted?: Maybe<Scalars['Boolean']>;
  /** The historical and current values (chart) of the user usage count. */
  statistics?: Maybe<PartnerDashboardUsageStatistics>;
  /** The current tier requirements for the usage statistic. */
  tier?: Maybe<PartnerDashboardUsageTier>;
};

export type PartnerDashboardUsageStatistics = {
  __typename?: 'PartnerDashboardUsageStatistics';
  /** The historical and current monthly values as reported by our backend data. */
  monthly?: Maybe<PartnerDashboardUsageStatisticsMonthly>;
  /** The historical and current quarterly values as reported by our backend data. */
  quarterly?: Maybe<PartnerDashboardUsageStatisticsQuarterly>;
};

export type PartnerDashboardUsageStatisticsMonthly = {
  __typename?: 'PartnerDashboardUsageStatisticsMonthly';
  /** The human-friendly labels for the x-axis of the chart. */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The raw values as reported by Looker for the y-axis of the chart. */
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PartnerDashboardUsageStatisticsQuarterly = {
  __typename?: 'PartnerDashboardUsageStatisticsQuarterly';
  /** The human-friendly labels for the x-axis of the chart. */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The raw values as reported by Looker for the y-axis of the chart. */
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PartnerDashboardUsageTier = {
  __typename?: 'PartnerDashboardUsageTier';
  /**
   * The minimum amount the partner is required to have in usage to retain the current
   * tier. If below this amount, we may consider dropping their tier to the previous
   * level.
   */
  minimum?: Maybe<Scalars['Int']>;
  /**
   * The current progress in as a percent fraction to meet or exceed the goal. This
   * ranges from 0.0 to 1.0.
   */
  percent?: Maybe<Scalars['Float']>;
  /**
   * The benchmark/upgrade amount the partner is requested to have in order to be
   * considered for the next upgrade in tier.
   */
  upgrade?: Maybe<Scalars['Int']>;
};

/** Partner Profile information for the current user */
export type PartnerProfile = {
  __typename?: 'PartnerProfile';
  /** Returns the ID of the customuser associated with this partner profile. Can return 'null' if partner profile doesn't exist */
  customuser?: Maybe<Scalars['Int']>;
  /** All deploy keys for a CLI developer. */
  deployKeys: Array<Maybe<PartnerPlatformDeployKey>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  jobTitle: Scalars['String'];
  lastName: Scalars['String'];
  /** All memberships for this partner profile */
  memberships: Array<Maybe<PartnerProfileMembership>>;
  /** All roles for this partner profile */
  roles: Array<PartnerProfileRole>;
};

/** Partner Profile information for the current user */
export type PartnerProfileDeployKeysArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Deploy keys are created when a dev runs `zapier login` from the
 * command line. They're used to push changes to an integration.
 */
export type PartnerPlatformDeployKey = {
  __typename?: 'PartnerPlatformDeployKey';
  /** Whether this key is enabled. */
  active: Scalars['Boolean'];
  /** The datetime where this key was created. */
  date: Scalars['String'];
  /** Universal identifier of this key. */
  id: Scalars['ID'];
  /** Value of this key. */
  key: Scalars['String'];
};

/** Partner Profile memberships information. */
export type PartnerProfileMembership = {
  __typename?: 'PartnerProfileMembership';
  app: PartnerProfileMembershipApp;
  /** Is the user subscribed to this integration? */
  optedIn: Scalars['Boolean'];
  type: MembershipSubscriptionOptions;
};

/** All the information related to an app that a user might be subscribed to (or not) */
export type PartnerProfileMembershipApp = {
  __typename?: 'PartnerProfileMembershipApp';
  id: Scalars['Int'];
  /** Membership app image */
  image: Scalars['String'];
  /** Is this app in beta? */
  isBeta: Scalars['Boolean'];
  /** Is this app public? */
  isPublic: Scalars['Boolean'];
  /** App slug. eg. 'mailchimp', 'wb-app-1234', null */
  slug?: Maybe<Scalars['String']>;
  /** App's name. eg. 'My wonderful app' */
  title: Scalars['String'];
  type: MembershipAppTypes;
};

/**
 * We have 3 types of application:
 * Web Builder apps: 'wb'
 * CLI Apps: 'cli'
 * Python Apps: 'py'
 */
export enum MembershipAppTypes {
  Cli = 'cli',
  Py = 'py',
  Wb = 'wb',
}

/** An user could be either a 'collaborator' or a 'subscriber' on an integration. */
export enum MembershipSubscriptionOptions {
  Collaborator = 'collaborator',
  Subscriber = 'subscriber',
}

/** Role that a user plays in a particular integration */
export type PartnerProfileRole = {
  __typename?: 'PartnerProfileRole';
  checked: Scalars['Boolean'];
  name: Scalars['String'];
  value: Scalars['String'];
};

/**
 * Which modals should persist for the current user. As an example, we want to show a small banner
 * at the top of the logged-in dashboard that will always be present until it's dismissed by the user.
 * We store this data as a table containing the customuser id, the string name identifier for the
 * modal we're representing (for example "getting-started"), and an optional JSON object containing
 * some modal metadata.
 */
export type PersistedModal = {
  __typename?: 'PersistedModal';
  /** An optional JSON string containing metadata. */
  modal_data?: Maybe<Scalars['JSON']>;
  /** The modal's unique name, such as "getting-started". */
  name?: Maybe<Scalars['String']>;
};

export type PlatformDeployKey = {
  __typename?: 'PlatformDeployKey';
  /** Whether this key is enabled. */
  active: Scalars['Boolean'];
  /** The datetime where this key was created. */
  date: Scalars['String'];
  /** Universal identifier of this key. */
  id: Scalars['ID'];
  /** Value of this key. */
  key: Scalars['String'];
};

export type PlatformIntegrationDetails = {
  __typename?: 'PlatformIntegrationDetails';
  /** The id of the integration. */
  id: Scalars['ID'];
  /** A JPEG image for the integration. Using the SaaS product's logo. */
  image?: Maybe<Scalars['String']>;
  /**
   * Indicates that the integration is a new public app that has been approved by app review.
   * Integrations are in beta for three months.
   */
  isBeta: Scalars['Boolean'];
  /**
   * If true, indicates that an integration is publicly accessible, without an invite link.
   * The integration has been approved via the app review process.
   */
  isPublic: Scalars['Boolean'];
  /** The slug of the integration for building pages. */
  slug?: Maybe<Scalars['String']>;
  /** The status of this integration. */
  status?: Maybe<Scalars['String']>;
  /** The title of the integration. Usually is the name of the SaaS product. */
  title: Scalars['String'];
};

export type Policies = CursorBasedConnection & {
  __typename?: 'Policies';
  edges: Array<Policy>;
  pageInfo: CursorBasedPageInfo;
  totalCount: Scalars['Int'];
};

export type Policy = {
  __typename?: 'Policy';
  body: Scalars['String'];
  contentId?: Maybe<Scalars['Int']>;
  /** Unique ID */
  id?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  tldr: Scalars['String'];
};

export type PlanTaskGrouping = {
  __typename?: 'PlanTaskGrouping';
  id: Scalars['ID'];
  plans: Array<PlanV2>;
  planType: Scalars['String'];
};

export type Provision = {
  __typename?: 'Provision';
  /** Account Id that owns Provision */
  accountId: Scalars['Int'];
  id: Scalars['Int'];
  /** True if Provision is enabled */
  isEnabled: Scalars['Boolean'];
  /** Schema JSON template */
  schema: Scalars['JSON'];
  /** SCIM URL that can be used by clients */
  scimBaseUrl: Scalars['String'];
  /** SCIM Bearer Token to be used in SCIM requests */
  token: Scalars['String'];
};

export type PressArticle = {
  __typename?: 'PressArticle';
  /** A brief excerpt from the article */
  articleExcerpt: Scalars['String'];
  /** The publisher of the article - usually the website */
  articlePublisher: Scalars['String'];
  /** The title of the article */
  articleTitle: Scalars['String'];
  /** The external link to the article */
  articleUrl: Scalars['String'];
  /** The date the article was published */
  datePublished: Scalars['String'];
  /** The headline image, in a 1600x900 format */
  headlineImageUrl: Scalars['String'];
  /** The unique ID of the article */
  id: Scalars['Int'];
  /** An indication of whether we should show the article on the press page */
  isPublic: Scalars['Boolean'];
  /** The order of the article, in ascending order. */
  order: Scalars['Int'];
  /** The read time in minutes, in the format "MM:SS" */
  readTimeMinutes: Scalars['String'];
};

/** Represents the testimonial of a user saying good things about Zapier. */
export type UserTestimonial = {
  __typename?: 'UserTestimonial';
  /** The name of the company the author of this testimonial is associated with. */
  company: Scalars['String'];
  /** The unique ID of this testimonial. */
  id: Scalars['ID'];
  /** An image to use for this testimonial. Usually this is the image of the author of the testimonial. */
  image?: Maybe<Scalars['String']>;
  /** The name of the author of this testimonial. */
  name: Scalars['String'];
  /** The actual testimonial quote. */
  quote: Scalars['String'];
};

export type ReviewPage = {
  __typename?: 'ReviewPage';
  author?: Maybe<AuthorType>;
  features?: Maybe<Scalars['String']>;
  featuresHtml?: Maybe<Scalars['String']>;
  homepageScreenshot?: Maybe<PhotoType>;
  id?: Maybe<Scalars['ID']>;
  lastChanged?: Maybe<Scalars['UTCDateTime']>;
  name?: Maybe<Scalars['String']>;
  photos?: Maybe<Array<Maybe<PhotoType>>>;
  pricing?: Maybe<Scalars['String']>;
  pricingHtml?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  relatedApps?: Maybe<Array<Maybe<Service>>>;
  review?: Maybe<Scalars['String']>;
  reviewHtml?: Maybe<Scalars['String']>;
  reviewSummary?: Maybe<Scalars['String']>;
  reviewSummaryHtml?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  service?: Maybe<Service>;
  sharingTags?: Maybe<Scalars['String']>;
  similarApps?: Maybe<Array<Maybe<Service>>>;
  siteUrl?: Maybe<Scalars['String']>;
};

export type PhotoType = {
  __typename?: 'PhotoType';
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type RolesConnection = LimitOffsetConnection & {
  __typename?: 'RolesConnection';
  edges: Array<RecommendationProfileRole>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export type SeoData = {
  __typename?: 'SEOData';
  /**
   * Deprecated, use canonicalPath instead.
   * @deprecated Use canonicalPath instead.
   */
  cannonicalPath: Scalars['String'];
  /**
   * Deprecated: use canonicalPathV2 instead.
   * @deprecated Use canonicalPathV2 instead. This field's type definition claims the value is non-nullable, where in fact the API might return a null value.
   */
  canonicalPath: Scalars['String'];
  /** The path which is the new cannonical home of the original path. */
  canonicalPathV2?: Maybe<Scalars['String']>;
  /** The primary key of the seo data. */
  id: Scalars['Int'];
  /** The path which we cannot find. */
  path: Scalars['String'];
  /** An optional field which allows us to override the meta description of a page. */
  seoDescriptionOverride?: Maybe<Scalars['String']>;
  /** An optional field indicating the experiment lane. */
  seoExperimentLane?: Maybe<Scalars['String']>;
  /** An optional field indicating the experiment name. */
  seosplitName?: Maybe<Scalars['String']>;
  /** An optional field which allows us to override the h1 tag of a page. */
  seoH1Override?: Maybe<Scalars['String']>;
  /** An optional field which allows us to override the indexability of a page. */
  seoIndexTagOverride?: Maybe<Scalars['Boolean']>;
  /**
   * Deprecated, use seoIndexTagOverride instead.
   * @deprecated Use seoIndexTagOverride instead.
   */
  seoNoIndexOverride?: Maybe<Scalars['String']>;
  /** An optional field letting the frontend know if it should display the overrides or not. */
  seoOverrideEnabled?: Maybe<Scalars['Boolean']>;
  /** An optional field which allows us to set additional JSON+LD tags on a page. */
  seoStructuredData?: Maybe<Scalars['JSON']>;
  /** An optional field which allows us to override the title of a page. */
  seoTitleOverride?: Maybe<Scalars['String']>;
  /** Whether to follow this redirect. */
  shouldRedirect: Scalars['Boolean'];
};

export type ServiceOne = {
  __typename?: 'ServiceOne';
  id: Scalars['ID'];
  /** A requested service or not. */
  isRequested: Scalars['Boolean'];
  /** The name of the service. */
  name: Scalars['String'];
  /** The slug of the service. */
  slug: Scalars['String'];
  /** The count of Zaps. */
  zapUsageCount: Scalars['Int'];
};

/** Services per page. */
export type ServicesByNameContainsOutput = {
  __typename?: 'ServicesByNameContainsOutput';
  count: Scalars['Int'];
  services?: Maybe<Array<Maybe<ServiceOne>>>;
};

export type Session = {
  __typename?: 'Session';
  /** The customuser ID of the user, if logged in. */
  id?: Maybe<Scalars['ID']>;
  /** The identity of the user, regardless of whether they're logged in. */
  identity: Scalars['Int'];
  /** Indicates whether the user is logged in. */
  isLoggedIn: Scalars['Boolean'];
  /** Object containing Gargoyle switches that may apply to the user. */
  switches: Scalars['JSON'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * TODO:
   * Only temporarily here so we can migrate id from an enum to a String.
   * If you are seeing this exist for longer than seven days, then something went wrong.
   */
  _id: Scalars['String'];
  /** A description of the subscription */
  description?: Maybe<Scalars['String']>;
  /**
   * The unique id of the subscription
   * When allowed by our schema checks in CI, we should swap back over to this
   * field and change it to a String!. Also delete _id
   */
  id: SubscriptionId;
  /** Same as id */
  key: SubscriptionId;
  /** User-facing description for subscription */
  name?: Maybe<Scalars['String']>;
  /** Is the user subscribed? */
  subscribed: Scalars['Boolean'];
};

/** Represents subscriptions that users can subscribe to */
export enum SubscriptionId {
  All = 'all',
  Iterableappupdatesrecommendations = 'iterableappupdatesrecommendations',
  Iterablecommunity = 'iterablecommunity',
  Iterabledeveloperblog = 'iterabledeveloperblog',
  Iterablegettingstartedseries = 'iterablegettingstartedseries',
  Iterablenewappsweekly = 'iterablenewappsweekly',
  Iterablenewsspecialoffers = 'iterablenewsspecialoffers',
  Iterablepartnercommunications = 'iterablepartnercommunications',
  Iterablezapierblog = 'iterablezapierblog',
  Iterablezapierfeedback = 'iterablezapierfeedback',
  Iterablezapierproductupdates = 'iterablezapierproductupdates',
}

export enum SuggestionPersonalization {
  Popularity = 'popularity',
  Role = 'role',
}

/** Represents a Timezone that the user can set on their Profile page. */
export type Timezone = {
  __typename?: 'Timezone';
  /** Timezone represented as an id, like Pacific/Niue */
  id?: Maybe<Scalars['ID']>;
  /** The user friendly label for this timezone */
  label?: Maybe<Scalars['String']>;
};

export type TwoFactorAuth = {
  __typename?: 'TwoFactorAuth';
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  qrCodeUrl?: Maybe<Scalars['String']>;
  recoveryCodes: Array<Scalars['String']>;
  recoveryPhoneNumber?: Maybe<Scalars['String']>;
};

export type UseCases = CursorBasedConnection & {
  __typename?: 'UseCases';
  /** List of Use Cases */
  edges: Array<UseCase>;
  /** Current results page info including next and previous cursors */
  pageInfo: CursorBasedPageInfo;
  /** Total results available */
  totalCount: Scalars['Int'];
};

export type UserJobStatus = {
  __typename?: 'UserJobStatus';
  status?: Maybe<JobStatus>;
};

export enum JobStatus {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'inProgress',
  None = 'none',
}

/** Represents an app selected by a user to follow. */
export type FollowedApp = {
  __typename?: 'FollowedApp';
  /** The complete app object. */
  app: AppV2;
  /** Timestamp for when this was added */
  created: Scalars['String'];
  /** The index of this app result. */
  id: Scalars['ID'];
  /** The slug of this followed app. */
  serviceSlug: Scalars['String'];
  /** Source of this becoming a followed app */
  sources: Array<Scalars['String']>;
};

/** Represents a single Action/Goal that a user will be able to complete. */
export type UserSkillLevelAction = {
  __typename?: 'UserSkillLevelAction';
  /** Defines whether or not an action has been completed by the current user */
  completed: Scalars['Boolean'];
  /** The unique ID of the Action */
  id: Scalars['ID'];
  /** The key of the Action. This is used to map actions with extra behavior in the frontend */
  key: Scalars['String'];
  /** The name of the Action */
  name: Scalars['String'];
  /** The order of the Action. This is an attempt to facilitate in which order the actions should be completed by the user */
  order: Scalars['Int'];
};

export type Testimonial = {
  __typename?: 'Testimonial';
  company?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  quote?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ZapRunStatus = {
  __typename?: 'ZapRunStatus';
  errors?: Maybe<Array<Scalars['String']>>;
  messages: Array<ZapRunStatusStep>;
};

export type ZapRunStatusStep = {
  __typename?: 'ZapRunStatusStep';
  body: Scalars['String'];
  status: Scalars['String'];
};

export enum KindType {
  Transfer = 'transfer',
  Workflow = 'workflow',
}

export type ZapOrderByInput = {
  state?: InputMaybe<Sort>;
  title?: InputMaybe<Sort>;
};

export enum Sort {
  Asc = 'asc',
  Desc = 'desc',
}

export type Zaps = LimitOffsetConnection & {
  __typename?: 'Zaps';
  edges: Array<ZapV2>;
  pageInfo: LimitOffsetPageInfo;
  totalCount: Scalars['Int'];
};

export enum ZapTemplatesOrderByOptions {
  /** Filters and orders results based on our default recommendation algorithm. */
  Default = 'DEFAULT',
  /**
   * Filters and orders results based on what our recommendation system believes are good beginner Zaps.
   * In practice this means Simple Zap Setup ZTs, ranked by how often they have been completed by users.
   */
  ForBeginners = 'FOR_BEGINNERS',
  /** Order results ascending by the ZT's "rank" field. */
  Rank = 'RANK',
}

export type ZapTemplatesConnectionV2 = CursorBasedConnection & {
  __typename?: 'ZapTemplatesConnectionV2';
  edges: Array<ZapTemplateV2>;
  pageInfo: CursorBasedPageInfo;
  totalCount: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * This empty mutation can be ignored. It's only used to make sure we never have a non-empty Mutation type.
   * This way, all structures can use the "extend Mutation" syntax.
   */
  _?: Maybe<Scalars['String']>;
  acceptInvitation: Scalars['Int'];
  acceptInvitationByCode: Scalars['String'];
  acceptOffer?: Maybe<Offer>;
  acceptTeamRequest: Scalars['ID'];
  addTeamMember: TeamMember;
  /**
   * Bulk add team members by email address
   * If the email address doesn't belong to an Account Member
   * then the email will be invted to join Zapier and will be
   * added to the team once they join
   */
  addTeamMembers: BulkAddTeamMemberResults;
  changeAccountPlan: Account;
  /**
   * Starts the change email process for a user by sending the new email address a
   * confirmation link, authToken comes from reauthentication flow
   */
  changeUserEmail: Scalars['ID'];
  checkDomainRequest?: Maybe<DomainRequest>;
  /** Completes a specific skill level action by action key */
  completeUserSkillLevelAction: UserSkillLevelAction;
  /** Copies a zap */
  copyZap: ZapV2;
  createAccountSurveyResponse: SurveyResponse;
  /**
   * Send a request for an app that's not currently in Zapier.com.
   * Returns AppRequestSummary object when the vote has been successfully added.
   */
  createAppRequest: AppRequestSummary;
  /** Create a new app restriction */
  createAppRestriction: AppRestriction;
  /** Add member to app restriction */
  createAppRestrictionMembership: AppRestriction;
  /** Add team to app restriction */
  createAppRestrictionTeamship: AppRestriction;
  /** Share auth with a member */
  createAuthMembership: AuthenticationV2;
  /** Share auth with a team */
  createAuthTeamship: AuthenticationV2;
  createDomainRequest: DomainRequest;
  createEmailSubscription: EmailSubscription;
  createFolder: Folder;
  createFolderMembershipV2: ShareMember;
  createFolderTeamshipV2: ShareTeam;
  createIdentityProvider: IdentityProvider;
  createIntegrationReviewFeedbackItem?: Maybe<IntegrationReviewFeedbackItem>;
  createInvitations?: Maybe<InvitationResults>;
  /** Creates a new account in the current user's plan group on the Free plan */
  createNewFreeAccount: Account;
  /** Creates a new onboarding object */
  createOnboarding?: Maybe<Onboarding>;
  /**
   * Create and Update Partner Profile
   *
   * /api/platform/cli/profile will create and update the partner profile using the same POST method. That's why we're using the same mutation for creating and updating.
   */
  createOrUpdatePartnerProfile?: Maybe<PartnerProfile>;
  /** Create a deploy key */
  createPlatformDeployKey: PartnerPlatformDeployKey;
  createSetupIntent: SetupIntent;
  createTeam: Team;
  /** Delete app restriction record */
  deleteAppRestriction: Scalars['ID'];
  /** Remove member from app restriction */
  deleteAppRestrictionMembership: AppRestriction;
  /** Remove team from app sharing */
  deleteAppRestrictionTeamship: AppRestriction;
  /** Delete an authentication */
  deleteAuthentication: Scalars['ID'];
  /** Remove member from auth sharing */
  deleteAuthMembership: AuthenticationV2;
  /** Remove team from auth sharing */
  deleteAuthTeamship: AuthenticationV2;
  deleteDomainRequest: Scalars['Int'];
  deleteFolderMembershipV2: Scalars['ID'];
  deleteFolderTeamshipV2: Scalars['ID'];
  deleteFolderV2: Scalars['Int'];
  deleteIdentityProvider: IdentityProvider;
  deleteInvitation: Scalars['Int'];
  deleteMember: Scalars['Int'];
  deleteOAuth: Scalars['ID'];
  /** Delete a deploy key by id */
  deletePlatformDeployKey?: Maybe<DeletePlatformDeployKeyResult>;
  deleteTasks: TaskActionResult;
  deleteTeam: Scalars['ID'];
  deleteTeamMember: Scalars['ID'];
  /** Deletes a user and all of their information */
  deleteUser: Scalars['ID'];
  /**
   * Delete a zap (move to trash)
   * Returns an empty 200 response if successful
   */
  deleteZap: Scalars['ID'];
  /** Bulk moves zaps to the trash */
  deleteZaps: Array<Scalars['ID']>;
  denyTeamRequest: Scalars['ID'];
  disable2FA: Scalars['ID'];
  /** Removes an SSO Identity from a user's account */
  disconnectSsoIdentity: Scalars['ID'];
  domainMembersExport: Scalars['String'];
  downloadTasks: DownloadTasksResult;
  extendAccountTrial: Account;
  /** Create a Feedback record for a helpdoc. */
  helpDocs_createFeedback: HelpDocs_Feedback;
  /**
   * Submits feedback for an helpdoc.
   * @deprecated Use helpDocs_createFeedback instead
   */
  helpDocs_postFeedback: HelpDocs_Feedback;
  /**
   * Submits a rating for an helpdoc.
   * @deprecated Use helpDocs_postFeedback instead
   */
  helpDocs_postRating: HelpDocs_Rating;
  /** Amend a Feedback record for a helpdoc. */
  helpDocs_updateFeedback: HelpDocs_Feedback;
  internal_addUserAlias?: Maybe<Scalars['Boolean']>;
  /** Approve pending expert relationship for a given users's client_account_id */
  inviteExpert: InviteExpertResponse;
  joinAccount: Account;
  /** Move a Zap to a different folder */
  moveZap?: Maybe<ZapV2>;
  notifyMembers: IdentityProvider;
  /** Turn a zap off (pause) */
  pauseZap: ZapV2;
  /** Creates a new modal row with the given name and data. */
  persistedModalCreate: PersistedModal;
  /** Removes (dismisses) a modal row with the given name. */
  persistedModalDismiss?: Maybe<Scalars['Boolean']>;
  /** Agrees to a policy for the given user based on policy slug */
  policyAgreement?: Maybe<PolicyAgreement>;
  refreshProvisionToken: Provision;
  regenerate2FARecoveryCodes: TwoFactorAuth;
  removeIntegrationReviewFeedbackItem?: Maybe<Scalars['ID']>;
  /** Rename a Zap */
  renameZap: ZapV2;
  renewDomainRequest?: Maybe<DomainRequest>;
  replayTask?: Maybe<TaskReplayStatus>;
  replayTasks: TaskActionResult;
  requestAccess: Invitation;
  requestJoinTeam: TeamMemberRequest;
  /** @deprecated use resendInvitationV2 instead */
  resendInvitation: Invitation;
  resendInvitationV2: Scalars['Int'];
  /** Start a zap run (non-instant zaps only) */
  runZap: Scalars['String'];
  saveBankPaymentSource?: Maybe<PaymentSource>;
  saveCardPaymentSource?: Maybe<PaymentSource>;
  /** @deprecated Use savePlatformIssueComment instead */
  saveComment?: Maybe<IssueComment>;
  savePaypalPaymentSource?: Maybe<PaymentSource>;
  /** Creates or Updates a comment on a Platform Issue */
  savePlatformIssueComment?: Maybe<PlatformIssueComment>;
  /** Send an email to user so they can confirm their email address */
  sendConfirmationEmail: Scalars['ID'];
  sendSuccess?: Maybe<BanditRecommendation>;
  /** Update if an auth is shared or not */
  setAuthIsShared: AuthenticationV2;
  setAutoUpgrade?: Maybe<FeatureEnrollment>;
  setCompanyInitialEngagement: Account;
  /** Mark the jobs CTA as having been seen or unseen by the user */
  setHasSeenJobsCta: UserV2;
  setTeamAutoUpgrade: Account;
  /** Set the description of a Zap */
  setZapDescription: ZapV2;
  /** Set the timezone of a Zap */
  setZapTimezone: ZapV2;
  /** Test if the auth is connected correctly */
  testAuth: TestAuthResponse;
  /** Test if the multiple auths are connected correctly */
  testAuths: Array<TestAuthResponse>;
  text2FAVerificationCode: TwoFactorAuth;
  toggleProvision: Provision;
  /** Transfer auth ownership */
  transferAuth: AuthenticationV2;
  /** Transfer a Zap to a new owner */
  transferZap?: Maybe<ZapV2>;
  trialOnboardingSurvey?: Maybe<Account>;
  /** Turn a zap on (unpause) */
  unpauseZap: ZapV2;
  unsubscribeFromAll: Array<Subscription>;
  updateAccessPolicy: Account;
  updateAccount: Account;
  /** Update the title of an authentication */
  updateAuthTitle: AuthenticationV2;
  updateFolderV2: Folder;
  updateIdentityProvider: IdentityProvider;
  updateIntegrationNotificationSettings: PlatformIntegrationNotificationSettings;
  updateIntegrationPublishingInfo?: Maybe<UpdatePublishingInfoPayload>;
  updateIntegrationReview?: Maybe<IntegrationReview>;
  updateIntegrationReviewFeedbackItem?: Maybe<IntegrationReviewFeedbackItem>;
  updateInvoiceInfo: Account;
  updateMemberRole?: Maybe<Member>;
  /** Update notification settings */
  updateNotificationSettings: UserV2;
  /** Updates onboarding with given status */
  updateOnboarding: Onboarding;
  /** Updates the status of a Platform Issue */
  updatePlatformIssueStatus: PlatformIntegrationIssue;
  updateRecommendationProfile?: Maybe<RecommendationProfile>;
  updateSubscription: Subscription;
  updateTeam: Team;
  /** Update profile information as outlined in the form on settings "My Profile" */
  updateUser: UserV2;
  /** Update a User's password */
  updateUserPassword: Scalars['ID'];
  /**
   * Deprecated do not use
   * @deprecated Use non-generic mutations like moveZap instead
   */
  updateZap?: Maybe<Zap>;
  /** Start a deletion of all user data */
  userStartDataDelete: UserJobStatus;
  /** Start an export of all of the user's data (sent to their email) */
  userStartDataExport: UserJobStatus;
  verify2FARecoveryCode: TwoFactorAuth;
};

export type MutationAcceptInvitationArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationAcceptInvitationByCodeArgs = {
  code: Scalars['String'];
};

export type MutationAcceptOfferArgs = {
  input: AcceptOfferInput;
};

export type MutationAcceptTeamRequestArgs = {
  accountId: Scalars['Int'];
  data: TeamMemberInput;
  teamId: Scalars['ID'];
};

export type MutationAddTeamMemberArgs = {
  accountId: Scalars['Int'];
  data: TeamMemberInput;
  teamId: Scalars['ID'];
};

export type MutationAddTeamMembersArgs = {
  accountId: Scalars['Int'];
  emails: Array<Scalars['String']>;
  teamId: Scalars['ID'];
};

export type MutationChangeAccountPlanArgs = {
  id: Scalars['Int'];
  input: ChangeAccountPlanInput;
};

export type MutationChangeUserEmailArgs = {
  authToken: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type MutationCheckDomainRequestArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationCompleteUserSkillLevelActionArgs = {
  actionKey: Scalars['String'];
};

export type MutationCopyZapArgs = {
  id: Scalars['ID'];
};

export type MutationCreateAccountSurveyResponseArgs = {
  id: Scalars['Int'];
  input: SurveyResponseInput;
};

export type MutationCreateAppRequestArgs = {
  data: AppRequestInput;
  slug: Scalars['String'];
};

export type MutationCreateAppRestrictionArgs = {
  accountId: Scalars['Int'];
  data: AppRestrictionInput;
};

export type MutationCreateAppRestrictionMembershipArgs = {
  accountId: Scalars['Int'];
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};

export type MutationCreateAppRestrictionTeamshipArgs = {
  accountId: Scalars['Int'];
  id: Scalars['ID'];
  teamId: Scalars['ID'];
};

export type MutationCreateAuthMembershipArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};

export type MutationCreateAuthTeamshipArgs = {
  id: Scalars['ID'];
  teamId: Scalars['ID'];
};

export type MutationCreateDomainRequestArgs = {
  accountId: Scalars['Int'];
  data?: InputMaybe<DomainRequestInput>;
};

export type MutationCreateEmailSubscriptionArgs = {
  input: EmailSubscriptionInput;
};

export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};

export type MutationCreateFolderMembershipV2Args = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
  memberId: Scalars['ID'];
};

export type MutationCreateFolderTeamshipV2Args = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
  teamId: Scalars['ID'];
};

export type MutationCreateIdentityProviderArgs = {
  accountId: Scalars['Int'];
  input: IdentityProviderInput;
};

export type MutationCreateIntegrationReviewFeedbackItemArgs = {
  input: CreateIntegrationReviewFeedbackItemInput;
};

export type MutationCreateInvitationsArgs = {
  accountId: Scalars['Int'];
  emails: Array<Scalars['String']>;
  role?: InputMaybe<MemberRole>;
};

export type MutationCreateNewFreeAccountArgs = {
  currentAccountId: Scalars['ID'];
};

export type MutationCreateOnboardingArgs = {
  intent?: InputMaybe<OnboardingIntent>;
  intentDetail?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OnboardingStatus>;
};

export type MutationCreateOrUpdatePartnerProfileArgs = {
  data: PartnerProfileInput;
  secret?: InputMaybe<Scalars['String']>;
};

export type MutationCreateSetupIntentArgs = {
  accountId: Scalars['Int'];
  processor?: InputMaybe<PaymentSourceBackend>;
};

export type MutationCreateTeamArgs = {
  accountId: Scalars['Int'];
  data: TeamInput;
};

export type MutationDeleteAppRestrictionArgs = {
  accountId: Scalars['Int'];
  id: Scalars['ID'];
};

export type MutationDeleteAppRestrictionMembershipArgs = {
  accountId: Scalars['Int'];
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};

export type MutationDeleteAppRestrictionTeamshipArgs = {
  accountId: Scalars['Int'];
  id: Scalars['ID'];
  teamId: Scalars['ID'];
};

export type MutationDeleteAuthenticationArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteAuthMembershipArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};

export type MutationDeleteAuthTeamshipArgs = {
  id: Scalars['ID'];
  teamId: Scalars['ID'];
};

export type MutationDeleteDomainRequestArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationDeleteFolderMembershipV2Args = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
  memberId: Scalars['ID'];
};

export type MutationDeleteFolderTeamshipV2Args = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
  teamId: Scalars['ID'];
};

export type MutationDeleteFolderV2Args = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationDeleteIdentityProviderArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationDeleteInvitationArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationDeleteMemberArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationDeleteOAuthArgs = {
  id: Scalars['ID'];
};

export type MutationDeletePlatformDeployKeyArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteTasksArgs = {
  accountId: Scalars['Int'];
  filters: TaskFilter;
  taskIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type MutationDeleteTeamArgs = {
  accountId: Scalars['Int'];
  id: Scalars['ID'];
};

export type MutationDeleteTeamMemberArgs = {
  accountId: Scalars['Int'];
  id: Scalars['ID'];
  teamId: Scalars['ID'];
};

export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
  input: DeleteUserInput;
};

export type MutationDeleteZapArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteZapsArgs = {
  ids: Array<Scalars['ID']>;
};

export type MutationDenyTeamRequestArgs = {
  accountId: Scalars['Int'];
  data: TeamMemberInput;
  teamId: Scalars['ID'];
};

export type MutationDisable2FaArgs = {
  code: Scalars['String'];
  id: Scalars['ID'];
};

export type MutationDisconnectSsoIdentityArgs = {
  identityId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type MutationDomainMembersExportArgs = {
  accountId: Scalars['Int'];
  domainId: Scalars['Int'];
};

export type MutationDownloadTasksArgs = {
  accountId: Scalars['Int'];
  filters: TaskFilter;
  taskIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type MutationExtendAccountTrialArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
  shouldAutoUpgrade?: InputMaybe<Scalars['Boolean']>;
};

export type MutationHelpDocs_CreateFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  negativeReason?: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
  type: HelpDocs_DocumentType;
};

export type MutationHelpDocs_PostFeedbackArgs = {
  comment: Scalars['String'];
  id: Scalars['String'];
  type: HelpDocs_DocumentType;
};

export type MutationHelpDocs_PostRatingArgs = {
  id: Scalars['String'];
  rating: Scalars['Int'];
  type: HelpDocs_DocumentType;
};

export type MutationHelpDocs_UpdateFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  negativeReason?: InputMaybe<Scalars['String']>;
};

export type MutationInternal_AddUserAliasArgs = {
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type MutationInviteExpertArgs = {
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type MutationJoinAccountArgs = {
  accountId: Scalars['Int'];
};

export type MutationMoveZapArgs = {
  folderId: Scalars['ID'];
  id: Scalars['ID'];
};

export type MutationNotifyMembersArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationPauseZapArgs = {
  id: Scalars['ID'];
};

export type MutationPersistedModalCreateArgs = {
  modal_data?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type MutationPersistedModalDismissArgs = {
  name: Scalars['String'];
};

export type MutationPolicyAgreementArgs = {
  content: Scalars['Int'];
  slug: Scalars['String'];
};

export type MutationRefreshProvisionTokenArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationRegenerate2FaRecoveryCodesArgs = {
  auth: TwoFactorAuthInput;
};

export type MutationRemoveIntegrationReviewFeedbackItemArgs = {
  id: Scalars['ID'];
};

export type MutationRenameZapArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type MutationRenewDomainRequestArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationReplayTaskArgs = {
  accountId: Scalars['Int'];
  taskId: Scalars['ID'];
};

export type MutationReplayTasksArgs = {
  accountId: Scalars['Int'];
  filters: TaskFilter;
  taskIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type MutationRequestAccessArgs = {
  accountId: Scalars['Int'];
};

export type MutationRequestJoinTeamArgs = {
  accountId: Scalars['Int'];
  teamId: Scalars['ID'];
};

export type MutationResendInvitationArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationResendInvitationV2Args = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationRunZapArgs = {
  id: Scalars['ID'];
};

export type MutationSaveBankPaymentSourceArgs = {
  accountId: Scalars['Int'];
  data: BankInput;
};

export type MutationSaveCardPaymentSourceArgs = {
  accountId: Scalars['Int'];
  data: CardInput;
};

export type MutationSaveCommentArgs = {
  input: SaveCommentInput;
};

export type MutationSavePaypalPaymentSourceArgs = {
  accountId: Scalars['Int'];
  data: PaypalInput;
};

export type MutationSavePlatformIssueCommentArgs = {
  input: SavePlatformCommentInput;
};

export type MutationSendConfirmationEmailArgs = {
  id: Scalars['ID'];
};

export type MutationSendSuccessArgs = {
  name: Scalars['String'];
  weights?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type MutationSetAuthIsSharedArgs = {
  id: Scalars['ID'];
  isShared?: InputMaybe<Scalars['Boolean']>;
};

export type MutationSetAutoUpgradeArgs = {
  input: AutoTaskTierUpdateInput;
};

export type MutationSetCompanyInitialEngagementArgs = {
  companyInitialEngagement: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type MutationSetHasSeenJobsCtaArgs = {
  hasSeenCta: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type MutationSetTeamAutoUpgradeArgs = {
  id: Scalars['Int'];
  shouldAutoUpgrade: Scalars['Boolean'];
};

export type MutationSetZapDescriptionArgs = {
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type MutationSetZapTimezoneArgs = {
  id: Scalars['ID'];
  timezone: Scalars['String'];
};

export type MutationTestAuthArgs = {
  id: Scalars['ID'];
};

export type MutationTestAuthsArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  myAuths?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  selectedApi?: InputMaybe<Scalars['String']>;
  serviceSlug?: InputMaybe<Scalars['String']>;
};

export type MutationText2FaVerificationCodeArgs = {
  auth: TwoFactorAuthInput;
  code: Scalars['String'];
};

export type MutationToggleProvisionArgs = {
  accountId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isEnabled: Scalars['Boolean'];
};

export type MutationTransferAuthArgs = {
  customuserId: Scalars['ID'];
  id: Scalars['ID'];
};

export type MutationTransferZapArgs = {
  id: Scalars['ID'];
  ownerId: Scalars['ID'];
};

export type MutationTrialOnboardingSurveyArgs = {
  accountId: Scalars['Int'];
  input: TrialOnboardingSurvey;
};

export type MutationUnpauseZapArgs = {
  id: Scalars['ID'];
};

export type MutationUnsubscribeFromAllArgs = {
  input?: InputMaybe<SubscriptionInput>;
};

export type MutationUpdateAccessPolicyArgs = {
  data: AccessPolicyInput;
};

export type MutationUpdateAccountArgs = {
  id: Scalars['Int'];
  input: AccountInput;
};

export type MutationUpdateAuthTitleArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type MutationUpdateFolderV2Args = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
  input: FolderInput;
};

export type MutationUpdateIdentityProviderArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
  input: IdentityProviderInput;
};

export type MutationUpdateIntegrationNotificationSettingsArgs = {
  input: UpdatePlatformNotificationSettingsInput;
  integrationId: Scalars['ID'];
};

export type MutationUpdateIntegrationPublishingInfoArgs = {
  input?: InputMaybe<UpdatePublishingInfoInput>;
};

export type MutationUpdateIntegrationReviewArgs = {
  input: UpdateReviewInput;
};

export type MutationUpdateIntegrationReviewFeedbackItemArgs = {
  input: UpdateIntegrationReviewFeedbackItemInput;
};

export type MutationUpdateInvoiceInfoArgs = {
  id: Scalars['Int'];
  input: InvoiceInfoInput;
};

export type MutationUpdateMemberRoleArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
  role: MemberRole;
};

export type MutationUpdateNotificationSettingsArgs = {
  id: Scalars['ID'];
  input: NotificationSettingsInput;
};

export type MutationUpdateOnboardingArgs = {
  id: Scalars['ID'];
  intent?: InputMaybe<OnboardingIntent>;
  intentDetail?: InputMaybe<Scalars['String']>;
  status: OnboardingStatus;
};

export type MutationUpdatePlatformIssueStatusArgs = {
  input: UpdateIssueStatusInput;
};

export type MutationUpdateRecommendationProfileArgs = {
  id: Scalars['ID'];
  input: RecommendationProfileInput;
};

export type MutationUpdateSubscriptionArgs = {
  input?: InputMaybe<SubscriptionInput>;
};

export type MutationUpdateTeamArgs = {
  accountId: Scalars['Int'];
  data: TeamInput;
  id: Scalars['ID'];
};

export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  input: UserV2Input;
};

export type MutationUpdateUserPasswordArgs = {
  id: Scalars['ID'];
  input: PasswordInput;
};

export type MutationUpdateZapArgs = {
  id?: InputMaybe<Scalars['Int']>;
  zap: ZapInput;
};

export type MutationUserStartDataDeleteArgs = {
  id: Scalars['ID'];
};

export type MutationUserStartDataExportArgs = {
  id: Scalars['ID'];
};

export type MutationVerify2FaRecoveryCodeArgs = {
  auth: TwoFactorAuthInput;
  code: Scalars['String'];
};

export type AcceptOfferInput = {
  acceptedAt: Scalars['String'];
  accountId: Scalars['ID'];
  offerId: Scalars['ID'];
  targetPlanId?: InputMaybe<Scalars['ID']>;
  variant: OfferVariantInput;
};

export type OfferVariantInput = {
  campaign: OfferCampaignInput;
  destinationPlan?: InputMaybe<OfferPlanInput>;
  id: Scalars['ID'];
  isControl: Scalars['Boolean'];
  monthlyCost: Scalars['Int'];
  name: Scalars['String'];
  promotionPlanGroup?: InputMaybe<OfferPlanGroupInput>;
  terms?: InputMaybe<Scalars['String']>;
  totalCost: Scalars['Int'];
};

export type OfferCampaignInput = {
  id: Scalars['ID'];
  maxUses: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type OfferPlanInput = {
  amount: Scalars['Int'];
  displayShortName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  interval: Scalars['String'];
  name: Scalars['String'];
};

export type OfferPlanGroupInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TeamMemberInput = {
  id: Scalars['ID'];
};

export type BulkAddTeamMemberResults = {
  __typename?: 'BulkAddTeamMemberResults';
  /**
   * Team Members that were added to the Team
   * (email associated with existing Account Member)
   */
  addedToTeam: Array<TeamMember>;
  /**
   * Email addresses that could not be added or invited
   * (invalid email address)
   */
  errors: Array<InvitationError>;
  /**
   * Account / Team invitations that were sent out
   * (email not associated with existing Account Member)
   */
  invited: Array<Invitation>;
};

export type InvitationError = {
  __typename?: 'InvitationError';
  /** Email string that caused error */
  email: Scalars['String'];
  /** Error Message */
  message: Scalars['String'];
};

export type ChangeAccountPlanInput = {
  /** The selected currency at time of plan change */
  currency?: InputMaybe<Scalars['String']>;
  /**
   * If a downgrade, the reason for downgrading and any comments
   * This will be forwarded to the churn inbox
   */
  downgradeReason?: InputMaybe<Scalars['JSON']>;
  /** The UTC datetime the plan was changed */
  invoiced_at?: InputMaybe<Scalars['String']>;
  /** The ID of the plan the account is attempting to switch to */
  planId: Scalars['ID'];
};

export type DomainRequest = {
  __typename?: 'DomainRequest';
  /** Account Id for the request */
  accountId: Scalars['Int'];
  /** Challenge text to be entered into DNS settings */
  code: Scalars['String'];
  /** Domain to be verified */
  domain: Scalars['String'];
  /** Date request will expire */
  expiry: Scalars['String'];
  id: Scalars['Int'];
  /** Date request was last attempted to be verified */
  lastVerificationAttempt?: Maybe<Scalars['String']>;
  /** Domain request status code */
  status: DomainRequestStatus;
};

export type SurveyResponseInput = {
  /** Free form comment from the user */
  comment?: InputMaybe<Scalars['String']>;
  /** One of the many reasons the user is exiting the plan instead of upgrading */
  exitReason?: InputMaybe<Scalars['String']>;
  /** What type of trial is the user responding to? Company or Team */
  trialType: Scalars['String'];
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  /** Free form comment from the user */
  comment?: Maybe<Scalars['String']>;
  /** One of the many reasons the user is exiting the plan instead of upgrading */
  exitReason?: Maybe<Scalars['String']>;
  /** What type of trial is the user responding to? Company or Team */
  trialType: Scalars['String'];
};

export type AppRequestInput = {
  /** Why we need to add this app in Zapier.com */
  comment: Scalars['String'];
  /** Where does the user work? */
  company: Scalars['String'];
  /** User's email */
  email: Scalars['String'];
  /** User's first name */
  firstName: Scalars['String'];
  /** Whether we can use their name and company publicly. Default (when not supplied) is False. */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** User's last name */
  lastName: Scalars['String'];
};

export type AppRequestSummary = {
  __typename?: 'AppRequestSummary';
  comment: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  photo_url?: Maybe<Scalars['String']>;
};

export type AppRestrictionInput = {
  appSlug: Scalars['String'];
};

export type DomainRequestInput = {
  /** Domain to be verified */
  domain: Scalars['String'];
};

export type EmailSubscriptionInput = {
  channel: Scalars['String'];
  email: Scalars['String'];
};

export type EmailSubscription = {
  __typename?: 'EmailSubscription';
  channel: Scalars['String'];
  email: Scalars['String'];
};

export type CreateFolderInput = {
  accountId: Scalars['Int'];
  isShared?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type IdentityProviderInput = {
  certificate?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  idpSloUrl?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  signedSlo?: InputMaybe<Scalars['Boolean']>;
  sloSigAlg?: InputMaybe<Scalars['String']>;
  ssoUrl?: InputMaybe<Scalars['String']>;
};

export type CreateIntegrationReviewFeedbackItemInput = {
  body: Scalars['String'];
  isBlocking: Scalars['Boolean'];
  reviewId: Scalars['ID'];
  title: Scalars['String'];
  type: IntegrationReviewFeedbackItemType;
};

export type InvitationResults = {
  __typename?: 'InvitationResults';
  error: Array<InvitationError>;
  success: Array<Invitation>;
};

/** Partner Profile information for the current user */
export type PartnerProfileInput = {
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** All memberships for this user */
  memberships?: InputMaybe<Array<PartnerProfileMembershipInput>>;
  /** All roles for this user */
  roles?: InputMaybe<Array<PartnerProfileRoleInput>>;
  /** Has the user accepted the ToS? */
  tosAgreement?: InputMaybe<Scalars['Boolean']>;
};

/** Partner Profile memberships information. */
export type PartnerProfileMembershipInput = {
  app: MembershipAppInput;
  /** Is the user subscribed to this integration? */
  optedIn: Scalars['Boolean'];
  type: MembershipSubscriptionOptions;
};

/**
 * Application membership.
 * All the information related to an app that a user might be subscribed (or not)
 */
export type MembershipAppInput = {
  id: Scalars['Int'];
  /** Membership app image */
  image: Scalars['String'];
  /** Is this app in beta? */
  isBeta: Scalars['Boolean'];
  /** Is this app public? */
  isPublic: Scalars['Boolean'];
  /** App slug. eg. 'mailchimp', 'wb-app-1234' */
  slug?: InputMaybe<Scalars['String']>;
  /** App's name. eg. 'My wonderful app' */
  title: Scalars['String'];
  type: MembershipAppTypes;
};

/** Role that a user plays in a particular integration */
export type PartnerProfileRoleInput = {
  checked: Scalars['Boolean'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type SetupIntent = {
  __typename?: 'SetupIntent';
  clientSecret: Scalars['String'];
  processor: PaymentSourceBackend;
  setupIntentId: Scalars['String'];
};

export type TeamInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  members: Array<Scalars['ID']>;
  name: Scalars['String'];
  newOwnerId?: InputMaybe<Scalars['ID']>;
};

export type DeletePlatformDeployKeyResult = {
  __typename?: 'DeletePlatformDeployKeyResult';
  status?: Maybe<Scalars['String']>;
};

export type TaskFilter = {
  app?: InputMaybe<Scalars['String']>;
  customuserId?: InputMaybe<Scalars['ID']>;
  folderId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  periodEnd?: InputMaybe<Scalars['String']>;
  periodStart?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  rootId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type TaskActionResult = {
  __typename?: 'TaskActionResult';
  channel: Scalars['ID'];
  errors?: Maybe<Scalars['JSON']>;
  globalFailures?: Maybe<Scalars['JSON']>;
  globalFailureType?: Maybe<GlobalFailureStatus>;
  isMassActionsDisabled: Scalars['Boolean'];
  pending: Scalars['Int'];
};

export enum GlobalFailureStatus {
  MassReplayDown = 'mass_replay_down',
  PaymentIssue = 'payment_issue',
  PlanLimit = 'plan_limit',
}

export type DeleteUserInput = {
  /** Token from reauthentication */
  authToken: Scalars['String'];
  /** Should be 'DELETE' from the user confirming */
  confirmDelete: Scalars['String'];
  /** User's email address */
  email: Scalars['String'];
};

export type DownloadTasksResult = {
  __typename?: 'DownloadTasksResult';
  /** Message about the outcome of the request */
  message?: Maybe<Scalars['String']>;
};

/** All possible document types. */
export enum HelpDocs_DocumentType {
  Faq = 'faq',
  Generic = 'generic',
  Reference = 'reference',
  Troubleshooting = 'troubleshooting',
  Tutorial = 'tutorial',
}

/** Feedback as returned by helpDocs_postFeedback, helpDocs_createFeedback and helpDocs_updateFeedback. */
export type HelpDocs_Feedback = {
  __typename?: 'HelpDocs_Feedback';
  id: Scalars['ID'];
};

/** Rating as returned by helpDocs_postRating. */
export type HelpDocs_Rating = {
  __typename?: 'HelpDocs_Rating';
  id: Scalars['ID'];
};

export type InviteExpertResponse = {
  __typename?: 'InviteExpertResponse';
  /** Was the mutation successful? */
  success?: Maybe<Scalars['Boolean']>;
};

export type PolicyAgreement = {
  __typename?: 'PolicyAgreement';
  agreedAt: Scalars['String'];
  content: Scalars['Int'];
  user: Scalars['Int'];
};

export type TwoFactorAuthInput = {
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  qrCodeUrl?: InputMaybe<Scalars['String']>;
  recoveryCodes: Array<Scalars['String']>;
  recoveryPhoneNumber?: InputMaybe<Scalars['String']>;
};

export type TaskReplayStatus = {
  __typename?: 'TaskReplayStatus';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type BankInput = {
  details: BankInputDetails;
  method: Scalars['String'];
  paymentProcessor?: InputMaybe<PaymentSourceBackend>;
  token: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type BankInputDetails = {
  address_city: Scalars['String'];
  address_country: Scalars['String'];
  address_state: Scalars['String'];
  address_zip: Scalars['String'];
};

export type CardInput = {
  details: CardInputDetails;
  method?: InputMaybe<Scalars['String']>;
  paymentProcessor?: InputMaybe<PaymentSourceBackend>;
  setupIntentId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type CardInputDetails = {
  address_city?: InputMaybe<Scalars['String']>;
  address_country?: InputMaybe<Scalars['String']>;
  address_state?: InputMaybe<Scalars['String']>;
  address_zip?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  exp_month?: InputMaybe<Scalars['Int']>;
  exp_year?: InputMaybe<Scalars['Int']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last4?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  object?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type SaveCommentInput = {
  appId: Scalars['ID'];
  body?: InputMaybe<Scalars['String']>;
  commentId?: InputMaybe<Scalars['Int']>;
  isPublic: Scalars['Boolean'];
  issueId: Scalars['Int'];
};

export type PaypalInput = {
  addressCountry?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<PayPalInputDetails>;
  email?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<Scalars['String']>;
  paymentProcessor?: InputMaybe<PaymentSourceBackend>;
  token: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type PayPalInputDetails = {
  addressCountry?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export type SavePlatformCommentInput = {
  body?: InputMaybe<Scalars['String']>;
  commentId?: InputMaybe<Scalars['Int']>;
  integrationId: Scalars['ID'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  issueId: Scalars['Int'];
};

export type AutoTaskTierUpdateInput = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
  isEnrolled: Scalars['Boolean'];
  upgradePlanId?: InputMaybe<Scalars['ID']>;
};

export type TestAuthResponse = {
  __typename?: 'TestAuthResponse';
  errors: Array<Maybe<Scalars['JSON']>>;
  id: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type TrialOnboardingSurvey = {
  companyName: Scalars['String'];
  companySize?: InputMaybe<Scalars['String']>;
  purchasingRole?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  trialReason?: InputMaybe<Scalars['String']>;
  type: OnboardingSurveyType;
};

export enum OnboardingSurveyType {
  Company = 'Company',
  Team = 'Team',
}

export type SubscriptionInput = {
  _id: Scalars['String'];
  subscribed: Scalars['Boolean'];
};

export type AccessPolicyInput = {
  /** Level of access policy allows */
  accessLevel: AccessPolicyLevel;
  /** Account Id */
  accountId: Scalars['Int'];
  /** Id is not required since this is an upsert */
  id?: InputMaybe<Scalars['Int']>;
  /**
   * True if email is required to be verified before requesting
   * access to the account
   */
  isEmailVerificationRequired: Scalars['Boolean'];
};

export type AccountInput = {
  companiesTrialAutoUpgrade?: InputMaybe<Scalars['Boolean']>;
  dataRetentionDays?: InputMaybe<Scalars['Int']>;
  isAutoReplayEnabled?: InputMaybe<Scalars['Boolean']>;
  logoChoice?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** The Stripe payment intent ID */
  paymentIntentId?: InputMaybe<Scalars['String']>;
  /** True to enable auto-upgrade at the end of a Professional trial */
  trialAutoUpgrade?: InputMaybe<Scalars['Boolean']>;
};

export type FolderInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  isShared?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePlatformNotificationSettingsInput = {
  ccContact?: InputMaybe<NotificationsCcContactInput>;
  shouldNotify?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationsCcContactInput = {
  email: Scalars['String'];
};

export type UpdatePublishingInfoInput = {
  form: IntegrationPublishingInfoInput;
  implementationId: Scalars['ID'];
  integrationId: Scalars['ID'];
};

export type IntegrationPublishingInfoInput = {
  apiDocsUrl: Scalars['String'];
  expectedResponseTime: Scalars['String'];
  homepageUrl: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  marketingContactEmail: Scalars['String'];
  paidApi: PartnerApiPaymentType;
  primaryColor: Scalars['String'];
  secondaryColor: Scalars['String'];
  technicalContactEmail: Scalars['String'];
  testAccountNotes: Scalars['String'];
  testAccountPassword: Scalars['String'];
  testAccountUsername: Scalars['String'];
  twitterUsername: Scalars['String'];
};

export type UpdatePublishingInfoPayload = {
  __typename?: 'UpdatePublishingInfoPayload';
  info?: Maybe<IntegrationPublishingInfo>;
};

export type UpdateReviewInput = {
  consistencyKey?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  serviceId?: InputMaybe<Scalars['ID']>;
  status: IntegrationReviewStatus;
};

export type UpdateIntegrationReviewFeedbackItemInput = {
  body: Scalars['String'];
  id: Scalars['ID'];
  isBlocking: Scalars['Boolean'];
  title: Scalars['String'];
  type: IntegrationReviewFeedbackItemType;
};

export type InvoiceInfoInput = {
  companyAddress: Scalars['String'];
  companyName: Scalars['String'];
  id: Scalars['ID'];
  invoiceEmail: Scalars['String'];
  sendInvoiceEmail: Scalars['Boolean'];
};

export type NotificationSettingsInput = {
  alertActions?: InputMaybe<AlertTriggersAction>;
  alertTriggers?: InputMaybe<AlertTriggersAction>;
  summarySchedule?: InputMaybe<SummarySchedule>;
};

export type UpdateIssueStatusInput = {
  integrationId: Scalars['ID'];
  issueId: Scalars['ID'];
  status: Scalars['Int'];
};

export type RecommendationProfileInput = {
  organizationName?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
};

export type UserV2Input = {
  firstName?: InputMaybe<Scalars['String']>;
  isSslCheckDisabled?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
  timezoneId?: InputMaybe<Scalars['String']>;
};

export type PasswordInput = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  newPassword1: Scalars['String'];
};

export type ZapInput = {
  folderIds: Array<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lastchanged: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export enum ChangePlanType {
  Change = 'change',
  Downgrade = 'downgrade',
  Upgrade = 'upgrade',
}

/** A connection in the graph. */
export type Connection = {
  /** Edges. */
  edges: Array<Node>;
  /** Information about a page of results. */
  pageInfo: ConnectionPageInfo;
  /** The total number of results. */
  totalCount: Scalars['Int'];
};

/** A node in the graph." */
export type Node = {
  /** The unique identifier of the node. */
  id: Scalars['ID'];
};

/** Information about a set of results in a cursor connection. */
export type ConnectionPageInfo = {
  /** Opaque cursor of the last item returned (null for an empty result set). */
  endCursor?: Maybe<Scalars['String']>;
  /** Is there another page after this one? */
  hasNextPage: Scalars['Boolean'];
  /** Is there a previous page before this one? */
  hasPreviousPage: Scalars['Boolean'];
  /** Opaque cursor of the first item returned (null for an empty result set). */
  startCursor?: Maybe<Scalars['String']>;
};

/** A connection edge. */
export type ConnectionEdge = {
  /** An opaque cursor for this node. */
  cursor: Scalars['String'];
  /** A node. */
  node: Node;
};

export type FunctionSchema = {
  __typename?: 'FunctionSchema';
  source: Scalars['String'];
};

/** Reference content, as returned by the helpDocs_Content query. */
export type HelpDocs_Reference = HelpDocs_Content & {
  __typename?: 'HelpDocs_Reference';
  canonicalPath: Scalars['String'];
  category?: Maybe<HelpDocs_Category>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  introductionAst: Scalars['HTMLAST'];
  lastUpdated: Scalars['String'];
  published: Scalars['Boolean'];
  slug: Scalars['String'];
  steps: Array<HelpDocs_ReferenceStep>;
  suggested: HelpDocs_Suggested;
  title: Scalars['String'];
  type: HelpDocs_ContentType;
};

/** Step, as used in HelpDocs_Reference. */
export type HelpDocs_ReferenceStep = {
  __typename?: 'HelpDocs_ReferenceStep';
  /** Unique ID */
  _id?: Maybe<Scalars['ID']>;
  bodyAst: Scalars['HTMLAST'];
  canonicalPath: Scalars['String'];
  slug: Scalars['String'];
  steps: Array<HelpDocs_ReferenceStep>;
  title: Scalars['String'];
};

/** Troubleshooting content, as returned by the helpDocs_Content query. */
export type HelpDocs_Troubleshooting = HelpDocs_Content & {
  __typename?: 'HelpDocs_Troubleshooting';
  canonicalPath: Scalars['String'];
  category?: Maybe<HelpDocs_Category>;
  conclusionAst: Scalars['HTMLAST'];
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  introductionAst: Scalars['HTMLAST'];
  lastUpdated: Scalars['String'];
  published: Scalars['Boolean'];
  slug: Scalars['String'];
  steps: Array<HelpDocs_InstructionStep>;
  suggested: HelpDocs_Suggested;
  title: Scalars['String'];
  type: HelpDocs_ContentType;
};

export type PopularTemplatesQueryVariables = Exact<{
  roleCanonicalId?: InputMaybe<Scalars['String']>;
  personalizeBy: SuggestionPersonalization;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type PopularTemplatesQuery = {
  suggestedZapTemplates: {
    __typename?: 'SuggestedZapTemplateConnection';
    edges: Array<{
      __typename?: 'SuggestedZapTemplate';
      zapTemplate?: {
        __typename?: 'ZapTemplateV2';
        title?: string | null;
        url: string;
        services: Array<{
          __typename?: 'ServiceV2';
          image?: string | null;
          name?: string | null;
        }>;
      } | null;
    }>;
  };
};

export type CreateEmailSubscriptionMutationMutationVariables = Exact<{
  email: Scalars['String'];
  channel: Scalars['String'];
}>;

export type CreateEmailSubscriptionMutationMutation = {
  createEmailSubscription: {
    __typename?: 'EmailSubscription';
    email: string;
    channel: string;
  };
};
